import * as __WEBPACK_EXTERNAL_MODULE_classnames__ from "classnames";
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react_transition_group_0923a755__ from "react-transition-group";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_lodash_noop_227d2eda__ from "lodash/noop";
import * as __WEBPACK_EXTERNAL_MODULE_lodash_omit_d930e0f3__ from "lodash/omit";
import * as __WEBPACK_EXTERNAL_MODULE_react_dom_7dac9eee__ from "react-dom";
import * as __WEBPACK_EXTERNAL_MODULE_bowser__ from "bowser";
import * as __WEBPACK_EXTERNAL_MODULE_lodash_debounce_3540babe__ from "lodash/debounce";
import * as __WEBPACK_EXTERNAL_MODULE_react_router_dom_a27720b7__ from "react-router-dom";
import * as __WEBPACK_EXTERNAL_MODULE_lodash_isEqual_ce045a54__ from "lodash/isEqual";
import * as __WEBPACK_EXTERNAL_MODULE_fastdom__ from "fastdom";
import * as __WEBPACK_EXTERNAL_MODULE_lodash_isFunction_f90b20d6__ from "lodash/isFunction";
import * as __WEBPACK_EXTERNAL_MODULE_lodash_round_5c2fdcd3__ from "lodash/round";
import * as __WEBPACK_EXTERNAL_MODULE_bezier_easing_32289db5__ from "bezier-easing";
import * as __WEBPACK_EXTERNAL_MODULE_nanoid_non_secure_38f76ec4__ from "nanoid/non-secure";
import * as __WEBPACK_EXTERNAL_MODULE_smoothscroll_polyfill_5a6263eb__ from "smoothscroll-polyfill";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/******/ /* webpack/runtime/make namespace object */
/******/ (() => {
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = (exports) => {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/ })();
/******/ 
/************************************************************************/

// NAMESPACE OBJECT: ./src/typography/index.ts
var typography_namespaceObject = {};
__webpack_require__.r(typography_namespaceObject);
__webpack_require__.d(typography_namespaceObject, {
  ArticleColors: () => (ArticleColors),
  ArticleFontWeights: () => (ArticleFontWeights),
  ArticleSizeVariants: () => (ArticleSizeVariants),
  ArticleSizes: () => (ArticleSizes),
  ArticleStyles: () => (ArticleStyles),
  ArticleWeights: () => (ArticleWeights),
  BodyColors: () => (BodyColors),
  BodyFontWeights: () => (BodyFontWeights),
  BodySizeVariants: () => (BodySizeVariants),
  BodySizes: () => (BodySizes),
  BodyStyles: () => (BodyStyles),
  BodyWeights: () => (BodyWeights),
  HeadingColors: () => (HeadingColors),
  HeadingFontWeights: () => (HeadingFontWeights),
  HeadingSizeVariants: () => (HeadingSizeVariants),
  HeadingSizes: () => (HeadingSizes),
  HeadingStyles: () => (HeadingStyles),
  HeadingWeights: () => (HeadingWeights),
  article: () => (article),
  articleStyles: () => (articleStyles),
  body: () => (body),
  bodyStyles: () => (bodyStyles),
  heading: () => (heading),
  headingStyles: () => (headingStyles)
});

;// ./src/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const base = ({});
;// external "classnames"
var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const external_classnames_namespaceObject = x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_classnames__["default"]) });
;// ./src/typography/Typography.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

var Typography = /*#__PURE__*/ function() {
    "use strict";
    function Typography(cssModules, props) {
        _class_call_check(this, Typography);
        _define_property(this, "props", void 0);
        _define_property(this, "cssModules", void 0);
        this.props = props;
        this.cssModules = cssModules;
    }
    _create_class(Typography, [
        {
            key: "className",
            get: function get() {
                return this.toString();
            }
        },
        {
            /**
   * Return a new typography object that merges the current and next typographic
   * properties.
   */ key: "create",
            value: function create(props) {
                return new Typography(this.cssModules, Object.assign({}, this.props, props));
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font color.
   */ key: "color",
            value: function color(nextColor) {
                var change = {
                    color: nextColor
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font size.
   */ key: "size",
            value: function size(nextSize) {
                var change = {
                    size: nextSize
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font weight.
   */ key: "weight",
            value: function weight(nextWeight) {
                var change = {
                    weight: nextWeight
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font style.
   */ key: "fontStyle",
            value: function fontStyle(nextStyle) {
                var change = {
                    fontStyle: nextStyle
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with the
   * font weight of `bold`.
   */ key: "bold",
            value: function bold() {
                return this.weight('bold');
            }
        },
        {
            /**
   * Return a single class name that matches a given typographic property with
   * the class names provided by this object's css modules.
   */ key: "getClassName",
            value: function getClassName(prop, className) {
                if (typeof className === 'undefined') {
                    return;
                }
                return this.cssModules[prop][className];
            }
        },
        {
            /**
   * Return a string value of css class names for the appropriate typographic
   * properties that have been applied to this object.
   */ key: "toString",
            value: function toString() {
                var _this_props = this.props, color = _this_props.color, size = _this_props.size, weight = _this_props.weight, fontStyle = _this_props.fontStyle;
                return external_classnames_namespaceObject["default"].apply(void 0, _to_consumable_array(Object.values(this.cssModules.base)).concat([
                    this.getClassName('colors', color),
                    this.getClassName('sizes', "size-".concat(size !== null && size !== void 0 ? size : 'undefined')),
                    this.getClassName('weights', weight),
                    this.getClassName('fontStyles', fontStyle)
                ]));
            }
        }
    ]);
    return Typography;
}();

;// ./src/typography/body/styles/colors.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const colors = ({"blueberry-2":"HuWVIw","blueberry2":"HuWVIw","carrot-2":"qhaiFZ","carrot2":"qhaiFZ","carrot-3":"phBiB0","carrot3":"phBiB0","charcoal-1":"ABZeDk","charcoal1":"ABZeDk","charcoal-2":"DXtob_","charcoal2":"DXtob_","charcoal-3":"dwonWt","charcoal3":"dwonWt","kale-2":"z6o6vK","kale2":"z6o6vK","white":"MuueZ1"});
;// ./src/typography/body/styles/fontStyles.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const fontStyles = ({"normal":"UTEK_m","italic":"GETg_B"});
;// ./src/typography/body/styles/sizes.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const sizes = ({"size-21":"w5Gigb","size21":"w5Gigb","size-16":"Onrt7M","size16":"Onrt7M","size-12":"tNalHK","size12":"tNalHK","size-1":"JxOyrS","size1":"JxOyrS","size-2":"lPXkrj","size2":"lPXkrj","size-3":"aLJRdI","size3":"aLJRdI"});
;// ./src/typography/body/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_base = ({"family":"MxSV6V"});
;// ./src/typography/body/styles/weights.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const weights = ({"normal":"kP01rb","roman":"wXaB35","bold":"I7NmKh"});
;// ./src/typography/body/styles/index.ts





var bodyStyles = {
    colors: colors,
    fontStyles: fontStyles,
    sizes: sizes,
    base: styles_base,
    weights: weights
};

;// ./src/typography/body/body.ts


/** the available body font sizes */ var BodySizes = [
    21,
    16,
    12
];
/** The available body font weights */ var BodyWeights = [
    'normal',
    'bold'
];
/** The available body font styles */ var BodyStyles = [
    'normal',
    'italic'
];
/** The available body font colors */ var BodyColors = [
    'blueberry-2',
    'carrot-2',
    'carrot-3',
    'charcoal-1',
    'charcoal-2',
    'charcoal-3',
    'kale-2',
    'white'
];
/** The available body font size variant for responsive text */ var BodySizeVariants = [
    '1',
    '2',
    '3'
];
/** The available body font weights for responsive text */ var BodyFontWeights = [
    'roman',
    'bold'
];
var body = new Typography(bodyStyles, {
    weight: 'normal',
    fontStyle: 'normal',
    size: 21
});

;// ./src/typography/body/index.ts



;// ./src/typography/article/styles/colors.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_colors = ({"blueberry-2":"d6M9nV","blueberry2":"d6M9nV","carrot-2":"XpkIT2","carrot2":"XpkIT2","carrot-3":"vP13y2","carrot3":"vP13y2","charcoal-1":"OPgCRp","charcoal1":"OPgCRp","charcoal-2":"d05LjI","charcoal2":"d05LjI","charcoal-3":"RNBOzr","charcoal3":"RNBOzr","kale-2":"yyB0nY","kale2":"yyB0nY","white":"R6uBMJ"});
;// ./src/typography/article/styles/fontStyles.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_fontStyles = ({"normal":"A3cMl9","italic":"ANzMq1"});
;// ./src/typography/article/styles/sizes.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_sizes = ({"size-21":"AVg6vN","size21":"AVg6vN","size-20":"Sd5rey","size20":"Sd5rey","size-16":"tq7_h7","size16":"tq7_h7","size-12":"amNnHC","size12":"amNnHC","size-1":"CxPOhC","size1":"CxPOhC","size-2":"AGszgf","size2":"AGszgf","size-3":"k9E_z2","size3":"k9E_z2"});
;// ./src/typography/article/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const article_styles_base = ({"family":"bOoAdc"});
;// ./src/typography/article/styles/weights.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_weights = ({"normal":"N5P5ZN","roman":"T2_JNo","bold":"zQwdZ5"});
;// ./src/typography/article/styles/index.ts





var articleStyles = {
    colors: styles_colors,
    fontStyles: styles_fontStyles,
    sizes: styles_sizes,
    base: article_styles_base,
    weights: styles_weights
};

;// ./src/typography/article/article.ts


/** The available article font sizes */ var ArticleSizes = [
    21,
    20,
    16,
    12
];
/** The available article font weights */ var ArticleWeights = [
    'normal',
    'bold'
];
/** The available article font styles */ var ArticleStyles = [
    'normal',
    'italic'
];
/** The available article font colors */ var ArticleColors = [
    'blueberry-2',
    'carrot-2',
    'carrot-3',
    'charcoal-1',
    'charcoal-2',
    'charcoal-3',
    'kale-2',
    'white'
];
/** The available article font size variant for responsive text */ var ArticleSizeVariants = [
    '1',
    '2',
    '3'
];
/** The available article font weights for responsive text */ var ArticleFontWeights = [
    'roman',
    'bold'
];
var article = new Typography(articleStyles, {
    weight: 'normal',
    fontStyle: 'normal',
    size: 16
});

;// ./src/typography/article/index.ts



;// ./src/typography/heading/styles/colors.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_colors = ({"blueberry-3":"kM5rLm","blueberry3":"kM5rLm","carrot-2":"HrxLrb","carrot2":"HrxLrb","carrot-3":"C1t5Gc","carrot3":"C1t5Gc","charcoal-1":"QItEqX","charcoal1":"QItEqX","charcoal-2":"iA7Qcq","charcoal2":"iA7Qcq","charcoal-3":"U67HrC","charcoal3":"U67HrC","kale-2":"aiLAmA","kale2":"aiLAmA","kale-3":"Pz8Jc_","kale3":"Pz8Jc_","white":"osMXBi"});
;// ./src/typography/heading/styles/fontStyles.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_fontStyles = ({"normal":"PGDFMa"});
;// ./src/typography/heading/styles/sizes.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_sizes = ({"size-72":"W67vY7","size72":"W67vY7","size-52":"eLbOpQ","size52":"eLbOpQ","size-40":"FUn009","size40":"FUn009","size-28":"tlQtaU","size28":"tlQtaU","size-22":"LnfUW7","size22":"LnfUW7","size-21":"ZWoR2o","size21":"ZWoR2o","size-16":"zPijcF","size16":"zPijcF","size-12":"Dbzq1C","size12":"Dbzq1C","size-1":"kPVMWW","size1":"kPVMWW","size-2":"SsjmnA","size2":"SsjmnA","size-3":"vhBtdN","size3":"vhBtdN","size-4":"bOqAXY","size4":"bOqAXY","size-5":"DCqlf1","size5":"DCqlf1"});
;// ./src/typography/heading/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_base = ({"family":"TNu9xA"});
;// ./src/typography/heading/styles/weights.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_weights = ({"normal":"pKjc9p","bold":"U70TRS","black":"jjdzq5","dynamicBold":"m_li4Y"});
;// ./src/typography/heading/styles/index.ts





var headingStyles = {
    colors: heading_styles_colors,
    fontStyles: heading_styles_fontStyles,
    sizes: heading_styles_sizes,
    base: heading_styles_base,
    weights: heading_styles_weights
};

;// ./src/typography/heading/heading.ts


/** The available heading font sizes */ var HeadingSizes = [
    72,
    52,
    40,
    28,
    22,
    21,
    16,
    12
];
/** The available heading font weights */ var HeadingWeights = [
    'normal',
    'bold'
];
/** The available heading font styles */ var HeadingStyles = [
    'normal'
];
/** The available heading font colors */ var HeadingColors = [
    'blueberry-3',
    'carrot-2',
    'carrot-3',
    'charcoal-1',
    'charcoal-2',
    'charcoal-3',
    'kale-2',
    'kale-3',
    'white'
];
/** The available heading font size variant for responsive text */ var HeadingSizeVariants = [
    '1',
    '2',
    '3',
    '4',
    '5'
];
var HeadingFontWeights = [
    'black'
];
var heading = new Typography(headingStyles, {
    weight: 'normal',
    fontStyle: 'normal'
});

;// ./src/typography/heading/index.ts



;// ./src/typography/index.ts




;// ./src/styles/button.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_button = ({"button":"qdKc3_"});
;// ./src/designs/getButtonDesign/getButtonDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getButtonDesign = ({"button":"Mv3epP","primary":"JjeNJn","secondary":"dhXnmw","mini":"T7AUyd","pill":"PWWto6","hover":"CGootV","active":"s5x0pS","disabled":"GuwyyR"});
;// ./src/designs/getButtonDesign/getButtonDesign.ts
function getButtonDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




/** All of the possible design variants available for the button design */ var ButtonVariants = [
    'primary',
    'secondary'
];
var typography = heading.create({
    size: 16,
    weight: 'bold'
});
/**
 * Return a class name the applies the button design based on the button design
 * props interface.
 */ function getButtonDesign_getButtonDesign(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'primary' : _param_variant, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_active = param.active, active = _param_active === void 0 ? false : _param_active, _param_hover = param.hover, hover = _param_hover === void 0 ? false : _param_hover, _param_asPill = param.asPill, asPill = _param_asPill === void 0 ? false : _param_asPill, _param_asMini = param.asMini, asMini = _param_asMini === void 0 ? false : _param_asMini;
    var _obj;
    return (0,external_classnames_namespaceObject["default"])(getButtonDesign.button, styles_button.button, typography.className, (_obj = {}, getButtonDesign_define_property(_obj, getButtonDesign[variant], variant), getButtonDesign_define_property(_obj, getButtonDesign.disabled, disabled), getButtonDesign_define_property(_obj, getButtonDesign.active, active), getButtonDesign_define_property(_obj, getButtonDesign.hover, hover), getButtonDesign_define_property(_obj, getButtonDesign.pill, asPill), getButtonDesign_define_property(_obj, getButtonDesign.mini, asMini), _obj));
}

;// ./src/designs/getButtonDesign/index.ts


;// ./src/designs/getCheckboxDesign/getCheckboxDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getCheckboxDesign = ({"checkbox":"de4Npi","checked":"vYzOUT","disabled":"PaIfeJ","focus":"TxMWDn"});
;// ./src/designs/getCheckboxDesign/getCheckboxDesign.ts
function getCheckboxDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Return a class name the applies the checkbox design based on the checkbox design
 * props interface.
 */ function getCheckboxDesign_getCheckboxDesign(param) {
    var _param_checked = param.checked, checked = _param_checked === void 0 ? false : _param_checked, state = param.state;
    return (0,external_classnames_namespaceObject["default"])(getCheckboxDesign.checkbox, getCheckboxDesign[state], getCheckboxDesign_define_property({}, getCheckboxDesign.checked, checked));
}

;// ./src/designs/getCheckboxDesign/index.ts


;// ./src/designs/getLineThroughDesign/getLineThroughDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getLineThroughDesign = ({"line":"U4nhWs","first":"YxNBei","last":"dLZ9V3"});
;// ./src/designs/getLineThroughDesign/getLineThroughDesign.ts
function getLineThroughDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Return a class name the applies the line through design based on the line through design
 * props interface.
 */ function getLineThroughDesign_getLineThroughDesign() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_first = _ref.first, first = _ref_first === void 0 ? false : _ref_first, _ref_last = _ref.last, last = _ref_last === void 0 ? false : _ref_last;
    var _obj;
    return (0,external_classnames_namespaceObject["default"])(getLineThroughDesign.line, (_obj = {}, getLineThroughDesign_define_property(_obj, getLineThroughDesign.first, first), getLineThroughDesign_define_property(_obj, getLineThroughDesign.last, last), _obj));
}

;// ./src/designs/getLineThroughDesign/index.ts


;// ./src/designs/getLinkDesign/getLinkDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getLinkDesign = ({"link":"PLkTbL","primary":"ALo_z_","dark":"zX05h4","light":"IrduX9","high-contrast":"Ynvno7","highContrast":"Ynvno7","secondary":"BRERcz","tertiary":"oUnK5K","disabled":"upgeWx","hover":"wmVaBj","active":"IUAK3H"});
;// ./src/designs/getLinkDesign/getLinkDesign.ts
function getLinkDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/** All of the possible contrast modes available for the link design */ var LinkModes = [
    'light',
    'dark'
];
/** All of the possible design variants available for the link design */ var LinkVariants = [
    'primary',
    'secondary',
    'tertiary'
];
/**
 * Return a class name the applies the link design based on the link design
 * props interface.
 */ function getLinkDesign_getLinkDesign(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'primary' : _param_variant, _param_mode = param.mode, mode = _param_mode === void 0 ? 'light' : _param_mode, _param_highContrast = param.highContrast, highContrast = _param_highContrast === void 0 ? false : _param_highContrast, disabled = param.disabled, active = param.active, hover = param.hover;
    var _obj;
    return (0,external_classnames_namespaceObject["default"])(getLinkDesign.link, getLinkDesign[variant], getLinkDesign[mode], (_obj = {}, getLinkDesign_define_property(_obj, getLinkDesign.active, active), getLinkDesign_define_property(_obj, getLinkDesign.hover, hover), getLinkDesign_define_property(_obj, getLinkDesign.disabled, disabled), getLinkDesign_define_property(_obj, getLinkDesign.highContrast, highContrast), _obj));
}

;// ./src/designs/getLinkDesign/index.ts


;// ./src/designs/getModalDesign/getModalDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getModalDesign = ({"modal":"wJ7ne0","non-wave":"weSLiE","nonWave":"weSLiE","wave-section":"nOGnz2","waveSection":"nOGnz2","below-wave-section":"Gmrww8","belowWaveSection":"Gmrww8"});
;// ./src/designs/getModalDesign/getModalDesign.ts


/**
 * Return a class name the applies the modal design.
 */ function getModalDesign_getModalDesign() {
    return (0,external_classnames_namespaceObject["default"])(getModalDesign.modal);
}
/**
 * Return a class name that applies the non-wave design to the modal content.
 */ function getNonWaveDesign() {
    return (0,external_classnames_namespaceObject["default"])(getModalDesign.nonWave);
}
/**
 * Return object with class names for the sections of the wave design modal.
 */ function getWaveDesign() {
    return {
        waveSectionDesign: (0,external_classnames_namespaceObject["default"])(getModalDesign.waveSection),
        belowWaveSectionDesign: (0,external_classnames_namespaceObject["default"])(getModalDesign.belowWaveSection)
    };
}

;// ./src/designs/getModalDesign/index.ts


;// ./src/designs/getRadioDesign/getRadioDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getRadioDesign = ({"radio":"eRkNTG","checked":"LeJH8R","disabled":"ilz48F","focus":"ZyZxNH"});
;// ./src/designs/getRadioDesign/getRadioDesign.ts
function getRadioDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Return a class name the applies the radio design based on the radio design
 * props interface.
 */ function getRadioDesign_getRadioDesign(param) {
    var state = param.state, checked = param.checked;
    return (0,external_classnames_namespaceObject["default"])(getRadioDesign.radio, getRadioDesign[state], getRadioDesign_define_property({}, getRadioDesign.checked, checked));
}

;// ./src/designs/getRadioDesign/index.ts


;// ./src/designs/index.ts







;// external "react/jsx-runtime"
var jsx_runtime_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var jsx_runtime_y = (x) => (() => (x))
const jsx_runtime_namespaceObject = jsx_runtime_x({ ["Fragment"]: () => (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.Fragment), ["jsx"]: () => (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsx), ["jsxs"]: () => (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsxs) });
;// external "react-transition-group"
var external_react_transition_group_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_react_transition_group_y = (x) => (() => (x))
const external_react_transition_group_namespaceObject = external_react_transition_group_x({ ["CSSTransition"]: () => (__WEBPACK_EXTERNAL_MODULE_react_transition_group_0923a755__.CSSTransition), ["Transition"]: () => (__WEBPACK_EXTERNAL_MODULE_react_transition_group_0923a755__.Transition), ["TransitionGroup"]: () => (__WEBPACK_EXTERNAL_MODULE_react_transition_group_0923a755__.TransitionGroup) });
;// ./src/components/BorderLabel/BorderLabel.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const BorderLabel = ({"container":"FIJWu3","label":"MgASHM","normal":"DRlP_9","focus":"a9IHEz","invalid":"lTDcYH","disabled":"mdVruo","highlighted":"cC0zAR"});
;// ./src/components/BorderLabel/Text.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Text = ({"text":"WNyRfS","normal":"UDipXU","exited":"WIEMS8","exiting":"vZ_G9L","entered":"vkkPbD","entering":"GLrouC","focus":"sXNNDh","invalid":"uGPg8W","disabled":"H0o0OA"});
;// ./src/styles/accessibility.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const accessibility = ({"hidden":"EQwwNX"});
;// ./src/components/AccessibleContent/AccessibleContent.tsx


/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/accessiblecontent | AccessibleContent} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ function AccessibleContent(param) {
    var visualContent = param.visualContent, accessibleText = param.accessibleText;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                "aria-hidden": "true",
                children: visualContent
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                className: accessibility.hidden,
                children: accessibleText
            })
        ]
    });
}

;// ./src/components/BorderLabel/BorderLabel.tsx
function BorderLabel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BorderLabel_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var ANIMATION_DURATION = 200;
var BorderLabel_typography = heading.create({
    size: 16
});
/**
 * An animated label that serves as both a WCAG compliant element label as well
 * as a placholder. The animations occur based on the different states of the
 * element.
 *
 * In adherence of best WCAG practices we put the interface element inside of
 * the label.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/fieldlabel | FieldLabel} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var BorderLabel_BorderLabel = function(_param) {
    var state = _param.state, children = _param.children, text = _param.text, show = _param.in, className = _param.className, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = _object_without_properties(_param, [
        "state",
        "children",
        "text",
        "in",
        "className",
        "hideLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_transition_group_namespaceObject.Transition, {
        in: show,
        timeout: ANIMATION_DURATION,
        children: function(transitionState) {
            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: (0,external_classnames_namespaceObject["default"])(BorderLabel.container, className),
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("label", _object_spread_props(_object_spread({}, props), {
                    className: (0,external_classnames_namespaceObject["default"])(BorderLabel.label, BorderLabel[state]),
                    children: [
                        children,
                        hideLabel && show ? /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(AccessibleContent, {
                            visualContent: '',
                            accessibleText: text
                        }) : /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                            className: (0,external_classnames_namespaceObject["default"])(Text.text, Text[transitionState], Text[state], BorderLabel_typography.className),
                            children: text
                        })
                    ]
                }))
            });
        }
    });
};

;// external "react"
var external_react_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_react_y = (x) => (() => (x))
const external_react_namespaceObject = external_react_x({ ["Children"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.Children), ["cloneElement"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.cloneElement), ["createContext"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.createContext), ["createElement"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.createElement), ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_react__["default"]), ["forwardRef"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.forwardRef), ["isValidElement"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.isValidElement), ["useCallback"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useCallback), ["useContext"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useContext), ["useEffect"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useEffect), ["useId"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useId), ["useLayoutEffect"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect), ["useMemo"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useMemo), ["useRef"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useRef), ["useState"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useState) });
;// ./src/components/BorderLabel/useElementState.ts
function useElementState_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useElementState_array_without_holes(arr) {
    if (Array.isArray(arr)) return useElementState_array_like_to_array(arr);
}
function useElementState_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useElementState_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || useElementState_unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function useElementState_to_consumable_array(arr) {
    return useElementState_array_without_holes(arr) || useElementState_iterable_to_array(arr) || useElementState_unsupported_iterable_to_array(arr) || useElementState_non_iterable_spread();
}
function useElementState_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useElementState_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useElementState_array_like_to_array(o, minLen);
}

/** An array of all possible states that an element can have */ var ElementStates = [
    'invalid',
    'disabled',
    'focus',
    'highlighted',
    'normal'
];
/**
 * Return a single string of the highest priority state given an array of
 * currently active states.
 */ function getState(states) {
    if (states.includes('disabled')) {
        return 'disabled';
    }
    if (states.includes('invalid')) {
        return 'invalid';
    }
    if (states.includes('focus')) {
        return 'focus';
    }
    if (states.includes('highlighted')) {
        return 'highlighted';
    }
    return 'normal';
}
/**
 * Use interface element states based on props. Return an enum value of the
 * current element state as well as handlers to intercept focus and blur events
 * so that they stay in sync with the element state.
 */ var useElementState = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var invalid = Boolean(props.invalid);
    var disabled = Boolean(props.disabled);
    var autoFocus = Boolean(props.autoFocus);
    var highlighted = Boolean(props.highlighted);
    var _useState = _sliced_to_array((0,external_react_namespaceObject.useState)([]), 2), states = _useState[0], setStates = _useState[1];
    var addState = (0,external_react_namespaceObject.useCallback)(function(nextState) {
        setStates(function(lastStates) {
            return useElementState_to_consumable_array(lastStates).concat([
                nextState
            ]);
        });
    }, []);
    var removeState = (0,external_react_namespaceObject.useCallback)(function(nextState) {
        setStates(function(lastStates) {
            return lastStates.filter(function(state) {
                return state !== nextState;
            });
        });
    }, []);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (invalid) {
            addState('invalid');
        } else {
            removeState('invalid');
        }
    }, [
        addState,
        removeState,
        invalid
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (disabled) {
            addState('disabled');
        } else {
            removeState('disabled');
        }
    }, [
        addState,
        removeState,
        disabled
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (highlighted) {
            addState('highlighted');
        } else {
            removeState('highlighted');
        }
    }, [
        addState,
        removeState,
        highlighted
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (autoFocus) {
            addState('focus');
        } else {
            removeState('focus');
        }
    }, [
        addState,
        removeState,
        autoFocus
    ]);
    var handleFocus = function() {
        addState('focus');
    };
    var handleBlur = function() {
        removeState('focus');
    };
    return [
        getState(states),
        {
            onBlur: handleBlur,
            onFocus: handleFocus
        }
    ];
};

;// ./src/components/BorderLabel/index.ts



;// ./src/components/ActivityIndicator/ActivityIndicator.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ActivityIndicator = ({"container":"BJcT5w","bounce":"saeipN","light":"ydkNDZ"});
;// ./src/components/ActivityIndicator/ActivityIndicator.tsx



var ActivityIndicatorModes = (/* unused pure expression or super */ null && ([
    'light',
    'dark'
]));
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/activityindicator | ActivityIndicator} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var ActivityIndicator_ActivityIndicator = function(param) {
    var _param_mode = param.mode, mode = _param_mode === void 0 ? 'light' : _param_mode;
    var cssClass = (0,external_classnames_namespaceObject["default"])(ActivityIndicator.container, ActivityIndicator[mode]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("span", {
        className: cssClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {})
        ]
    });
};

;// ./src/components/ButtonBase/ButtonBase.tsx
function ButtonBase_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonBase_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonBase_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ButtonBase_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ButtonBase_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ButtonBase_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ButtonBase_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ButtonBase_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ButtonBase_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/**
 * The core component to render a button.  Responsible for managing any
 * accessibility patterns and minimal base button styles.
 *
 * This component is "private" to CORGI and should not be exported.
 */ var ButtonBase = function(_param) {
    var _param_type = _param.type, type = _param_type === void 0 ? 'button' : _param_type, disabled = _param.disabled, props = ButtonBase_object_without_properties(_param, [
        "type",
        "disabled"
    ]);
    if (disabled) {
        props['aria-disabled'] = true;
    }
    var handleClickSuppression = function(event) {
        event.preventDefault();
        return;
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", ButtonBase_object_spread_props(ButtonBase_object_spread({}, props), {
        type: type,
        className: (0,external_classnames_namespaceObject["default"])(styles_button.button, props.className),
        /* for accessibility purposes, disable click events if disabled or loading; otherwise use props */ onClick: disabled ? handleClickSuppression : props.onClick,
        children: props.children
    }));
};

;// ./src/components/Button/Button.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Button = ({"button":"br1fCW","as-link":"a6QHfN","asLink":"a6QHfN","loading":"mlU8zd","indicator":"_FURd4"});
;// ./src/components/Button/Button.tsx
function Button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Button_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Button_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Button_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Button_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Button_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Button_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Button_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






/**
 * Extends native button element
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/button | Button} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Button_Button = function(_param) {
    var _param_loading = _param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_asLink = _param.asLink, asLink = _param_asLink === void 0 ? false : _param_asLink, highContrast = _param.highContrast, variant = _param.variant, disabled = _param.disabled, active = _param.active, hover = _param.hover, asPill = _param.asPill, asMini = _param.asMini, mode = _param.mode, className = _param.className, children = _param.children, props = Button_object_without_properties(_param, [
        "loading",
        "asLink",
        "highContrast",
        "variant",
        "disabled",
        "active",
        "hover",
        "asPill",
        "asMini",
        "mode",
        "className",
        "children"
    ]);
    var elementClass = !asLink ? Button.button : Button.asLink;
    var designClass = !asLink ? getButtonDesign_getButtonDesign({
        variant: variant !== 'tertiary' ? variant : undefined,
        disabled: disabled && !loading,
        active: active,
        hover: hover,
        asPill: asPill,
        asMini: asMini
    }) : getLinkDesign_getLinkDesign({
        variant: variant,
        disabled: disabled,
        active: active,
        hover: hover,
        mode: mode,
        highContrast: highContrast
    });
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(ButtonBase, Button_object_spread_props(Button_object_spread({
        "aria-busy": loading,
        disabled: disabled || loading
    }, props), {
        className: (0,external_classnames_namespaceObject["default"])(elementClass, designClass, className, Button_define_property({}, Button.loading, loading && !asLink)),
        children: [
            children,
            loading && !asLink && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                className: Button.indicator,
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ActivityIndicator_ActivityIndicator, {
                    mode: variant !== 'secondary' ? 'light' : 'dark'
                })
            })
        ]
    }));
};

;// ./src/components/Button/index.ts


;// ./src/util/withRef.tsx
function withRef_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withRef_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withRef_define_property(target, key, source[key]);
        });
    }
    return target;
}
function withRef_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function withRef_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        withRef_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/**
 * Add a prop named `forwardedRef` to the component props. This is useful for
 * exposing the inner HTML element to the consumer of a component and makes it
 * easier to deal with the complications from using `forwardRef` in typescript.
 *
 * @deprecated Don't use this. Use the `forwardRef` function from React and make explicit the ref forwarding explicit in the code.
 */ var withRef = function(Wrapped) {
    return /*#__PURE__*/ (0,external_react_namespaceObject.forwardRef)(function(props, forwardedRef) {
        return /*#__PURE__*/ (0,external_react_namespaceObject.createElement)(Wrapped, withRef_object_spread_props(withRef_object_spread({}, props), {
            forwardedRef: forwardedRef
        }));
    });
};

;// ./src/util/interceptEvent.ts
/** No arguments */ function interceptEvent_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function interceptEvent_array_without_holes(arr) {
    if (Array.isArray(arr)) return interceptEvent_array_like_to_array(arr);
}
function interceptEvent_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function interceptEvent_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function interceptEvent_to_consumable_array(arr) {
    return interceptEvent_array_without_holes(arr) || interceptEvent_iterable_to_array(arr) || interceptEvent_unsupported_iterable_to_array(arr) || interceptEvent_non_iterable_spread();
}
function interceptEvent_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return interceptEvent_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return interceptEvent_array_like_to_array(o, minLen);
}
/**
 * Return an event handler that will run multiple events in the order that they
 * are passed as arguments.
 */ function interceptEvent() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handlers.forEach(function(handler) {
            if (handler) {
                handler.apply(void 0, interceptEvent_to_consumable_array(args));
            }
        });
    };
}

;// ./src/components/Selector/Selector.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Selector = ({"container":"jU74az"});
;// ./src/components/Selector/Selector.tsx
function Selector_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Selector_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Selector_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Selector_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Selector_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Selector_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Selector_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Selector_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Selector_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Selector_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Selector_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Selector_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Selector_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Selector_sliced_to_array(arr, i) {
    return Selector_array_with_holes(arr) || Selector_iterable_to_array_limit(arr, i) || Selector_unsupported_iterable_to_array(arr, i) || Selector_non_iterable_rest();
}
function Selector_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Selector_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Selector_array_like_to_array(o, minLen);
}







/** Valid input types that can be a selector */ var Types = [
    'radio',
    'checkbox'
];
/**
 * Component used to create a custom radio or checkbox element following a11y rules.
 * Children can be any react element and will be passed the prop "state" which holds a value from
 * useElementState.
 *
 * All props not defined will be passed into the `input` element except for the className which is passed to
 * the containing `label` element.
 *
 * @deprecated Do not use this component. Use Checkbox or RadioButton from corgi-x, or implement your own state.
 */ var Selector_Selector = withRef(function(_param) {
    var className = _param.className, onFocus = _param.onFocus, onBlur = _param.onBlur, children = _param.children, labelProps = _param.labelProps, forwardedRef = _param.forwardedRef, props = Selector_object_without_properties(_param, [
        "className",
        "onFocus",
        "onBlur",
        "children",
        "labelProps",
        "forwardedRef"
    ]);
    var _useElementState = Selector_sliced_to_array(useElementState(props), 2), state = _useElementState[0], handlers = _useElementState[1];
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("label", Selector_object_spread_props(Selector_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(Selector.container, className)
    }, labelProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("input", Selector_object_spread({
                ref: forwardedRef,
                className: (0,external_classnames_namespaceObject["default"])(accessibility.hidden),
                onFocus: interceptEvent(handlers.onFocus, onFocus),
                onBlur: interceptEvent(handlers.onBlur, onBlur),
                "data-checked": props.checked
            }, props)),
            typeof children === 'function' ? children(state) : external_react_namespaceObject.Children.map(children, function(child) {
                if (!/*#__PURE__*/ external_react_namespaceObject.isValidElement(child)) {
                    return child;
                }
                return /*#__PURE__*/ external_react_namespaceObject.cloneElement(child, {
                    // @ts-ignore
                    state: state
                });
            })
        ]
    }));
});

;// ./src/icons/svg/arrow.svg
function arrow_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function arrow_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            arrow_define_property(target, key, source[key]);
        });
    }
    return target;
}
function arrow_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function arrow_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        arrow_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgArrow = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", arrow_object_spread_props(arrow_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 20"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M11.03 19.53a.75.75 0 00.073-.976l-.073-.084-8.467-8.468 8.467-8.469a.75.75 0 00.073-.976L11.03.472A.75.75 0 0010.054.4L9.97.473.972 9.471a.75.75 0 00-.072.977l.072.084L9.97 19.53a.749.749 0 001.06 0z",
            fillRule: "nonzero"
        })
    }));
};
/* harmony default export */ const arrow = (SvgArrow);

;// ./src/icons/svg/back.svg
function back_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function back_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            back_define_property(target, key, source[key]);
        });
    }
    return target;
}
function back_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function back_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        back_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgBack = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", back_object_spread_props(back_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 44 44"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M43.9995864,21.987712 C43.9995864,22.5399968 43.5518711,22.987712 42.9995864,22.987712 L3.41378635,22.987712 L15.7067864,35.280712 C15.9667429,35.5317864 16.070999,35.90359 15.9794835,36.2532194 C15.8879682,36.6028488 15.6149232,36.8758938 15.2652937,36.9674092 C14.9156644,37.0589246 14.543861,36.9546686 14.2927864,36.694712 L0.29278635,22.694712 C-0.09759545,22.3042122 -0.09759545,21.6712118 0.29278635,21.280712 L14.2927864,7.28071203 C14.6851654,6.90173983 15.3088712,6.90715963 15.6946049,7.29289343 C16.0803388,7.67862723 16.0857586,8.30233323 15.7067864,8.69471203 L3.41378635,20.987712 L42.9997864,20.987712 C43.5519929,20.9878224 43.9995864,21.4355054 43.9995864,21.987712 Z"
        })
    }));
};
/* harmony default export */ const back = (SvgBack);

;// ./src/icons/svg/blob.svg
function blob_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function blob_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            blob_define_property(target, key, source[key]);
        });
    }
    return target;
}
function blob_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function blob_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        blob_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgBlob = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", blob_object_spread_props(blob_object_spread({
        viewBox: "0 0 464 422",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M462.672,182.35 C462.66,182.187 462.64,182.025 462.624,181.862 C462.124,176.862 461.788,171.833 461.073,166.871 C460.461,162.671 459.815,158.545 459.765,159.206 C456.851,141.914 451.065,124.837 443.865,108.838 C437.729,95.207 430.203,82.089 420.445,70.855 C414.592,64.118 407.994,58.12 401.415,52.141 C398.463,49.459 395.51,46.776 392.462,44.214 C381.055048,34.62104 368.292799,26.7668296 354.589,20.906 C352.038,19.818 349.446,18.769 346.838,17.739 C345.974,17.227 345.118,16.713 344.29,16.192 C341.965,14.729 336.264,12.902 336.264,12.902 C336.264,12.902 328.422,10.134 325.42,9.534 C323.926,9.234 321.698,8.842 319.02,8.4 C314.925333,7.286 310.832,6.3 306.74,5.442 C299.86,4.009 292.912,3.027 285.956,2.242 C274.832667,0.992 263.689333,0.250666667 252.526,0.018 C242.1,-0.2 232.76,1.6 222.553,3.281 C205.677326,6.05294848 188.993225,9.88622025 172.6,14.758 C163.703535,17.3627365 154.994731,20.5701531 146.534,24.358 C136.834,28.758 128.913,34.989 118.852,38.842 C94,48.355 75.719,65.663 55.934,82.924 C47.146,90.591 38.234,98.393 31.388,108.03 C24.247,118.082 19.06,129.95 14.024,141.281 C3.142,165.765 1.1,196.228 0.165,223.149 C0.075,225.735 0.233,229.911 0.089,231.568 C0.557,237.803 -0.197,234.635 0.052,238.694 C-0.078,239.924 0.24,244.23 0.573,248.378 C0.973,253.001 1.224,256.289 0.896,254.946 C1.467,260.323 1.806,263.691 1.903,264.971 C2.409,269.302 2.978,273.827 3.157,275.155 C3.35766398,277.163476 3.66442586,279.159931 4.076,281.136 C4.149,281.101 4.954,286.249 5.827,291.611 C7.01,299.294 7.044,298.098 7.086,296.662 C7.352,296.9 8.068,300.211 8.872,303.882 C9.464,305.958 10.065,307.812 10.932,311.341 C17.127,325.923 22.069,339.906 31.508,352.886 C40.7737394,365.695216 52.3567955,376.655534 65.658,385.2 C69.536,387.669 73.537,389.912 77.537,392.154 C80.6952294,394.032139 83.9925174,395.665906 87.4,397.041 C93,399.131 98.949,399.746 104.735,401.088 C119.435,404.499 133.196,412.677 148.185,414.516 C164.908,416.567 181.821,418.141 198.602,419.916 C225.297,422.734 250.841,420.902 277.244,418.035 C287.169,416.958 296.944,414.482 306.564,411.866 C316.153,409.258 326.047,407.836 335.526,404.65 C346.088,401.101 355.998,395.956 366.018,391.15 C374.695,386.985 382.444,382.639 389.436,375.9 C394.279606,371.106141 398.783815,365.9811 402.916,360.562 C406.955,355.409 411.522,350.814 415.487,345.577 C417.513,342.901 419.523,339.994 421.514,336.924 C421.552,336.994 421.584,337.07 421.624,337.139 C426.079,329.322 430.905,322.591 435.606,315.009 C440.353,307.352 442.339,298.773 445.27,290.309 C448.27,281.634 452.27,272.96 455.27,264.286 C458.186,255.859 460.606,228.1 461.805,219.38 C461.905,218.641 461.898,218.256 461.798,218.158 C463.135483,206.270495 463.427937,194.288601 462.672,182.35 L462.672,182.35 Z",
            fillRule: "nonzero"
        })
    }));
};
/* harmony default export */ const blob = (SvgBlob);

;// ./src/icons/svg/bolt.svg
function bolt_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bolt_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bolt_define_property(target, key, source[key]);
        });
    }
    return target;
}
function bolt_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bolt_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bolt_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgBolt = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", bolt_object_spread_props(bolt_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "nonzero",
            d: "M13.255 9.19H7.759c.136-.648.276-1.3.412-1.948.328-1.544.656-3.088.98-4.632.136-.652.276-1.3.412-1.952C9.61.426 9.535.194 9.327.07c-.248-.148-.548-.052-.7.188-.316.496-.632.988-.952 1.484l-2.24 3.5L2.819 9.33c-.692 1.084-1.388 2.168-2.08 3.252-.22.348-.444.692-.664 1.04-.216.336.068.784.44.784H6.003c-.136.652-.276 1.3-.412 1.952-.328 1.544-.656 3.092-.98 4.636-.136.636-.272 1.276-.404 1.912a.52.52 0 0 0 .04.428c.004.008.008.016.016.024.012.016.02.032.032.048a.48.48 0 0 0 .044.048.106.106 0 0 1 .02.024.284.284 0 0 0 .056.04c.008.004.012.008.016.012.004 0 .004.004.008.004.02.012.04.02.064.028.012.004.024.012.036.012.008 0 .012.004.016.008.016.004.032.004.044.008.012 0 .024.004.032.004a.194.194 0 0 0 .068 0h.028a.509.509 0 0 0 .424-.292c.308-.48.616-.964.928-1.448.748-1.168 1.496-2.336 2.244-3.5.872-1.364 1.748-2.728 2.62-4.088.696-1.084 1.388-2.168 2.084-3.252.22-.348.444-.692.664-1.04.22-.336-.064-.784-.436-.784zm-3.636 5.244c-.872 1.364-1.748 2.728-2.62 4.088-.408.636-.816 1.272-1.224 1.912.316-1.488.632-2.976.944-4.464.14-.652.276-1.3.412-1.952.068-.328-.148-.66-.492-.66H1.463l.448-.7 2.24-3.5L6.767 5.07c.408-.636.812-1.272 1.22-1.908-.316 1.488-.628 2.972-.944 4.46-.136.652-.276 1.3-.412 1.952-.068.328.148.66.492.66h5.184l-.448.7a4745.65 4745.65 0 0 1-2.24 3.5z"
        })
    }));
};
/* harmony default export */ const bolt = (SvgBolt);

;// ./src/icons/svg/bowl-steaming.svg
function bowl_steaming_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bowl_steaming_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bowl_steaming_define_property(target, key, source[key]);
        });
    }
    return target;
}
function bowl_steaming_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bowl_steaming_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bowl_steaming_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgBowlSteaming = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", bowl_steaming_object_spread_props(bowl_steaming_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                                fillRule: "nonzero",
                                d: "M10 7.832c-.029-.594-.34-1.14-.838-1.466C8.453 5.852 8.024 5.038 8 4.163c.024-.874.453-1.687 1.162-2.2.497-.326.809-.87.838-1.463 0-.276.224-.5.5-.5s.5.224.5.5c-.024.874-.454 1.688-1.163 2.2-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466.709.514 1.138 1.328 1.162 2.203-.024.875-.453 1.69-1.162 2.203-.497.326-.809.87-.838 1.465 0 .276-.224.5-.5.5s-.5-.224-.5-.5c.024-.875.453-1.689 1.162-2.203.498-.326.809-.87.838-1.465zm4.5 0c-.029-.594-.34-1.14-.838-1.466-.709-.514-1.138-1.328-1.162-2.203.024-.874.453-1.687 1.162-2.2.497-.326.809-.87.838-1.463 0-.276.224-.5.5-.5s.5.224.5.5c-.024.874-.454 1.688-1.163 2.2-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466.709.514 1.138 1.328 1.162 2.203-.024.875-.453 1.69-1.162 2.203-.497.326-.809.87-.838 1.465 0 .276-.224.5-.5.5s-.5-.224-.5-.5c.024-.875.453-1.69 1.162-2.203.497-.326.809-.87.838-1.465zm4.5 0c-.029-.594-.34-1.14-.838-1.466-.709-.514-1.138-1.328-1.162-2.203.024-.874.453-1.687 1.162-2.2.497-.326.809-.87.838-1.463 0-.276.224-.5.5-.5s.5.224.5.5c-.024.874-.454 1.688-1.163 2.2-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466.709.514 1.138 1.328 1.162 2.203-.024.875-.453 1.69-1.162 2.203-.497.326-.809.87-.838 1.465 0 .276-.224.5-.5.5s-.5-.224-.5-.5c.024-.875.453-1.69 1.162-2.203.497-.326.809-.87.838-1.465z",
                                transform: "translate(-281 -2549) translate(281 2549) translate(4 4)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                                d: "M10 7.832c-.029-.594-.34-1.14-.838-1.466C8.453 5.852 8.024 5.038 8 4.163c.024-.874.453-1.687 1.162-2.2.497-.326.809-.87.838-1.463 0-.276.224-.5.5-.5s.5.224.5.5c-.024.874-.454 1.688-1.163 2.2-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466.709.514 1.138 1.328 1.162 2.203-.024.875-.453 1.69-1.162 2.203-.497.326-.809.87-.838 1.465 0 .276-.224.5-.5.5s-.5-.224-.5-.5c.024-.875.453-1.689 1.162-2.203.498-.326.809-.87.838-1.465zM14.5 7.832c-.029-.594-.34-1.14-.838-1.466-.709-.514-1.138-1.328-1.162-2.203.024-.874.453-1.687 1.162-2.2.497-.326.809-.87.838-1.463 0-.276.224-.5.5-.5s.5.224.5.5c-.024.874-.454 1.688-1.163 2.2-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466.709.514 1.138 1.328 1.162 2.203-.024.875-.453 1.69-1.162 2.203-.497.326-.809.87-.838 1.465 0 .276-.224.5-.5.5s-.5-.224-.5-.5c.024-.875.453-1.69 1.162-2.203.497-.326.809-.87.838-1.465zM19 7.832c-.029-.594-.34-1.14-.838-1.466-.709-.514-1.138-1.328-1.162-2.203.024-.874.453-1.687 1.162-2.2.497-.326.809-.87.838-1.463 0-.276.224-.5.5-.5s.5.224.5.5c-.024.874-.454 1.688-1.163 2.2-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466.709.514 1.138 1.328 1.162 2.203-.024.875-.453 1.69-1.162 2.203-.497.326-.809.87-.838 1.465 0 .276-.224.5-.5.5s-.5-.224-.5-.5c.024-.875.453-1.69 1.162-2.203.497-.326.809-.87.838-1.465z",
                                transform: "translate(-281 -2549) translate(281 2549) translate(4 4)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                                fillRule: "nonzero",
                                d: "M27.5 15c.276 0 .5.224.5.5s-.224.5-.5.5h-2.58l-.003.077-.846 11c-.04.52-.474.923-.997.923H4.926c-.523 0-.957-.402-.997-.923l-.846-11L3.08 16H.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h27zm-3.58 1H4.079l.847 11h18.148l.307-4H9.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h13.958l.462-6z",
                                transform: "translate(-281 -2549) translate(281 2549) translate(4 4)"
                            })
                        ]
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const bowl_steaming = (SvgBowlSteaming);

;// ./src/icons/svg/calendar.svg
function calendar_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function calendar_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            calendar_define_property(target, key, source[key]);
        });
    }
    return target;
}
function calendar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function calendar_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        calendar_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCalendar = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", calendar_object_spread_props(calendar_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M28 25.958c0 .576-.448 1.042-1 1.042H1c-.552 0-1-.466-1-1.042V3c0-.552.448-1 1-1h5V.5c0-.276.224-.5.5-.5s.5.224.5.5V2h14V.5c0-.276.224-.5.5-.5s.5.224.5.5V2h5c.552 0 1 .448 1 1v22.958zM27 8H1v18h26V8zm-12.5 3c3.038 0 5.5 2.462 5.5 5.5S17.538 22 14.5 22 9 19.538 9 16.5s2.462-5.5 5.5-5.5zm0 1c-2.484.003-4.497 2.016-4.5 4.5 0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5zm0 2c.276 0 .5.224.5.5v2.25l1.8 1.35c.143.107.218.282.196.46-.021.177-.135.33-.3.4-.164.07-.353.047-.496-.06l-2-1.5c-.126-.094-.2-.243-.2-.4v-2.5c0-.276.224-.5.5-.5zM27 3H1v4h26V3z",
                            transform: "translate(-281 -2237) translate(281 2237) translate(4 5)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const calendar = (SvgCalendar);

;// ./src/icons/svg/caret.svg
function caret_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function caret_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            caret_define_property(target, key, source[key]);
        });
    }
    return target;
}
function caret_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function caret_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        caret_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCaret = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", caret_object_spread_props(caret_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M12 0L6 8 0 0z",
                            transform: "translate(-260 -1577) translate(260 1577) translate(12 15)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const caret = (SvgCaret);

;// ./src/icons/svg/carrot.svg
function carrot_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carrot_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carrot_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carrot_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carrot_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carrot_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCarrot = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", carrot_object_spread_props(carrot_object_spread({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            strokeWidth: 1,
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                    d: "M23.9713043,6.25961739 C23.8422255,5.90389177 23.6368246,5.58074241 23.3695304,5.31286957 C22.9211762,4.87916735 22.3449614,4.60154358 21.7263652,4.52118261 C21.6779478,4.51346087 21.6305739,4.51753043 21.5821565,4.51147826 C22.0443388,3.79216313 22.3412082,2.97928265 22.4513739,2.1314087 C22.4736983,1.97101409 22.4195067,1.80943396 22.304987,1.69493481 C22.1904674,1.58043566 22.0288776,1.52627301 21.868487,1.54862609 C21.0206874,1.6588314 20.207864,1.9556217 19.4885217,2.41763478 C19.4826783,2.36932174 19.4867478,2.32215652 19.4788174,2.27373913 C19.3985429,1.65506537 19.1208668,1.07878132 18.6870261,0.630469565 C18.4191877,0.363182841 18.0960739,0.157781918 17.7403826,0.0286956522 C17.573508,-0.0305553478 17.3877072,0.00355915727 17.2527652,0.118226087 C16.4626045,0.802805548 16.1017419,1.85948384 16.3081043,2.88438261 C16.3882061,3.333819 16.5389407,3.76774428 16.754713,4.17005217 C15.1004097,3.48990832 13.1960066,3.96574476 12.0560348,5.34406957 C8.10052174,10.4119304 4.21241739,15.5504348 0.327965217,20.8591304 C-0.196745184,21.6527994 -0.0711254097,22.7094262 0.625043478,23.3579478 L0.661773913,23.3946783 C1.29091359,24.0700087 2.31599487,24.1917122 3.08577391,23.6824696 C8.40876522,19.7868522 13.5762783,15.9088696 18.6565565,11.9436522 C20.0348193,10.8037056 20.5103589,8.89922107 19.8297391,7.24518261 C20.2321663,7.46093609 20.6661914,7.61166862 21.1157217,7.6917913 C22.1405953,7.89808819 23.1972252,7.53728191 23.8818783,6.74723478 C23.9965494,6.61229155 24.0306279,6.42647021 23.9713043,6.25961739 Z M17.6913391,1.16086957 C17.7845896,1.22054364 17.8711104,1.29013113 17.9493913,1.36841739 C18.2255033,1.66286103 18.4004266,2.03774881 18.4486957,2.43850435 C18.496466,2.76591644 18.4969931,3.0984903 18.4502609,3.42605217 C18.2661661,3.69535338 18.1294175,3.99411813 18.045913,4.30946087 C17.6899427,3.84163549 17.4478896,3.29729298 17.3389565,2.71961739 C17.2257414,2.17352651 17.3542315,1.605157 17.6913391,1.16086957 L17.6913391,1.16086957 Z M18.0148174,11.1210783 C13.1765217,14.8973217 8.30003478,18.5736 2.46991304,22.8399652 C2.09598708,23.0423519 1.63094769,22.9498087 1.3629913,22.619687 C1.03554409,22.3320301 0.955098291,21.8539746 1.17036522,21.4749913 C2.5730087,19.5580174 4.1685913,17.5104 5.42932174,15.8089043 L7.03147826,17.4112696 C7.1632813,17.5431099 7.35540832,17.5946193 7.53548691,17.5463947 C7.71556551,17.4981701 7.85623746,17.3575379 7.90451301,17.1774729 C7.95278855,16.997408 7.90133349,16.8052664 7.76953043,16.6734261 L6.07241739,14.9764174 C6.06730435,14.9712 6.0602087,14.9696348 6.05457391,14.9646261 C6.48024348,14.3920348 6.90187826,13.8265739 7.31947826,13.2682435 L7.32688696,13.2793043 L9.0237913,14.976313 C9.22754115,15.1801205 9.55793165,15.1801672 9.76173913,14.9764174 C9.96554661,14.7726675 9.96559333,14.442277 9.76184348,14.2384696 L8.06462609,12.5414609 C8.02524462,12.5053641 7.98046,12.4756485 7.93189565,12.4533913 C8.36222609,11.8798261 8.79165217,11.3106435 9.22017391,10.7458435 L10.4995826,12.0249391 C10.7040678,12.2242779 11.0308139,12.2221844 11.232728,12.0202417 C11.4346421,11.8182991 11.4366894,11.4915526 11.2373217,11.2870957 L9.90907826,9.95895652 C9.88992161,9.94397945 9.86965457,9.93047971 9.84845217,9.91857391 C10.2762087,9.35669565 10.7057391,8.79565217 11.1370435,8.23544348 L11.9751652,9.07356522 C12.1789151,9.27737268 12.5093056,9.27741939 12.713113,9.07366955 C12.9169205,8.8699197 12.9169672,8.53952922 12.7132174,8.33572174 L11.779513,7.40222609 C12.1437913,6.9314087 12.5083826,6.4605913 12.8788174,5.98601739 C13.3867883,5.34525794 14.147656,4.9562592 14.9645217,4.91968696 C16.0341469,4.8710211 17.0735909,5.28174862 17.8210435,6.04841739 L17.8776,6.10455652 L17.9343652,6.16090435 L18.1302261,5.96932174 L18.1365913,5.97589565 L17.9430261,6.16956522 C18.7139504,6.91650432 19.1281917,7.95776696 19.0810435,9.03015652 C19.0460447,9.84891844 18.6568379,10.6120227 18.0146087,11.1210783 L18.0148174,11.1210783 Z M18.9759652,5.02591304 C18.9963275,4.50438398 19.2225923,4.01219229 19.6051826,3.65718261 C20.0710708,3.21809246 20.6397678,2.90303077 21.2590957,2.74090435 C21.0971841,3.36027335 20.7821751,3.92900468 20.3430261,4.39481739 C19.9890222,4.77821403 19.4971816,5.00523473 18.9757565,5.02591304 L18.9759652,5.02591304 Z M21.2806957,6.66146087 C20.7028772,6.55251793 20.1583936,6.31042992 19.6904348,5.9544 C20.0055352,5.87073428 20.3041192,5.73410967 20.5734261,5.55036522 C20.9011007,5.50339382 21.2338267,5.50378038 21.5613913,5.55151304 C21.9621982,5.59978267 22.3371291,5.77474557 22.6315826,6.05092174 C22.709764,6.12916589 22.779279,6.21561356 22.8389217,6.30876522 C22.3948541,6.64600219 21.8265957,6.77461565 21.2805913,6.66146087 L21.2806957,6.66146087 Z"
                })
            })
        })
    }));
};
/* harmony default export */ const carrot = (SvgCarrot);

;// ./src/icons/svg/check-circle.svg
function check_circle_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function check_circle_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            check_circle_define_property(target, key, source[key]);
        });
    }
    return target;
}
function check_circle_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function check_circle_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        check_circle_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCheckCircle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", check_circle_object_spread_props(check_circle_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 120 120"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M74.195 39.993c.631-.67 1.686-.701 2.356-.07.595.561.686 1.457.256 2.12l-.186.236L52.44 67.948c-.553.586-1.432.684-2.093.273l-.236-.179-14.346-12.94c-.683-.617-.738-1.67-.121-2.354.548-.608 1.442-.718 2.113-.302l.24.18 13.13 11.847 23.069-24.48zM107.333 54c0 29.455-23.878 53.333-53.333 53.333S.667 83.455.667 54 24.545.667 54 .667c14.145 0 27.71 5.619 37.712 15.62C101.714 26.29 107.333 39.856 107.333 54zM104 54c0-27.614-22.386-50-50-50S4 26.386 4 54s22.386 50 50 50c27.601-.03 49.97-22.399 50-50z",
                            transform: "translate(-1049 -1883) translate(1049 1883) translate(6 6)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const check_circle = (SvgCheckCircle);

;// ./src/icons/svg/check.svg
function check_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function check_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            check_define_property(target, key, source[key]);
        });
    }
    return target;
}
function check_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function check_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        check_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCheck = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", check_object_spread_props(check_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 12"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "nonzero",
            d: "M4.243 11.186c.257.257.514.385.9.385s.643-.128.9-.385l9-9a1.243 1.243 0 0 0 0-1.8 1.243 1.243 0 0 0-1.8 0l-8.1 8.1-2.957-2.957a1.243 1.243 0 0 0-1.8 0 1.243 1.243 0 0 0 0 1.8l3.857 3.857z"
        })
    }));
};
/* harmony default export */ const check = (SvgCheck);

;// ./src/icons/svg/chevron.svg
function chevron_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function chevron_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            chevron_define_property(target, key, source[key]);
        });
    }
    return target;
}
function chevron_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function chevron_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        chevron_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgChevron = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", chevron_object_spread_props(chevron_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M12.97 27.53c-.267-.266-.29-.683-.073-.976l.073-.084 8.467-8.468-8.467-8.469c-.267-.266-.29-.683-.073-.976l.073-.085c.266-.266.683-.29.976-.072l.084.073 8.998 8.998c.266.266.29.683.072.977l-.072.084-8.998 8.998c-.293.293-.767.293-1.06 0z"
        })
    }));
};
/* harmony default export */ const chevron = (SvgChevron);

;// ./src/icons/svg/circle-alert.svg
function circle_alert_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function circle_alert_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            circle_alert_define_property(target, key, source[key]);
        });
    }
    return target;
}
function circle_alert_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function circle_alert_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        circle_alert_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCircleAlert = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", circle_alert_object_spread_props(circle_alert_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                                d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16c0-4.243-1.686-8.313-4.686-11.314C24.314 1.686 20.244 0 16 0zm0 31C7.716 31 1 24.284 1 16 1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15-.01 8.28-6.72 14.99-15 15zm-.5-22h1v10h-1V9zm0 12.5h1v1h-1v-1z",
                                transform: "translate(-281 -3173) translate(281 3173) matrix(1 0 0 -1 2 34) matrix(1 0 0 -1 0 32)"
                            })
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const circle_alert = (SvgCircleAlert);

;// ./src/icons/svg/circle-cross.svg
function circle_cross_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function circle_cross_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            circle_cross_define_property(target, key, source[key]);
        });
    }
    return target;
}
function circle_cross_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function circle_cross_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        circle_cross_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCircleCross = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", circle_cross_object_spread_props(circle_cross_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M11.044 10.336l4.949 4.95 4.95-4.95c.195-.195.512-.195.707 0 .195.196.195.512 0 .708l-4.95 4.949 4.95 4.95c.195.195.195.512 0 .707-.195.195-.512.195-.707 0l-4.95-4.95-4.95 4.95c-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707l4.95-4.95-4.95-4.95c-.195-.195-.195-.511 0-.707.196-.195.512-.195.708 0zM32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0c4.243 0 8.313 1.686 11.314 4.686 3 3 4.686 7.07 4.686 11.314zm-1 0c0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.28-.01 14.99-6.72 15-15z",
                            transform: "translate(-281 -2081) translate(281 2081) translate(2 2)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const circle_cross = (SvgCircleCross);

;// ./src/icons/svg/circle-fill.svg
function circle_fill_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function circle_fill_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            circle_fill_define_property(target, key, source[key]);
        });
    }
    return target;
}
function circle_fill_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function circle_fill_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        circle_fill_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCircleFill = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", circle_fill_object_spread_props(circle_fill_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2c4.243 0 8.313 1.686 11.314 4.686 3 3 4.686 7.07 4.686 11.314zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5zm-2 0c0-6.904-5.596-12.5-12.5-12.5S5.5 11.096 5.5 18 11.096 30.5 18 30.5c6.9-.008 12.492-5.6 12.5-12.5z"
        })
    }));
};
/* harmony default export */ const circle_fill = (SvgCircleFill);

;// ./src/icons/svg/circle-minus.svg
function circle_minus_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function circle_minus_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            circle_minus_define_property(target, key, source[key]);
        });
    }
    return target;
}
function circle_minus_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function circle_minus_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        circle_minus_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCircleMinus = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", circle_minus_object_spread_props(circle_minus_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2c4.243 0 8.313 1.686 11.314 4.686 3 3 4.686 7.07 4.686 11.314zm-6 0c0 .414-.336.75-.75.75H8.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h18.5c.414 0 .75.336.75.75z"
        })
    }));
};
/* harmony default export */ const circle_minus = (SvgCircleMinus);

;// ./src/icons/svg/circle-plus.svg
function circle_plus_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function circle_plus_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            circle_plus_define_property(target, key, source[key]);
        });
    }
    return target;
}
function circle_plus_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function circle_plus_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        circle_plus_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCirclePlus = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", circle_plus_object_spread_props(circle_plus_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2c4.243 0 8.313 1.686 11.314 4.686 3 3 4.686 7.07 4.686 11.314zM18 8c.414 0 .75.336.75.75v8.5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5v8.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-8.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5v-8.5c0-.414.336-.75.75-.75z"
        })
    }));
};
/* harmony default export */ const circle_plus = (SvgCirclePlus);

;// ./src/icons/svg/circle.svg
function circle_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function circle_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            circle_define_property(target, key, source[key]);
        });
    }
    return target;
}
function circle_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function circle_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        circle_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgCircle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", circle_object_spread_props(circle_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2c4.243 0 8.313 1.686 11.314 4.686 3 3 4.686 7.07 4.686 11.314zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5z"
        })
    }));
};
/* harmony default export */ const circle = (SvgCircle);

;// ./src/icons/svg/clipboard.svg
function clipboard_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clipboard_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clipboard_define_property(target, key, source[key]);
        });
    }
    return target;
}
function clipboard_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function clipboard_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        clipboard_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgClipboard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", clipboard_object_spread_props(clipboard_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M16 0c1.105 0 2 .895 2 2h4c1.105 0 2 .895 2 2v26c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h4c0-1.105.895-2 2-2h8zM6 3H2c-.513 0-.936.386-.993.883L1 4v26c0 .513.386.936.883.993L2 31h20c.513 0 .936-.386.993-.883L23 30V4c0-.513-.386-.936-.883-.993L22 3h-4c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2zm4.266 10.745l.04.087L13.18 21.9l2.114-3.133c.074-.11.189-.185.316-.21l.098-.01H20c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008-4.025-.001-2.52 3.735c-.21.313-.669.282-.846-.029l-.039-.083-2.743-7.703-1.387 3.754c-.062.168-.208.288-.38.319l-.089.008H4c-.276 0-.5-.224-.5-.5 0-.246.177-.45.41-.492l.09-.008 3.623-.001 1.743-4.718c.15-.407.697-.433.9-.082zM16 1H8c-.513 0-.936.386-.993.883L7 2v1c0 .513.386.936.883.993L8 4h8c.513 0 .936-.386.993-.883L17 3V2c0-.513-.386-.936-.883-.993L16 1z",
                            transform: "translate(-281 -2705) translate(281 2705) translate(6 2)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const clipboard = (SvgClipboard);

;// ./src/icons/svg/clock.svg
function clock_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clock_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clock_define_property(target, key, source[key]);
        });
    }
    return target;
}
function clock_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function clock_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        clock_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgClock = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", clock_object_spread_props(clock_object_spread({
        viewBox: "0 0 120 120",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M113.333 60C113.333 89.4552 89.4553 113.333 60.0001 113.333C30.5449 113.333 6.66675 89.4552 6.66675 60C6.66675 30.5448 30.5449 6.66667 60.0001 6.66667C89.4553 6.66667 113.333 30.5448 113.333 60ZM60.0001 10C87.6143 10 110 32.3858 110 60C110 87.6142 87.6143 110 60.0001 110C32.3858 110 10.0001 87.6142 10.0001 60C10.0307 32.3985 32.3985 10.0306 60.0001 10ZM60.0001 28.3305C60.8183 28.3305 61.4988 28.9201 61.6399 29.6976L61.6667 29.9972V59.31L81.2044 78.8284C81.7832 79.4067 81.8479 80.3048 81.3982 80.9545L81.2055 81.1855C80.6272 81.7643 79.7291 81.829 79.0794 81.3793L78.8484 81.1866L58.8221 61.1791C58.5718 60.929 58.4092 60.6075 58.3542 60.2625L58.3334 60V29.9972C58.3334 29.0767 59.0796 28.3305 60.0001 28.3305Z"
        })
    }));
};
/* harmony default export */ const clock = (SvgClock);

;// ./src/icons/svg/close.svg
function close_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function close_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            close_define_property(target, key, source[key]);
        });
    }
    return target;
}
function close_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function close_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        close_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgClose = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", close_object_spread_props(close_object_spread({
        viewBox: "0 0 44 44"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M36.499513,4.60058433 C37.3002921,3.79980522 38.5986366,3.79980522 39.3994157,4.60058433 C40.2001948,5.40136344 40.2001948,6.69970783 39.3994157,7.50048693 L24.8999025,22 L39.3994157,36.499513 C40.2001948,37.3002921 40.2001948,38.5986366 39.3994157,39.3994157 C38.5986366,40.2001948 37.3002921,40.2001948 36.499513,39.3994157 L22,24.8999025 L7.50048693,39.3994157 C6.69970783,40.2001948 5.40136344,40.2001948 4.60058433,39.3994157 C3.79980522,38.5986366 3.79980522,37.3002921 4.60058433,36.499513 L19.1000974,22 L4.60058433,7.50048693 C3.79980522,6.69970783 3.79980522,5.40136344 4.60058433,4.60058433 C5.40136344,3.79980522 6.69970783,3.79980522 7.50048693,4.60058433 L22,19.1000974 L36.499513,4.60058433 Z"
        })
    }));
};
/* harmony default export */ const svg_close = (SvgClose);

;// ./src/icons/svg/doctor.svg
function doctor_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function doctor_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            doctor_define_property(target, key, source[key]);
        });
    }
    return target;
}
function doctor_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function doctor_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        doctor_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgDoctor = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", doctor_object_spread_props(doctor_object_spread({
        viewBox: "0 0 18 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            strokeWidth: 1,
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                    d: "M15.5,13 C14.2156172,12.9987092 13.1392234,13.9708712 13.0101445,15.248752 C12.8810657,16.5266328 13.7413036,17.6944141 15,17.95 L15,19 C15,21.209139 13.209139,23 11,23 C8.790861,23 7,21.209139 7,19 L7,13.9746 C10.3825336,13.7115532 12.9947207,10.8927421 13,7.5 L13,1.5 C12.9991181,0.671938427 12.3280616,0.00088185546 11.5,0 L9.5,0 C9.22385763,0 9,0.223857625 9,0.5 C9,0.776142375 9.22385763,1 9.5,1 L11.5,1 C11.7761424,1 12,1.22385763 12,1.5 L12,7.5 C12,10.5375661 9.53756612,13 6.5,13 C3.46243388,13 1,10.5375661 1,7.5 L1,1.5 C1,1.36739176 1.05267842,1.2402148 1.14644661,1.14644661 C1.2402148,1.05267842 1.36739176,1 1.5,1 L3.5,1 C3.77614237,1 4,0.776142375 4,0.5 C4,0.223857625 3.77614237,0 3.5,0 L1.5,0 C0.671938427,0.00088185546 0.00088185546,0.671938427 0,1.5 L0,7.5 C0.00527933456,10.8927421 2.6174664,13.7115532 6,13.9746 L6,19 C6,21.7614237 8.23857625,24 11,24 C13.7614237,24 16,21.7614237 16,19 L16,17.95 C17.2586964,17.6944141 18.1189343,16.5266328 17.9898555,15.248752 C17.8607766,13.9708712 16.7843828,12.9987092 15.5,13 Z M15.5,17 C14.6715729,17 14,16.3284271 14,15.5 C14,14.6715729 14.6715729,14 15.5,14 C16.3284271,14 17,14.6715729 17,15.5 C16.9991181,16.3280616 16.3280616,16.9991181 15.5,17 L15.5,17 Z"
                })
            })
        })
    }));
};
/* harmony default export */ const doctor = (SvgDoctor);

;// ./src/icons/svg/dog-food.svg
function dog_food_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dog_food_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dog_food_define_property(target, key, source[key]);
        });
    }
    return target;
}
function dog_food_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function dog_food_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        dog_food_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgDogFood = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", dog_food_object_spread_props(dog_food_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 38 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M32.374 9.061a6.28 6.28 0 0 0-3.998-4.678A6.284 6.284 0 0 0 22.5.251a6.183 6.183 0 0 0-3.75 1.27A6.184 6.184 0 0 0 15 .251 6.282 6.282 0 0 0 9.13 4.383a6.288 6.288 0 0 0-4 4.678 3.756 3.756 0 0 0-3.005 2.953l-2.1 10.487A1.252 1.252 0 0 0 1.249 24h35.002a1.25 1.25 0 0 0 1.223-1.5l-2.1-10.487a3.756 3.756 0 0 0-3-2.953zM10.411 6.607c.471-.105.84-.473.945-.947a3.722 3.722 0 0 1 2.726-2.798 3.715 3.715 0 0 1 3.724 1.184c.243.262.586.41.944.41.359 0 .701-.148.945-.41a3.715 3.715 0 0 1 3.724-1.184 3.722 3.722 0 0 1 2.726 2.798c.105.474.473.842.944.947A3.752 3.752 0 0 1 29.782 9H7.718a3.752 3.752 0 0 1 2.693-2.393zM2.775 21.5l1.798-9c.12-.58.632-1 1.228-.998h25.898a1.25 1.25 0 0 1 1.228.998l1.798 9H2.775z"
        })
    }));
};
/* harmony default export */ const dog_food = (SvgDogFood);

;// ./src/icons/svg/facebook.svg
function facebook_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function facebook_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            facebook_define_property(target, key, source[key]);
        });
    }
    return target;
}
function facebook_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function facebook_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        facebook_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgFacebook = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("svg", facebook_object_spread_props(facebook_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                    id: "a",
                    d: "M0.002 0.001L32 0.001 32 31.806 0.002 31.806z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("g", {
                fillRule: "evenodd",
                transform: "translate(2 2)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("mask", {
                        id: "b",
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("use", {
                            xlinkHref: "#a"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                        d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16c0 7.986 5.851 14.605 13.5 15.806V20.625H9.437V16H13.5v-3.525c0-4.01 2.389-6.225 6.043-6.225 1.751 0 3.582.313 3.582.313V10.5h-2.018c-1.987 0-2.607 1.233-2.607 2.499V16h4.438l-.71 4.625H18.5v11.18C26.149 30.606 32 23.987 32 16",
                        mask: "url(#b)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                        d: "M22.228 20.625l.71-4.625H18.5v-3.001c0-1.266.62-2.499 2.607-2.499h2.018V6.562s-1.831-.312-3.582-.312c-3.654 0-6.043 2.215-6.043 6.225V16H9.437v4.625H13.5v11.18c.815.128 1.65.195 2.5.195.85 0 1.685-.067 2.5-.194V20.625h3.728"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ const facebook = (SvgFacebook);

;// ./src/icons/svg/fork-spoon.svg
function fork_spoon_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fork_spoon_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fork_spoon_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fork_spoon_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fork_spoon_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fork_spoon_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgForkSpoon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", fork_spoon_object_spread_props(fork_spoon_object_spread({
        viewBox: "0 0 17 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            strokeWidth: 1,
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                    d: "M6.24,0 C5.97490332,0 5.76,0.21490332 5.76,0.48 L5.76,6.72 L3.84,6.72 L3.84,0.48 C3.84,0.21490332 3.62509668,0 3.36,0 C3.09490332,0 2.88,0.21490332 2.88,0.48 L2.88,6.72 L0.96,6.72 L0.96,0.48 C0.96,0.21490332 0.74509668,0 0.48,0 C0.21490332,0 0,0.21490332 0,0.48 L0,8.64 C0,9.70038672 0.85961328,10.56 1.92,10.56 L2.88,10.56 L2.88,14.488128 C2.30592163,14.689874 1.92129488,15.2315054 1.92,15.84 L1.92,22.56 C1.92,23.35529 2.56470996,24 3.36,24 C4.15529004,24 4.8,23.35529 4.8,22.56 L4.8,15.84 C4.79870512,15.2315054 4.41407837,14.689874 3.84,14.488128 L3.84,10.56 L4.8,10.56 C5.86038672,10.56 6.72,9.70038672 6.72,8.64 L6.72,0.48 C6.72,0.21490332 6.50509668,0 6.24,0 Z M3.84,22.56 C3.84,22.8250967 3.62509668,23.04 3.36,23.04 C3.09490332,23.04 2.88,22.8250967 2.88,22.56 L2.88,15.84 C2.88,15.5749033 3.09490332,15.36 3.36,15.36 C3.62509668,15.36 3.84,15.5749033 3.84,15.84 L3.84,22.56 Z M5.76,8.64 C5.75952365,9.16999592 5.32999592,9.59952365 4.8,9.6 L1.92,9.6 C1.39000408,9.59952365 0.960476354,9.16999592 0.96,8.64 L0.96,7.68 L5.76,7.68 L5.76,8.64 Z M16.32,6.72 C16.32,3.538848 14.815776,0 12.96,0 C11.104224,0 9.6,3.539328 9.6,6.72 C9.6,9.6192 10.853472,11.205216 12.48,11.46624 L12.48,14.488128 C11.9059216,14.689874 11.5212949,15.2315054 11.52,15.84 L11.52,22.56 C11.52,23.35529 12.16471,24 12.96,24 C13.75529,24 14.4,23.35529 14.4,22.56 L14.4,15.84 C14.3987051,15.2315054 14.0140784,14.689874 13.44,14.488128 L13.44,11.46672 C15.066528,11.205696 16.32,9.619776 16.32,6.72 Z M13.44,22.56 C13.44,22.8250967 13.2250967,23.04 12.96,23.04 C12.6949033,23.04 12.48,22.8250967 12.48,22.56 L12.48,15.84 C12.48,15.5749033 12.6949033,15.36 12.96,15.36 C13.2250967,15.36 13.44,15.5749033 13.44,15.84 L13.44,22.56 Z M12.96,10.56 C11.47968,10.56 10.56,9.089088 10.56,6.72 C10.56,3.596064 12.034176,0.96 12.96,0.96 C13.885824,0.96 15.36,3.596544 15.36,6.72 C15.36,9.089088 14.44032,10.56 12.96,10.56 Z"
                })
            })
        })
    }));
};
/* harmony default export */ const fork_spoon = (SvgForkSpoon);

;// ./src/icons/svg/heart-outline.svg
function heart_outline_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function heart_outline_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            heart_outline_define_property(target, key, source[key]);
        });
    }
    return target;
}
function heart_outline_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function heart_outline_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        heart_outline_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgHeartOutline = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", heart_outline_object_spread_props(heart_outline_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 29 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M7.502 0C4.215 0 0 2.89 0 8.561c0 3.19 2.033 6.122 4.689 8.712 2.656 2.589 6.005 4.856 8.955 6.601a.903.903 0 0 0 .919 0c2.95-1.745 6.299-4.012 8.955-6.601 2.656-2.59 4.689-5.522 4.689-8.712 0-5.67-4.215-8.561-7.502-8.561-3.114 0-5.228 1.36-6.601 3.029C12.73 1.36 10.616 0 7.502 0zm0 1.8c3.141 0 4.783 1.436 5.833 3.16a.9.9 0 0 0 1.537 0c1.05-1.724 2.692-3.16 5.833-3.16 2.229 0 5.702 1.973 5.702 6.761 0 2.396-1.657 5.002-4.145 7.427-2.36 2.3-5.398 4.377-8.158 6.039-2.76-1.662-5.798-3.74-8.159-6.039-2.488-2.425-4.144-5.03-4.144-7.427 0-4.788 3.473-6.76 5.701-6.76zM4.2 6.283a.9.9 0 0 0-.881.722c-.54 2.508.888 4.864 2.25 6.226a.902.902 0 0 0 1.313.047.904.904 0 0 0-.038-1.313c-1.038-1.038-2.1-3.008-1.763-4.576a.9.9 0 0 0-.881-1.106z"
        })
    }));
};
/* harmony default export */ const heart_outline = (SvgHeartOutline);

;// ./src/icons/svg/heart.svg
function heart_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function heart_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            heart_define_property(target, key, source[key]);
        });
    }
    return target;
}
function heart_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function heart_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        heart_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgHeart = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", heart_object_spread_props(heart_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 44 44"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M21.8357934,40.7028087 L39.7154936,22.8085958 C44.648195,17.76325 44.8035961,9.75078955 40.0702391,4.51797116 C35.3368821,-0.714847232 27.3490316,-1.36131207 21.8357934,3.04223899 C16.3171841,-1.49912555 8.20107961,-0.889491092 3.42280836,4.42531509 C-1.35546289,9.74012126 -1.10120987,17.8751174 3.99963152,22.8811595 L21.8357934,40.7028087 Z"
        })
    }));
};
/* harmony default export */ const heart = (SvgHeart);

;// ./src/icons/svg/house.svg
function house_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function house_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            house_define_property(target, key, source[key]);
        });
    }
    return target;
}
function house_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function house_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        house_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgHouse = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", house_object_spread_props(house_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M14.284.09l.07.058 13.498 13.498c.195.196.195.512 0 .708-.173.173-.443.192-.638.057l-.069-.057-2.646-2.646.001 14.8c0 .78-.595 1.421-1.356 1.494l-.144.007H5c-.78 0-1.42-.595-1.493-1.356L3.5 26.51V11.712L.858 14.354c-.174.173-.443.192-.638.057l-.07-.057c-.173-.174-.192-.443-.057-.638l.058-.07L13.646.148c.174-.173.443-.192.638-.057zM20 27.009H23c.245 0 .45-.176.492-.41l.008-.09v-15.8L14 1.209l-9.5 9.502v15.798c0 .245.177.45.41.492l.09.008h9V17c0-.552.448-1 1-1h4c.552 0 1 .448 1 1v10.008zM19 17h-4v10h4V17zm-9-1c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1H8c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h2zm0 1H8v2h2v-2z",
                            transform: "translate(-281 -2081) translate(281 2081) translate(4 4)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const house = (SvgHouse);

;// ./src/icons/svg/information.svg
function information_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function information_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            information_define_property(target, key, source[key]);
        });
    }
    return target;
}
function information_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function information_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        information_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgInformation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", information_object_spread_props(information_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16c0 4.243-1.686 8.313-4.686 11.314-3 3-7.07 4.686-11.314 4.686zm0-30.5C9.992 3.5 3.5 9.992 3.5 18S9.992 32.5 18 32.5 32.5 26.008 32.5 18C32.491 9.996 26.004 3.509 18 3.5zM17.25 25h1.5V15h-1.5v10zm0-12.5h1.5V11h-1.5v1.5z"
        })
    }));
};
/* harmony default export */ const information = (SvgInformation);

;// ./src/icons/svg/leaf.svg
function leaf_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function leaf_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            leaf_define_property(target, key, source[key]);
        });
    }
    return target;
}
function leaf_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function leaf_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        leaf_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgLeaf = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", leaf_object_spread_props(leaf_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                        d: "M31.481 4c.3 0 .537.253.518.551C30.843 22.792 21.637 32 4.519 32l-.087-.007c-.258-.044-.448-.275-.43-.544C5.156 13.207 14.363 4 31.481 4zM5.808 30.588l-.227.402c6.613-.165 11.935-1.78 15.977-4.856l-11.42-2.186c-1.556 2.105-2.999 4.319-4.33 6.64zm8.394-20.534c-5.206 4.09-8.233 10.668-9.101 19.76 2.893-4.995 6.302-9.495 10.227-13.498zm-3.396 13.004L22.57 25.31c2.706-2.356 4.77-5.445 6.197-9.27l-8.978-2.554c-3.313 2.884-6.307 6.074-8.983 9.572zM29.948 5.025l-.31.012c-5.906.254-10.75 1.702-14.54 4.352l1.09 6.065c4.057-3.987 8.644-7.463 13.76-10.429zm1.004.577l.293-.166c-3.807 2.143-7.322 4.567-10.545 7.271l8.4 2.388c.947-2.821 1.567-6.02 1.862-9.596l-.01.103z",
                        transform: "translate(-281 -3017) translate(281 3017)"
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const leaf = (SvgLeaf);

;// ./src/icons/svg/lock.svg
function lock_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function lock_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            lock_define_property(target, key, source[key]);
        });
    }
    return target;
}
function lock_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function lock_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        lock_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgLock = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", lock_object_spread_props(lock_object_spread({
        viewBox: "0 0 120 120",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M43.3333 31.6667V53.3334H76.6667V31.6667C76.6667 19.7006 69.2047 10.0001 60 10.0001C50.7953 10.0001 43.3333 19.7006 43.3333 31.6667ZM80 53.3334H98C99.1046 53.3334 100 54.2288 100 55.3334V111.333C100 112.438 99.1046 113.333 98 113.333H22C20.8954 113.333 20 112.438 20 111.333V55.3334C20 54.2288 20.8954 53.3334 22 53.3334H40V30.0001C40 17.1134 48.9543 6.66675 60 6.66675C71.0457 6.66675 80 17.1134 80 30.0001V53.3334ZM69.8974 94.162C70.1005 94.7421 69.9984 95.3797 69.623 95.8759C69.2476 96.3721 68.6446 96.6663 68.0022 96.6667H52.0087C51.3661 96.6667 50.7627 96.3726 50.387 95.8764C50.0113 95.3801 49.9091 94.7422 50.1123 94.162L53.4961 86.7073C50.4549 84.2405 49.2594 80.281 50.4605 76.6535C51.4477 73.5907 54.0121 71.2213 57.2577 70.3735C61.7679 69.1344 66.5754 71.0566 68.8033 74.9898C71.0312 78.923 70.0766 83.8027 66.5108 86.7088L69.8974 94.162Z"
        })
    }));
};
/* harmony default export */ const lock = (SvgLock);

;// ./src/icons/svg/mail.svg
function mail_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mail_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mail_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mail_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mail_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mail_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgMail = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", mail_object_spread_props(mail_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M34 7.92v1.71l-15.021 8.901c-.604.358-1.354.358-1.958 0L2 9.63V7.92C2 6.86 2.86 6 3.92 6h28.16C33.14 6 34 6.86 34 7.92zM18 20.08c-.574 0-1.138-.155-1.631-.449L2 11.117V28.4c0 1.06.86 1.92 1.92 1.92h28.16c1.06 0 1.92-.86 1.92-1.92V11.117L19.631 19.63c-.493.294-1.057.449-1.631.449z"
        })
    }));
};
/* harmony default export */ const mail = (SvgMail);

;// ./src/icons/svg/minus.svg
function minus_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function minus_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            minus_define_property(target, key, source[key]);
        });
    }
    return target;
}
function minus_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function minus_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        minus_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgMinus = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", minus_object_spread_props(minus_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("rect", {
            width: 20,
            height: 1.5,
            y: 0.25,
            fillRule: "evenodd",
            rx: 0.75,
            transform: "translate(8 17)"
        })
    }));
};
/* harmony default export */ const minus = (SvgMinus);

;// ./src/icons/svg/navigation.svg
function navigation_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function navigation_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            navigation_define_property(target, key, source[key]);
        });
    }
    return target;
}
function navigation_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function navigation_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        navigation_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgNavigation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("svg", navigation_object_spread_props(navigation_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("filter", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("feColorMatrix", {
                        in: "SourceGraphic",
                        values: "0 0 0 0 0.082353 0 0 0 0 0.227451 0 0 0 0 0.200000 0 0 0 1.000000 0"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                        fillOpacity: 0,
                        d: "M0 0H36V36H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                        fillOpacity: 0,
                        d: "M0 0H36V36H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        filter: "url(#a)",
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("g", {
                            transform: "translate(6 9)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("rect", {
                                    width: 24,
                                    height: 1.5,
                                    rx: 0.75
                                }),
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("rect", {
                                    width: 24,
                                    height: 1.5,
                                    y: 8,
                                    rx: 0.75
                                }),
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("rect", {
                                    width: 24,
                                    height: 1.5,
                                    y: 16,
                                    rx: 0.75
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ const navigation = (SvgNavigation);

;// ./src/icons/svg/parcel.svg
function parcel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function parcel_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            parcel_define_property(target, key, source[key]);
        });
    }
    return target;
}
function parcel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function parcel_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        parcel_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgParcel = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", parcel_object_spread_props(parcel_object_spread({
        viewBox: "0 0 27 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            strokeWidth: 1,
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                    d: "M25.6428571,4.35428571 L20.6707429,0.377142857 C20.3666614,0.133638384 19.9888776,0.000658480149 19.5993143,0 L6.6864,0 C6.29732651,0.000699155981 5.9200002,0.133377803 5.61611429,0.376342857 L0.642857143,4.35542857 C0.235528772,4.67996246 -0.00122815609,5.17279568 -4.75471524e-06,5.6936 L-4.75471524e-06,22.2857143 C-0.000879833974,22.7398681 0.178837333,23.175739 0.499554906,23.4972926 C0.820272479,23.8188462 1.25567398,23.9996975 1.70982857,24 L1.71314286,24 C5.896,23.9944 20.3874286,23.9771429 24.5702857,23.9910857 C25.0228783,23.9866064 25.4564955,23.8086188 25.7817143,23.4938286 C26.1061179,23.1721514 26.2877125,22.7336478 26.2857306,22.2768 L26.2857306,5.6936 C26.2868533,5.17249435 26.0501486,4.67934894 25.6428571,4.35428571 Z M13.7142857,1.14285714 L19.5993143,1.14285714 C19.7289509,1.14299989 19.8546138,1.18761729 19.9553143,1.26925714 L24.0836571,4.57142857 L13.7142857,4.57142857 L13.7142857,1.14285714 Z M6.33142857,1.26857143 C6.43195122,1.18740769 6.55720124,1.14304998 6.6864,1.14285714 L12.5714286,1.14285714 L12.5714286,4.57142857 L2.20205714,4.57142857 L6.33142857,1.26857143 Z M25.1428675,22.2768 C25.1437789,22.4309348 25.0830921,22.5790518 24.9742857,22.6882286 C24.8696804,22.7952416 24.726671,22.8560494 24.5770286,22.8571429 L24.5747429,22.8571429 C20.3861714,22.8571429 5.89611429,22.856 1.71085714,22.8616 L1.70982857,22.8571429 C1.55981321,22.8576118 1.41582012,22.7981632 1.30982857,22.692 C1.20200367,22.5843998 1.14185399,22.4380396 1.14284479,22.2857143 L1.14284479,5.71428571 L12.5714286,5.71428571 L12.5714286,9.71428571 C12.5714286,10.029877 12.8272659,10.2857143 13.1428571,10.2857143 C13.4584484,10.2857143 13.7142857,10.029877 13.7142857,9.71428571 L13.7142857,5.71428571 L25.1428675,5.71428571 L25.1428675,22.2768 Z"
                })
            })
        })
    }));
};
/* harmony default export */ const parcel = (SvgParcel);

;// ./src/icons/svg/play.svg
function play_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function play_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            play_define_property(target, key, source[key]);
        });
    }
    return target;
}
function play_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function play_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        play_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgPlay = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", play_object_spread_props(play_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M15.654 12.569c-.068-.045-.148-.069-.23-.069-.112 0-.22.044-.3.124-.08.08-.124.187-.124.3v10.152c0 .113.045.22.124.3.08.08.188.124.3.124.082 0 .162-.024.23-.069l7.615-5.076c.12-.078.193-.212.193-.355s-.073-.277-.193-.355l-7.615-5.076zM34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2c4.243 0 8.313 1.686 11.314 4.686 3 3 4.686 7.07 4.686 11.314zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5z"
        })
    }));
};
/* harmony default export */ const play = (SvgPlay);

;// ./src/icons/svg/plus.svg
function plus_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function plus_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            plus_define_property(target, key, source[key]);
        });
    }
    return target;
}
function plus_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function plus_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        plus_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgPlus = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", plus_object_spread_props(plus_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M18 8c.414 0 .75.336.75.75v8.5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5v8.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-8.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5v-8.5c0-.414.336-.75.75-.75z"
        })
    }));
};
/* harmony default export */ const plus = (SvgPlus);

;// ./src/icons/svg/refund.svg
function refund_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function refund_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            refund_define_property(target, key, source[key]);
        });
    }
    return target;
}
function refund_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function refund_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        refund_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgRefund = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("svg", refund_object_spread_props(refund_object_spread({
        viewBox: "0 0 30 30",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M3.38297 23.6247C3.20544 23.4132 2.89005 23.3857 2.67855 23.5632C2.46704 23.7407 2.4395 24.0561 2.61703 24.2676L3.38297 23.6247ZM13.8696 1.5C21.4018 1.5 27.5 7.54852 27.5 15L28.5 15C28.5 6.98751 21.9454 0.5 13.8696 0.499999L13.8696 1.5ZM27.5 15C27.5 22.4515 21.4018 28.5 13.8696 28.5L13.8696 29.5C21.9453 29.5 28.5 23.0125 28.5 15L27.5 15ZM3.38297 6.3753C5.88339 3.39641 9.65211 1.5 13.8696 1.5L13.8696 0.499999C9.346 0.499999 5.30055 2.53536 2.61703 5.73238L3.38297 6.3753ZM13.8696 28.5C9.6521 28.5 5.88339 26.6036 3.38297 23.6247L2.61703 24.2676C5.30055 27.4646 9.346 29.5 13.8696 29.5L13.8696 28.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M3 6L2.50248 5.95025C2.48756 6.09947 2.5404 6.24751 2.64645 6.35355C2.75249 6.4596 2.90053 6.51244 3.04975 6.49752L3 6ZM8.04975 5.99752C8.32452 5.97004 8.525 5.72502 8.49752 5.45025C8.47004 5.17548 8.22502 4.975 7.95025 5.00248L8.04975 5.99752ZM3.99752 1.04975C4.025 0.77498 3.82452 0.529958 3.54975 0.502481C3.27498 0.475004 3.02996 0.675476 3.00248 0.950248L3.99752 1.04975ZM3.04975 6.49752L8.04975 5.99752L7.95025 5.00248L2.95025 5.50248L3.04975 6.49752ZM3.49752 6.04975L3.99752 1.04975L3.00248 0.950248L2.50248 5.95025L3.49752 6.04975Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M14.1745 21.86V20.468C12.9905 20.3827 12.0785 20.0093 11.4385 19.348C10.7985 18.6867 10.4518 17.8547 10.3985 16.852H11.4065C11.4598 17.652 11.7212 18.2973 12.1905 18.788C12.6705 19.268 13.3318 19.5453 14.1745 19.62V15.092C13.0332 14.8467 12.1905 14.5213 11.6465 14.116C11.1132 13.7107 10.8465 13.0707 10.8465 12.196C10.8465 11.3533 11.1505 10.6707 11.7585 10.148C12.3665 9.62533 13.1718 9.34267 14.1745 9.3V8.388H14.9105V9.3C15.8705 9.37467 16.6225 9.67333 17.1665 10.196C17.7212 10.7187 18.0465 11.4067 18.1425 12.26H17.1665C17.0918 11.652 16.8572 11.1667 16.4625 10.804C16.0678 10.4413 15.5505 10.228 14.9105 10.164V14.276C15.4758 14.3933 15.9452 14.516 16.3185 14.644C16.6918 14.7613 17.0545 14.932 17.4065 15.156C17.7585 15.38 18.0198 15.6733 18.1905 16.036C18.3612 16.388 18.4465 16.8147 18.4465 17.316C18.4465 18.2227 18.1158 18.9693 17.4545 19.556C16.8038 20.132 15.9558 20.4413 14.9105 20.484V21.86H14.1745ZM14.1745 14.132V10.148C13.4492 10.1907 12.8732 10.3933 12.4465 10.756C12.0305 11.1187 11.8225 11.588 11.8225 12.164C11.8225 12.7187 11.9985 13.14 12.3505 13.428C12.7132 13.7053 13.3212 13.94 14.1745 14.132ZM14.9105 19.636C15.6358 19.5933 16.2332 19.3747 16.7025 18.98C17.1825 18.5747 17.4225 18.0413 17.4225 17.38C17.4225 16.7507 17.2358 16.292 16.8625 16.004C16.4892 15.7053 15.8385 15.4547 14.9105 15.252V19.636Z"
            })
        ]
    }));
};
/* harmony default export */ const refund = (SvgRefund);

;// ./src/icons/svg/scale.svg
function scale_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scale_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scale_define_property(target, key, source[key]);
        });
    }
    return target;
}
function scale_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function scale_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        scale_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgScale = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", scale_object_spread_props(scale_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "nonzero",
            d: "M16.004 15.864l2.36-4.096 2.36 4.096h-4.72zm-5.1-13.308a.88.88 0 0 1-.884-.884.88.88 0 0 1 .884-.884.88.88 0 0 1 .884.884.88.88 0 0 1-.884.884zM5.808 13.444H1.064l2.36-4.096 2.384 4.096zm16 2.772v-.06c0-.02-.02-.04-.02-.06 0 0 0-.02-.02-.02L18.776 10.9V7.16a.395.395 0 0 0-.336-.392l-7.144-1.18V3.304a1.69 1.69 0 0 0 1.28-1.632 1.671 1.671 0 1 0-3.344 0c0 .788.552 1.456 1.28 1.632v2.164l-7.008-1.14a.361.361 0 0 0-.316.1.342.342 0 0 0-.156.296v3.74L.06 13.64c-.04.06-.06.12-.06.196v.1c0 .02.02.02.02.04s.02.04.02.06l.02.04c.708 1.22 1.948 1.948 3.368 1.948s2.656-.728 3.368-1.948l.02-.04c.04-.06.06-.136.06-.196s-.02-.136-.06-.196L3.824 8.468V5.18l6.692 1.084v14.584L5.34 22.856a.375.375 0 0 0-.236.432c.04.196.196.316.392.316H16.34a.396.396 0 0 0 .392-.316.375.375 0 0 0-.236-.432L11.3 20.848V6.396l6.672 1.084v3.404L14.98 16.08c-.04.06-.06.12-.06.196 0 .06.02.136.06.196l.02.04a3.86 3.86 0 0 0 3.368 1.948c.708 0 1.376-.176 1.948-.512a3.964 3.964 0 0 0 1.416-1.436l.02-.04c.02-.02.02-.04.02-.06 0-.02 0-.02.02-.04V16.256c.016-.02.016-.02.016-.04z"
        })
    }));
};
/* harmony default export */ const scale = (SvgScale);

;// ./src/icons/svg/square-fill.svg
function square_fill_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_fill_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_fill_define_property(target, key, source[key]);
        });
    }
    return target;
}
function square_fill_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function square_fill_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        square_fill_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgSquareFill = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", square_fill_object_spread_props(square_fill_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M28.266 4H7.733C5.672 4 4.001 5.672 4 7.733v20.533C4 30.328 5.671 32 7.733 32h20.533C30.328 32 32 30.328 32 28.266V7.733C32 5.671 30.328 4 28.266 4zm-3.533 7.402c.276-.31.75-.337 1.06-.062.28.25.329.665.129.97l-.068.089L16.11 23.35c-.26.293-.696.332-1.002.108l-.088-.075-4.863-4.852c-.293-.293-.294-.767-.001-1.06.266-.267.683-.292.976-.074l.085.072 4.3 4.29 9.216-10.357z"
        })
    }));
};
/* harmony default export */ const square_fill = (SvgSquareFill);

;// ./src/icons/svg/square.svg
function square_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_define_property(target, key, source[key]);
        });
    }
    return target;
}
function square_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function square_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        square_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgSquare = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", square_object_spread_props(square_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            d: "M32 7.733v20.533c0 .99-.393 1.94-1.094 2.64-.7.7-1.65 1.094-2.64 1.094H7.733C5.671 32 4 30.328 4 28.266V7.733C4 5.672 5.672 4.001 7.733 4h20.533C30.328 4 32 5.671 32 7.733zm-1.5.148c0-1.315-1.066-2.381-2.381-2.381H7.881C6.566 5.5 5.5 6.566 5.5 7.881v20.24c0 1.314 1.066 2.379 2.381 2.379h20.238c1.315 0 2.38-1.065 2.381-2.38V7.881z"
        })
    }));
};
/* harmony default export */ const square = (SvgSquare);

;// ./src/icons/svg/stand-on-scale.svg
function stand_on_scale_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function stand_on_scale_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            stand_on_scale_define_property(target, key, source[key]);
        });
    }
    return target;
}
function stand_on_scale_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function stand_on_scale_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        stand_on_scale_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgStandOnScale = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", stand_on_scale_object_spread_props(stand_on_scale_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M14 0c2.419 0 4.437 1.718 4.9 4h6.926c1.105 0 2 .895 2 2 0 .055-.002.11-.007.166l-1.666 20C26.066 27.203 25.2 28 24.16 28H3.84c-1.04 0-1.906-.797-1.993-1.834l-1.666-20c-.092-1.1.726-2.067 1.827-2.16l.082-.004L9.1 4C9.563 1.718 11.58 0 14 0zm.217 9.995L14 10c-2.761 0-5-2.239-5-5H2.132l-.041.003c-.512.043-.9.463-.917.963l.003.117 1.667 20c.04.478.412.855.878.91L3.84 27h20.32c.48 0 .886-.34.98-.8l.016-.117 1.667-20c.002-.028.003-.055.003-.083 0-.552-.447-1-1-1H19c0 2.689-2.122 4.882-4.783 4.995zM17.5 24c.276 0 .5.224.5.5s-.224.5-.5.5h-7c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h7zM14 1c-2.21 0-4 1.79-4 4 0 2.04 1.527 3.723 3.5 3.969V6.5c0-.276.224-.5.5-.5s.5.224.5.5v2.469C16.473 8.723 18 7.039 18 5c0-2.21-1.79-4-4-4z",
                            transform: "translate(-281 -2861) translate(281 2861) translate(4 4)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const stand_on_scale = (SvgStandOnScale);

;// ./src/icons/svg/star.svg
function star_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function star_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            star_define_property(target, key, source[key]);
        });
    }
    return target;
}
function star_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function star_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        star_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgStar = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", star_object_spread_props(star_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "nonzero",
            d: "M12 0l3.523 8.17L24 9.167l-6.301 6.045L19.416 24 12 19.567 4.584 24l1.717-8.787L0 9.168l8.477-.999z"
        })
    }));
};
/* harmony default export */ const star = (SvgStar);

;// ./src/icons/svg/truck.svg
function truck_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function truck_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            truck_define_property(target, key, source[key]);
        });
    }
    return target;
}
function truck_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function truck_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        truck_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgTruck = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", truck_object_spread_props(truck_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("g", {
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                            d: "M22.5 0c.78 0 1.42.595 1.493 1.356L24 1.5v3.526h4c.116 0 .227.04.315.113l.062.06L31.88 9.22c.06.069.099.151.115.24l.008.089v9.977c0 .78-.595 1.42-1.356 1.493l-.144.007H26.96C26.706 22.71 25.254 24 23.5 24c-1.763 0-3.222-1.304-3.465-3h-6.07c-.243 1.696-1.702 3-3.465 3s-3.221-1.303-3.464-3H5.5c-.78 0-1.42-.595-1.493-1.356L4 19.5V7H2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H4V4H1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H4V1H.5C.224 1 0 .776 0 .5S.224 0 .5 0h22zm-12 18C9.12 18 8 19.12 8 20.5S9.12 23 10.5 23s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5zm13 0c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5zm7.501-7.003H24v6.039c1.542.22 2.76 1.445 2.968 2.99h3.534c.245 0 .45-.176.492-.41l.008-.09L31 10.998zM22.5 1H5v2h2.5c.276 0 .5.224.5.5s-.224.5-.5.5H5v2h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H5v12.5c0 .245.177.45.41.492L5.5 20h1.535c.243-1.696 1.702-3 3.465-3s3.222 1.304 3.465 3h6.07c.22-1.533 1.432-2.745 2.965-2.965V1.5c0-.245-.177-.45-.41-.492L22.5 1zm5.271 5.026H24v3.971h7.001v-.261l-3.23-3.71z",
                            transform: "translate(-281 -2393) translate(281 2393) translate(2 6)"
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ const truck = (SvgTruck);

;// ./src/icons/svg/twitter.svg
function twitter_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function twitter_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            twitter_define_property(target, key, source[key]);
        });
    }
    return target;
}
function twitter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function twitter_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        twitter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgTwitter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", twitter_object_spread_props(twitter_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M12.063 31.06c12.076 0 18.68-10.005 18.68-18.68 0-.285 0-.568-.019-.85C32.01 10.602 33.12 9.45 34 8.133c-1.198.531-2.47.88-3.77 1.033 1.37-.82 2.395-2.11 2.886-3.631-1.29.765-2.7 1.303-4.17 1.593-2.035-2.164-5.268-2.693-7.887-1.292-2.62 1.402-3.973 4.387-3.3 7.28-5.28-.264-10.198-2.758-13.532-6.86-1.742 3-.852 6.838 2.033 8.765-1.045-.031-2.067-.313-2.98-.822v.083c0 3.126 2.204 5.817 5.267 6.436-.966.264-1.98.302-2.964.113.86 2.674 3.325 4.506 6.133 4.56-2.324 1.826-5.196 2.818-8.153 2.815-.522 0-1.044-.033-1.563-.095 3.002 1.927 6.496 2.95 10.063 2.944"
        })
    }));
};
/* harmony default export */ const twitter = (SvgTwitter);

;// ./src/icons/svg/vegetable.svg
function vegetable_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vegetable_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vegetable_define_property(target, key, source[key]);
        });
    }
    return target;
}
function vegetable_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function vegetable_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        vegetable_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgVegetable = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", vegetable_object_spread_props(vegetable_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "nonzero",
            d: "M7.764 21.397c-.76-.412-3.596-2.052-5.256-4.396H4.08c.352 0 .64-.288.64-.64a.642.642 0 0 0-.64-.64H1.768a5.601 5.601 0 0 1-.404-1.28h4.36c.352 0 .64-.288.64-.64a.642.642 0 0 0-.64-.64H1.292c.028-.444.104-.868.22-1.28h2.572c.352 0 .64-.288.64-.64a.642.642 0 0 0-.64-.64h-2.04c1.072-1.908 3.168-3.18 5.632-3.18.032 0 .064 0 .092-.008.028.004.06.008.092.008 3.588 0 6.396 2.688 6.396 6.124-.004 4.124-5.396 7.256-6.492 7.852zM5.436 3.705c-.364-.712-.536-1.44-.496-2.064.876.576 2.244 1.82 1.984 3.848-.58-.416-1.116-1.056-1.488-1.784zm3.44-.32a5.303 5.303 0 0 1 1.364-1.696c.012.988-.252 2.588-1.86 3.76-.036-.624.132-1.352.496-2.064zm.508 2.9c2.228-1.816 2.324-4.488 2-5.8a.632.632 0 0 0-.332-.416.635.635 0 0 0-.532-.02c-1.092.452-2.132 1.48-2.78 2.756a.12.12 0 0 1-.016.032C7.008 1.417 5.692.485 4.756.085a.636.636 0 0 0-.84.344c-.452 1.092-.312 2.5.384 3.86a6.415 6.415 0 0 0 1.628 2.044C2.492 7.077 0 9.981 0 13.549c0 .064.004.124.008.188-.004.024-.008.044-.008.068 0 .044.004.092.012.132.292 4.576 5.668 7.788 7.06 8.544l.056.548a.638.638 0 0 0 .636.572.638.638 0 0 0 .636-.572l.056-.548c1.432-.776 7.076-4.148 7.076-8.932 0-3.648-2.6-6.6-6.148-7.264z"
        })
    }));
};
/* harmony default export */ const vegetable = (SvgVegetable);

;// ./src/icons/Icon.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Icon = ({"kale-3":"r39VCY","kale3":"r39VCY","white":"tnCLTb","charcoal-3":"LEpjfa","charcoal3":"LEpjfa","charcoal-1":"NQImBp","charcoal1":"NQImBp","carrot-2":"kiMyfs","carrot2":"kiMyfs","gunmetal":"fVtx7p","bluey-gray":"uqBfje","blueyGray":"uqBfje","salmon":"GqdDMb"});
;// ./src/icons/withIconProps.tsx
function withIconProps_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withIconProps_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withIconProps_define_property(target, key, source[key]);
        });
    }
    return target;
}
function withIconProps_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = withIconProps_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function withIconProps_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function withIconProps(IconComponent) {
    var Wrapped = function(props) {
        var WithFillProp = function(_param) {
            var fill = _param.fill, _param_size = _param.size, size = _param_size === void 0 ? 24 : _param_size, className = _param.className, otherProps = withIconProps_object_without_properties(_param, [
                "fill",
                "size",
                "className"
            ]);
            var fillClass = fill ? Icon[fill] : '';
            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(IconComponent, withIconProps_object_spread({
                className: (0,external_classnames_namespaceObject["default"])(fillClass, className),
                fill: fillClass ? undefined : fill,
                height: size
            }, otherProps));
        };
        return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(WithFillProp, withIconProps_object_spread({}, props));
    };
    return Wrapped;
}

;// ./src/icons/PropTypes.tsx

var IconPropTypes = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
        children: children
    });
};

;// ./src/icons/index.ts















































/** @deprecated Import `Arrow` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Arrow = withIconProps(arrow);
/** @deprecated Import `Back` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Back = withIconProps(back);
/** @deprecated Import `Blob` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Blob = withIconProps(blob);
/** @deprecated Import `Bolt` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Bolt = withIconProps(bolt);
/** @deprecated Import `BowlSteaming` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var BowlSteaming = withIconProps(bowl_steaming);
/** @deprecated Import `Calendar` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Calendar = withIconProps(calendar);
/** @deprecated Import `Caret` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Caret = withIconProps(caret);
/** @deprecated Import `Carrot` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Carrot = withIconProps(carrot);
/** @deprecated Import `Check` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Check = withIconProps(check);
/** @deprecated Import `CheckCircle` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CheckCircle = withIconProps(check_circle);
/** @deprecated Import `Chevron` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Chevron = withIconProps(chevron);
/** @deprecated Import `Circle` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Circle = withIconProps(circle);
/** @deprecated Import `CircleAlert` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleAlert = withIconProps(circle_alert);
/** @deprecated Import `CircleCross` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleCross = withIconProps(circle_cross);
/** @deprecated Import `CircleFill` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleFill = withIconProps(circle_fill);
/** @deprecated Import `CircleMinus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleMinus = withIconProps(circle_minus);
/** @deprecated Import `CirclePlus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CirclePlus = withIconProps(circle_plus);
/** @deprecated Import `Clipboard` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Clipboard = withIconProps(clipboard);
/** @deprecated Import `Clock` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Clock = withIconProps(clock);
/** @deprecated Import `Close` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Close = withIconProps(svg_close);
/** @deprecated Import `Doctor` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Doctor = withIconProps(doctor);
/** @deprecated Import `DogFood` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var DogFood = withIconProps(dog_food);
/** @deprecated Import `Facebook` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Facebook = withIconProps(facebook);
/** @deprecated Import `ForkSpoon` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var ForkSpoon = withIconProps(fork_spoon);
/** @deprecated Import `Heart` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Heart = withIconProps(heart);
/** @deprecated Import `HeartOutline` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var HeartOutline = withIconProps(heart_outline);
/** @deprecated Import `House` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var HoImport = withIconProps(house);
/** @deprecated Import `Information` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Information = withIconProps(information);
/** @deprecated Import `Leaf` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Leaf = withIconProps(leaf);
/** @deprecated Import `Lock` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Lock = withIconProps(lock);
/** @deprecated Import `Mail` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Mail = withIconProps(mail);
/** @deprecated Import `Minus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Minus = withIconProps(minus);
/** @deprecated Import `Navigation` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Navigation = withIconProps(navigation);
/** @deprecated Import `Parcel` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Parcel = withIconProps(parcel);
/** @deprecated Import `Play` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Play = withIconProps(play);
/** @deprecated Import `Plus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Plus = withIconProps(plus);
/** @deprecated Import `Refund` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Refund = withIconProps(refund);
/** @deprecated Import `Scale` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Scale = withIconProps(scale);
/** @deprecated Import `Square` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Square = withIconProps(square);
/** @deprecated Import `SquareFill` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var SquareFill = withIconProps(square_fill);
/** @deprecated Import `StandOnScale` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var StandOnScale = withIconProps(stand_on_scale);
/** @deprecated Import `Star` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Star = withIconProps(star);
/** @deprecated Import `Truck` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Truck = withIconProps(truck);
/** @deprecated Import `Twitter` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Twitter = withIconProps(twitter);
/** @deprecated Import `Vegetable` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Vegetable = withIconProps(vegetable);

;// ./src/components/Text/Text.tsx
// TODO: Rework Typography to not return any
// https://app.clubhouse.io/farmersdog/story/42358/Text-types-no-any-type-from-typography-in-Text
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ function Text_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Text_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Text_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Text_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Text_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Text_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Text_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Text_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Text_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Text_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Text_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Text_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Text_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Text_sliced_to_array(arr, i) {
    return Text_array_with_holes(arr) || Text_iterable_to_array_limit(arr, i) || Text_unsupported_iterable_to_array(arr, i) || Text_non_iterable_rest();
}
function Text_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Text_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Text_array_like_to_array(o, minLen);
}



var TextVariants = [
    'heading-72',
    'heading-52',
    'heading-40',
    'heading-28',
    'heading-22',
    'heading-21',
    'heading-16',
    'heading-12',
    'body-21',
    'body-16',
    'body-12',
    'article-21',
    'article-20',
    'article-16',
    'article-12'
];
/**
 * ## Text
 *
 * The `Text` component renders textual content following the CORGI styles.
 *
 * ### Usage
 *
 * - Use this component to render block of texts.
 * - Follow the designer guidelines to choose the right `variant`.
 * - Make sure you use the proper semantic HTML tags for the `as` property.
 *
 * ### Example
 *
 * ```jsx
 * import { Text } from '@farmersdog/corgi-legacy';
 *
 * function () {
 *  return (
 *    <Text color="charcoal-3" as="h1" bold variant="heading-52">
 *      This is a bold title!
 *    </Text>
 *  )
 * }
 * ```
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/text | Text} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Text_Text = function(_param) {
    var tmp = _param.as, HTMLElement = tmp === void 0 ? 'span' : tmp, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'heading-52' : _param_variant, bold = _param.bold, fontStyle = _param.fontStyle, color = _param.color, className = _param.className, children = _param.children, props = Text_object_without_properties(_param, [
        "as",
        "variant",
        "bold",
        "fontStyle",
        "color",
        "className",
        "children"
    ]);
    var _variant_split = Text_sliced_to_array(variant.split('-'), 2), type = _variant_split[0], size = _variant_split[1];
    var weight = 'normal';
    if (bold) {
        if (type === 'heading' && Number(size) > 22) {
            weight = 'dynamicBold';
        } else {
            weight = 'bold';
        }
    }
    // @ts-expect-error not sure why this works at runtime, but typescript isn't happy
    var typographyStyles = typography_namespaceObject[type].create({
        size: size,
        weight: weight,
        fontStyle: fontStyle,
        color: color
    });
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HTMLElement, Text_object_spread_props(Text_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(className, typographyStyles.className)
    }, props), {
        children: children
    }));
};

;// ./src/components/LabeledSelector/LabeledSelector.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const LabeledSelector = ({"container":"Nfs3ox","input":"d_ALhl","label":"h9TNWk","disabled":"w1GYdj","kale-3":"r1s09c","kale3":"r1s09c","charcoal-3":"BIFFTl","charcoal3":"BIFFTl","charcoal-1":"I5irap","charcoal1":"I5irap"});
;// ./src/components/LabeledSelector/LabeledSelector.tsx
function LabeledSelector_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LabeledSelector_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LabeledSelector_define_property(target, key, source[key]);
        });
    }
    return target;
}
function LabeledSelector_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function LabeledSelector_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        LabeledSelector_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function LabeledSelector_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = LabeledSelector_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function LabeledSelector_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









/**
 * Component to attach a label to a design radio or checkbox
 *
 * @deprecated Use corgi-x {@link https://corgi-x.tfd.engineering/components/radiobutton | RadioButton} or {@link https://corgi-x.tfd.engineering/components/checkbox | Checkbox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var LabeledSelector_LabeledSelector = withRef(function(_param) {
    var children = _param.children, stateProp = _param.state, checked = _param.checked, type = _param.type, _param_color = _param.color, color = _param_color === void 0 ? 'kale-3' : _param_color, className = _param.className, forwardedRef = _param.forwardedRef, props = LabeledSelector_object_without_properties(_param, [
        "children",
        "state",
        "checked",
        "type",
        "color",
        "className",
        "forwardedRef"
    ]);
    var isCheckbox = type === 'checkbox';
    var getDesign = isCheckbox ? getCheckboxDesign_getCheckboxDesign : getRadioDesign_getRadioDesign;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Selector_Selector, LabeledSelector_object_spread_props(LabeledSelector_object_spread({
        type: type,
        checked: checked,
        className: (0,external_classnames_namespaceObject["default"])(className, LabeledSelector.container),
        ref: forwardedRef
    }, props), {
        children: function(state) {
            var inputDesign = getDesign({
                state: stateProp !== null && stateProp !== void 0 ? stateProp : state,
                checked: checked
            });
            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                        className: (0,external_classnames_namespaceObject["default"])(LabeledSelector.input, inputDesign, LabeledSelector[type]),
                        children: isCheckbox && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Check, {
                            fill: "white",
                            size: 12
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                        as: "span",
                        variant: "heading-16",
                        className: (0,external_classnames_namespaceObject["default"])(LabeledSelector.label, LabeledSelector[state], LabeledSelector[type], LabeledSelector[color]),
                        children: children
                    })
                ]
            });
        }
    }));
});

;// ./src/components/Checkbox/Checkbox.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Checkbox = ({"container":"q0s1q6","wrap":"rcYZMw"});
;// ./src/components/Checkbox/Checkbox.tsx
function Checkbox_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Checkbox_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Checkbox_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Checkbox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Checkbox_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Checkbox_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Checkbox_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Checkbox_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Checkbox_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/checkbox | Checkbox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Checkbox_Checkbox = withRef(function(_param) {
    var label = _param.label, _param_labelWrap = _param.labelWrap, labelWrap = _param_labelWrap === void 0 ? false : _param_labelWrap, forwardedRef = _param.forwardedRef, props = Checkbox_object_without_properties(_param, [
        "label",
        "labelWrap",
        "forwardedRef"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(LabeledSelector_LabeledSelector, Checkbox_object_spread_props(Checkbox_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(Checkbox.container, Checkbox_define_property({}, Checkbox.wrap, labelWrap))
    }, props), {
        type: "checkbox",
        ref: forwardedRef,
        children: label
    }));
});

;// ./src/components/Checkbox/CheckboxView.tsx



var CheckboxView = function(param) {
    var state = param.state, checked = param.checked;
    var inputDesign = getCheckboxDesign_getCheckboxDesign({
        state: state !== null && state !== void 0 ? state : 'normal',
        checked: checked
    });
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("span", {
        className: inputDesign,
        children: [
            ' ',
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Check, {
                fill: "white",
                size: 12
            })
        ]
    });
};

;// ./src/components/Checkbox/index.ts



;// ./src/util/browserOnly.ts
/**
 * Safely execute browser only code.
 *
 * @deprecated Use `browserOnly` from `@farmersdog/utils`.
 */ var browserOnly = function(fn, fallback) {
    if (typeof window !== 'undefined') {
        return fn(window, document);
    }
    if (fallback) {
        return fallback();
    }
    return;
};

;// ./src/components/ContentReveal/transitionStyles/spring-down.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spring_down = ({"entering":"LF8j6O","spring-down-in":"FwCjzI","springDownIn":"FwCjzI","fade-in":"jpVPMw","fadeIn":"jpVPMw","exiting":"gfpXFs","spring-down-out":"SsV1eD","springDownOut":"SsV1eD","fade-out":"e7e9nr","fadeOut":"e7e9nr"});
;// ./src/components/ContentReveal/transitionStyles/spring-up.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spring_up = ({"entering":"F6SMI1","spring-up-in":"eUHVgE","springUpIn":"eUHVgE","fade-in":"OoQwUE","fadeIn":"OoQwUE","exiting":"lU3Ko1","spring-up-out":"wHJaHQ","springUpOut":"wHJaHQ","fade-out":"N7V8bc","fadeOut":"N7V8bc"});
;// ./src/components/ContentReveal/transitionStyles/slide-down.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const slide_down = ({"entering":"m8i25R","slide-down-in":"tftlzT","slideDownIn":"tftlzT","fade-in":"kK01Up","fadeIn":"kK01Up","exiting":"UAJhTf","slide-down-out":"GHp3w3","slideDownOut":"GHp3w3","fade-out":"VLRhAg","fadeOut":"VLRhAg"});
;// ./src/components/ContentReveal/transitionStyles/slide-up.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const slide_up = ({"entering":"gaLEYt","slide-up-in":"nEqnNf","slideUpIn":"nEqnNf","fade-in":"pKgkF3","fadeIn":"pKgkF3","exiting":"b5QQxQ","slide-up-out":"hFNkqF","slideUpOut":"hFNkqF","fade-out":"qk8aE9","fadeOut":"qk8aE9"});
;// ./src/components/ContentReveal/transitionStyles/fade.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const fade = ({"entering":"yMAEcN","fade-in":"FNnso6","fadeIn":"FNnso6","exiting":"kV4tgr","fade-out":"iC8m0Y","fadeOut":"iC8m0Y"});
;// ./src/components/ContentReveal/transitionStyles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const transitionStyles_base = ({"init":"MAu91p","entered":"txDvaL","exited":"QX2_pe"});
;// ./src/components/ContentReveal/transitions.ts






/* harmony default export */ const transitions = ({
    springDown: {
        transitions: spring_down,
        defaultOut: spring_up,
        duration: 600
    },
    springUp: {
        transitions: spring_up,
        defaultOut: spring_down,
        duration: 600
    },
    slideDown: {
        transitions: slide_down,
        defaultOut: slide_up,
        duration: 300
    },
    slideUp: {
        transitions: slide_up,
        defaultOut: slide_down,
        duration: 300
    },
    fade: {
        transitions: fade,
        defaultOut: fade,
        duration: 300
    },
    base: {
        transitions: transitionStyles_base
    }
});

;// ./src/components/ContentReveal/ContentReveal.tsx
function ContentReveal_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ContentReveal_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ContentReveal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContentReveal_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ContentReveal_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ContentReveal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContentReveal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ContentReveal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ContentReveal_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ContentReveal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ContentReveal_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ContentReveal_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ContentReveal_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ContentReveal_sliced_to_array(arr, i) {
    return ContentReveal_array_with_holes(arr) || ContentReveal_iterable_to_array_limit(arr, i) || ContentReveal_unsupported_iterable_to_array(arr, i) || ContentReveal_non_iterable_rest();
}
function ContentReveal_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ContentReveal_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContentReveal_array_like_to_array(o, minLen);
}






var useState = external_react_namespaceObject.useState, useEffect = external_react_namespaceObject.useEffect;
var ContentRevealAnimations = [
    'springUp',
    'springDown',
    'slideUp',
    'slideDown',
    'fade'
];
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/contentreveal | ContentReveal} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var ContentReveal = function(_param) {
    var inAnimation = _param.inAnimation, _param_inDelay = _param.inDelay, inDelay = _param_inDelay === void 0 ? 0 : _param_inDelay, outAnimation = _param.outAnimation, _param_outDelay = _param.outDelay, outDelay = _param_outDelay === void 0 ? 0 : _param_outDelay, children = _param.children, props = ContentReveal_object_without_properties(_param, [
        "inAnimation",
        "inDelay",
        "outAnimation",
        "outDelay",
        "children"
    ]);
    var _useState = ContentReveal_sliced_to_array(useState(false), 2), inState = _useState[0], setInState = _useState[1];
    var inTransition = transitions[inAnimation];
    var outTransition = outAnimation ? transitions[outAnimation] : ContentReveal_object_spread_props(ContentReveal_object_spread({}, inTransition), {
        transitions: inTransition.defaultOut
    });
    var stateTransitions = ContentReveal_object_spread({
        entering: inTransition.transitions.entering,
        exiting: outTransition.transitions.exiting,
        init: transitions.base.transitions.init
    }, transitions.base.transitions);
    useEffect(function() {
        var delayTimeout;
        if (props.in !== inState) {
            delayTimeout = browserOnly(function(window) {
                return window.setTimeout(function() {
                    setInState(props.in);
                    clearTimeout(delayTimeout);
                    delayTimeout = undefined;
                }, props.in ? inDelay : outDelay);
            });
        }
        return function() {
            clearTimeout(delayTimeout);
            delayTimeout = undefined;
        };
    }, [
        inDelay,
        inState,
        outDelay,
        props.in
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_transition_group_namespaceObject.Transition, {
        timeout: {
            enter: inTransition.duration,
            exit: outTransition.duration
        },
        in: inState,
        children: function(state) {
            var child = external_react_namespaceObject.Children.only(children);
            if (!/*#__PURE__*/ external_react_namespaceObject.isValidElement(child)) {
                return child;
            }
            var className = (0,external_classnames_namespaceObject["default"])(child.props.className, stateTransitions.init, stateTransitions[state]);
            return /*#__PURE__*/ external_react_namespaceObject.cloneElement(child, {
                className: className
            });
        }
    });
};

;// ./src/components/ContentReveal/index.ts


;// ./src/components/LiveMessage/LiveMessage.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const LiveMessage = ({"message":"_gFTaX","invalid":"jBfybM"});
;// ./src/components/LiveMessage/LiveMessage.tsx
function LiveMessage_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LiveMessage_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LiveMessage_define_property(target, key, source[key]);
        });
    }
    return target;
}
function LiveMessage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function LiveMessage_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        LiveMessage_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function LiveMessage_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = LiveMessage_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function LiveMessage_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/**
 * The valid string values for the aria-live attribute. This is used to indicate
 * to screen readers how frequently they should announce new message content.
 */ var AriaLiveAttributes = [
    'off',
    'assertive',
    'polite'
];
/**
 * An WCAG compliant component for rendering messages whose content is dynamic.
 * It's content can be visually show or visually hidden. Commonly used for
 * inline error messages.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/statusmessage | StatusMessage} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var LiveMessage_LiveMessage = function(_param) {
    var id = _param.id, invalid = _param.invalid, _param_hidden = _param.hidden, hidden = _param_hidden === void 0 ? false : _param_hidden, className = _param.className, children = _param.children, props = LiveMessage_object_without_properties(_param, [
        "id",
        "invalid",
        "hidden",
        "className",
        "children"
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ContentReveal, {
        inAnimation: "fade",
        outAnimation: "fade",
        in: !hidden,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", LiveMessage_object_spread_props(LiveMessage_object_spread({
            id: id,
            role: "status",
            className: (0,external_classnames_namespaceObject["default"])(className, LiveMessage.message, (_obj = {}, LiveMessage_define_property(_obj, LiveMessage.invalid, invalid), LiveMessage_define_property(_obj, accessibility.hidden, hidden), _obj))
        }, props), {
            children: children
        }))
    });
};

;// ./src/components/LiveMessage/index.ts


;// ./src/components/FormControl/FormControl.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const FormControl = ({"container":"L0wV3v","message":"a_2Xxn"});
;// ./src/components/FormControl/FormControl.tsx
function FormControl_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FormControl_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = FormControl_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function FormControl_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var FormControl_typography = heading.create({
    size: 16,
    color: 'charcoal-1'
});
/**
 * This component is used for including inline error messages along with form
 * elements.
 *
 * https://www.w3.org/WAI/tutorials/forms/notifications/#listing-errors
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/formcontrol | FormControl} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var FormControl_FormControl = function(_param) {
    var children = _param.children, message = _param.message, invalid = _param.invalid, className = _param.className, _param_disableAriaProps = _param.disableAriaProps, disableAriaProps = _param_disableAriaProps === void 0 ? false : _param_disableAriaProps, props = FormControl_object_without_properties(_param, [
        "children",
        "message",
        "invalid",
        "className",
        "disableAriaProps"
    ]);
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var hidden = !message;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0,external_classnames_namespaceObject["default"])(FormControl.container, className),
        children: [
            /*#__PURE__*/ external_react_namespaceObject["default"].isValidElement(children) && !disableAriaProps ? /*#__PURE__*/ external_react_namespaceObject["default"].cloneElement(children, (_obj = {
                // @ts-ignore
                invalid: invalid
            }, FormControl_define_property(_obj, 'aria-describedby', id), FormControl_define_property(_obj, 'aria-invalid', invalid), _obj)) : children,
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(LiveMessage_LiveMessage, {
                id: id,
                "aria-live": props['aria-live'],
                hidden: hidden,
                invalid: invalid,
                className: (0,external_classnames_namespaceObject["default"])(FormControl_typography.className, FormControl.message),
                children: message
            })
        ]
    });
};
FormControl_FormControl.defaultProps = FormControl_define_property({}, 'aria-live', 'polite');

;// ./src/components/FormControl/index.ts


;// ./src/util/getHasValue.ts
/**
 * Return if an input has a value. Inputs can have values of number type which
 * can make naive `Boolean` coercion incorrect.
 *
 * @example
 *
 *   hasValue(null) // false
 *   hasValue('') // false
 *   hasValue(0) // true
 *   hasValue(undefined) // false
 *   hasValue('some string') // true
 *
 */ var getHasValue = function(value) {
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    if (typeof value === 'number') {
        return Number.isFinite(value);
    }
    return Boolean(value);
};

;// ./src/components/Input/Input.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Input = ({"input":"oL9_CB"});
;// ./src/components/Input/Input.tsx
function Input_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Input_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Input_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Input_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Input_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Input_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Input_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Input_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Input_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Input_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Input_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Input_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Input_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Input_sliced_to_array(arr, i) {
    return Input_array_with_holes(arr) || Input_iterable_to_array_limit(arr, i) || Input_unsupported_iterable_to_array(arr, i) || Input_non_iterable_rest();
}
function Input_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Input_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Input_array_like_to_array(o, minLen);
}







var Input_typography = heading.create({
    size: 16
});
var InputComponent = function(_param) {
    var label = _param.label, className = _param.className, invalid = _param.invalid, highlighted = _param.highlighted, onChange = _param.onChange, onBlur = _param.onBlur, onFocus = _param.onFocus, forwardedRef = _param.forwardedRef, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = Input_object_without_properties(_param, [
        "label",
        "className",
        "invalid",
        "highlighted",
        "onChange",
        "onBlur",
        "onFocus",
        "forwardedRef",
        "hideLabel"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = Input_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid,
        highlighted: highlighted
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _props_value;
    var _React_useState = Input_sliced_to_array(external_react_namespaceObject.useState((_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : ''), 2), value = _React_useState[0], setValue = _React_useState[1];
    external_react_namespaceObject.useEffect(function() {
        if (props.value !== undefined && props.value !== null) {
            setValue(props.value);
        }
    }, [
        props.value,
        value
    ]);
    var handleChange = function(event) {
        setValue(event.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(BorderLabel_BorderLabel, {
        in: props.type === 'date' || state === 'focus' || state === 'invalid' || getHasValue(value),
        text: label || props.name || '',
        state: state,
        className: className,
        hideLabel: hideLabel,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("input", Input_object_spread_props(Input_object_spread({
            ref: forwardedRef,
            className: (0,external_classnames_namespaceObject["default"])(Input.input, Input_typography.className),
            onChange: interceptEvent(handleChange, onChange),
            onFocus: interceptEvent(handlers.onFocus, onFocus),
            onBlur: interceptEvent(handlers.onBlur, onBlur),
            "aria-invalid": invalid
        }, props), {
            // Order is important, we want to overwrite value
            value: value,
            placeholder: undefined
        }))
    });
};
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/input | Input} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Input_Input = withRef(InputComponent);

;// ./src/components/Input/index.ts


;// ./src/components/LabeledSelector/index.ts


;// ./src/components/Selector/index.ts


;// ./src/components/SelectorGroup/getInitialValue.ts
/**
 * Get the initial state value according to the input props. Initial state
 * depends on whether or not multiple selections are available as well as
 * whether or not a `value` prop is passed in.
 */ function getInitialValue(value, multi) {
    var isControlled = typeof value !== 'undefined';
    if (isControlled) {
        return value;
    }
    if (multi) {
        return [];
    }
    return undefined;
}
/* harmony default export */ const SelectorGroup_getInitialValue = (getInitialValue);

;// ./src/components/SelectorGroup/includesCastValue.ts
/**
 * Returns a boolean indicating whether or not the array contains an item that
 * matches the stringified argument.
 */ function includesCastValue(value, child) {
    if (!Array.isArray(value)) {
        return false;
    }
    return typeof value.find(function(value) {
        return String(value) === String(child);
    }) !== 'undefined';
}
/* harmony default export */ const SelectorGroup_includesCastValue = (includesCastValue);

;// ./src/components/SelectorGroup/SelectorGroup.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SelectorGroup = ({"fieldset":"K434KY","message":"WrstOy"});
;// ./src/components/SelectorGroup/SelectorGroup.tsx
function SelectorGroup_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SelectorGroup_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function SelectorGroup_array_without_holes(arr) {
    if (Array.isArray(arr)) return SelectorGroup_array_like_to_array(arr);
}
function SelectorGroup_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SelectorGroup_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SelectorGroup_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SelectorGroup_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SelectorGroup_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SelectorGroup_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SelectorGroup_define_property(target, key, source[key]);
        });
    }
    return target;
}
function SelectorGroup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SelectorGroup_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SelectorGroup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SelectorGroup_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = SelectorGroup_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SelectorGroup_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SelectorGroup_sliced_to_array(arr, i) {
    return SelectorGroup_array_with_holes(arr) || SelectorGroup_iterable_to_array_limit(arr, i) || SelectorGroup_unsupported_iterable_to_array(arr, i) || SelectorGroup_non_iterable_rest();
}
function SelectorGroup_to_consumable_array(arr) {
    return SelectorGroup_array_without_holes(arr) || SelectorGroup_iterable_to_array(arr) || SelectorGroup_unsupported_iterable_to_array(arr) || SelectorGroup_non_iterable_spread();
}
function SelectorGroup_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SelectorGroup_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SelectorGroup_array_like_to_array(o, minLen);
}










var SelectorGroup_typography = heading.create({
    size: 16,
    color: 'charcoal-1'
});
/**
 * Component to manage the state of multiple input children.  This component will
 * manage each child's props for: name, onChange, and checked.
 *
 * This allows the shared props to be set in one spot and automatically passed down.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/fieldset | Fieldset} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var SelectorGroup_SelectorGroup = function(_param) {
    var children = _param.children, name = _param.name, type = _param.type, legend = _param.legend, showLegend = _param.showLegend, className = _param.className, inputsClassName = _param.inputsClassName, propValue = _param.value, onChange = _param.onChange, invalid = _param.invalid, message = _param.message, props = SelectorGroup_object_without_properties(_param, [
        "children",
        "name",
        "type",
        "legend",
        "showLegend",
        "className",
        "inputsClassName",
        "value",
        "onChange",
        "invalid",
        "message"
    ]);
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var messageHidden = !message;
    var multi = type === 'checkbox' || Boolean(external_react_namespaceObject["default"].Children.toArray(children).find(function(child) {
        return /*#__PURE__*/ external_react_namespaceObject["default"].isValidElement(child) && child.props.type === 'checkbox';
    }));
    var _React_useState = SelectorGroup_sliced_to_array(external_react_namespaceObject["default"].useState(SelectorGroup_getInitialValue(propValue, multi)), 2), internalValue = _React_useState[0], setInternalValue = _React_useState[1];
    var value = typeof propValue !== 'undefined' ? propValue : internalValue;
    var handleChange = function(e) {
        var eventValue = e.target.value;
        if (!(multi && Array.isArray(value))) {
            setInternalValue(eventValue);
            return;
        }
        var nextValue = SelectorGroup_includesCastValue(value, eventValue) ? value.filter(function(lastValue) {
            return String(lastValue) !== eventValue;
        }) : SelectorGroup_to_consumable_array(value).concat([
            eventValue
        ]);
        setInternalValue(nextValue);
    };
    var getChecked = function(childValue) {
        if (multi && Array.isArray(value)) {
            return SelectorGroup_includesCastValue(value, childValue);
        }
        return String(value) === String(childValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("fieldset", SelectorGroup_object_spread_props(SelectorGroup_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(SelectorGroup.fieldset, className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("legend", {
                className: (0,external_classnames_namespaceObject["default"])(SelectorGroup_define_property({}, accessibility.hidden, !showLegend)),
                children: legend
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: inputsClassName,
                children: external_react_namespaceObject["default"].Children.map(children, function(child) {
                    if (!/*#__PURE__*/ external_react_namespaceObject["default"].isValidElement(child)) {
                        return child;
                    }
                    return /*#__PURE__*/ external_react_namespaceObject["default"].cloneElement(child, {
                        name: name,
                        onChange: interceptEvent(child.props.onChange, handleChange, onChange),
                        checked: getChecked(child.props.value),
                        type: type
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(LiveMessage_LiveMessage, {
                id: id,
                hidden: messageHidden,
                "aria-live": props['aria-live'],
                invalid: invalid,
                className: (0,external_classnames_namespaceObject["default"])(SelectorGroup_typography.className, SelectorGroup.message),
                children: message
            })
        ]
    }));
};

;// ./src/components/SelectorGroup/index.ts


;// external "lodash/noop"
var noop_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var noop_y = (x) => (() => (x))
const noop_namespaceObject = noop_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_lodash_noop_227d2eda__["default"]) });
;// external "lodash/omit"
var omit_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var omit_y = (x) => (() => (x))
const omit_namespaceObject = omit_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_lodash_omit_d930e0f3__["default"]) });
;// external "react-dom"
var external_react_dom_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_react_dom_y = (x) => (() => (x))
const external_react_dom_namespaceObject = external_react_dom_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_react_dom_7dac9eee__["default"]) });
;// ./src/components/Lightbox/Lightbox.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Lightbox = ({"tfd-lightbox":"zLBb0J","tfdLightbox":"zLBb0J","has-lightbox":"ioHTY4","hasLightbox":"ioHTY4","container":"dWlauE","background":"yiimnQ","disableAnimation":"ekSfoP","content":"i0x9Jz","autoBox":"greOkd"});
;// ./src/components/Lightbox/dom.ts

var DOCUMENT_ELEMENT;
var DOCUMENT;
if (typeof window !== 'undefined') {
    DOCUMENT_ELEMENT = window.document.documentElement;
    DOCUMENT = window.document;
}
var lightboxes = 0;
var previousPadding = null;
/**
 * Initialize the body element by setting a padding right of the same width as
 * any active body scrollbars.
 */ function setScrollBarGap() {
    if (!(DOCUMENT && DOCUMENT_ELEMENT && typeof window !== 'undefined')) {
        return;
    }
    var gap = window.innerWidth - DOCUMENT_ELEMENT.clientWidth;
    previousPadding = DOCUMENT.body.style.paddingRight;
    DOCUMENT.body.style.paddingRight = "".concat(gap, "px");
}
/**
 * Cleanup the body element by reseting the padding right to the initial stored
 * value.
 */ function unsetScrollBarGap() {
    if (!DOCUMENT || previousPadding === null) {
        return;
    }
    DOCUMENT.body.style.paddingRight = previousPadding;
}
/**
 * Initialize the root dom element by adding a css class. This class is used to
 * add specific overflow and scrolling related css.
 */ var initializeDOM = function() {
    if (lightboxes < 1 && DOCUMENT_ELEMENT) {
        setScrollBarGap();
        DOCUMENT_ELEMENT.classList.add(Lightbox.hasLightbox);
    }
    lightboxes += 1;
};
/**
 * Cleanup the root dom element by removing a css class. This class is used to
 * add specific overflow and scrolling related css. Removal of the class will
 * restore normal scrolling behavior.
 */ var cleanupDOM = function() {
    lightboxes -= 1;
    if (lightboxes < 1 && DOCUMENT_ELEMENT) {
        DOCUMENT_ELEMENT.classList.remove(Lightbox.hasLightbox);
        unsetScrollBarGap();
    }
};
/**
 * Add a new Element with the specified id. If the element already exists, it
 * returns it.
 */ var addDOMElementById = function(id) {
    var tagName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'div';
    if (!DOCUMENT) {
        return;
    }
    var el = DOCUMENT.getElementById(id);
    if (!el) {
        el = DOCUMENT.createElement(tagName);
        el.id = id;
        DOCUMENT.body.appendChild(el);
    }
    return el;
};

;// ./src/components/Lightbox/transitions/background.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const transitions_background = ({"entering":"kH7X3P","entered":"Prmd8_","exiting":"EDGR0E"});
;// ./src/components/Lightbox/transitions/content.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const content = ({"entering":"Ekeec6","entered":"UdzmZ5","exiting":"fBKSdE","exited":"OQSZMQ"});
;// external "bowser"
var external_bowser_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_bowser_y = (x) => (() => (x))
const external_bowser_namespaceObject = external_bowser_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_bowser__["default"]) });
;// ./src/components/Lightbox/device.ts

var hasSupport;
var hasPassiveTouchSupport = function() {
    if (hasSupport !== undefined) {
        return hasSupport;
    }
    try {
        var options = {
            get passive () {
                // This function will be called when the browser attempts to access
                // the passive property.
                hasSupport = true;
                return undefined;
            }
        };
        // Ignore the next lines to set a "fake" event listener
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    } catch (e) {
        hasSupport = false;
    }
    hasSupport = Boolean(hasSupport);
    return hasSupport;
};
var isIosDevice;
var isIos = function() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    if (isIosDevice !== undefined) {
        return isIosDevice;
    }
    var userAgent = navigator.userAgent;
    var deviceInfo = external_bowser_namespaceObject["default"].getParser(userAgent);
    var osName = deviceInfo.getOSName();
    isIosDevice = osName.toLowerCase() === 'ios';
    return isIosDevice;
};

;// ./src/components/Lightbox/blockBodyScroll.ts


/**
 * Imperative effect that blocks scrollling on the body element. The bounds for
 * scrolling are determined by the the height of the content element rectangle
 * compared to the height of container element rectangle. When the content has
 * been scrolled all the way up or down then this effect will block any further
 * scrolling action. Usually used to correct iOS behavior that does not respect
 * body overflow css.
 */ var blockBodyScroll = function(containerElement, contentElement) {
    if (!containerElement || !contentElement || typeof window === 'undefined') {
        return {
            initialize: noop_namespaceObject["default"],
            cleanup: noop_namespaceObject["default"]
        };
    }
    var BODY = window.document.body;
    var touchStartClientY = 0;
    var handleTouchMove = function(e) {
        if (e.targetTouches.length !== 1) {
            return;
        }
        if (!e.cancelable || e.defaultPrevented) {
            return;
        }
        var scrollUp = touchStartClientY - e.targetTouches[0].clientY < 0;
        var scrollTop = containerElement.scrollTop, clientHeight = containerElement.clientHeight;
        /** is the lightbox scrolled up? */ if (scrollTop <= 0 && scrollUp) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        var contentHeight = contentElement.clientHeight;
        /** is the lightbox scrolled down? */ if (scrollTop + clientHeight >= contentHeight && !scrollUp) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    var handleTouchStart = function(e) {
        if (e.targetTouches.length === 1) {
            touchStartClientY = e.targetTouches[0].clientY;
        }
    };
    var initialize = function() {
        var passiveSupported = hasPassiveTouchSupport();
        BODY.addEventListener('touchstart', handleTouchStart, passiveSupported ? {
            passive: false
        } : false);
        BODY.addEventListener('touchmove', handleTouchMove, passiveSupported ? {
            passive: false
        } : false);
    };
    var cleanup = function() {
        BODY.removeEventListener('touchstart', handleTouchStart);
        BODY.removeEventListener('touchmove', handleTouchMove);
    };
    return {
        initialize: initialize,
        cleanup: cleanup
    };
};

;// external "lodash/debounce"
var debounce_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var debounce_y = (x) => (() => (x))
const debounce_namespaceObject = debounce_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_lodash_debounce_3540babe__["default"]) });
;// ./src/components/Lightbox/trapFocus.ts
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

/**
 * Return two functions that will initialize and cleanup trapping focus inside a
 * dom node. If focus goes outside the hierarchy of the dom node then
 * programmatically refocus the dom node.
 */ function trapFocus(modalRoot) {
    var lastActiveElement = document.activeElement;
    var handleFocus = function(e) {
        if (_instanceof(e.target, Node) && !modalRoot.contains(e.target)) {
            (0,debounce_namespaceObject["default"])(function() {
                modalRoot.focus();
            }, 100);
        }
    };
    var initialize = function() {
        if (!modalRoot) {
            return;
        }
        (0,debounce_namespaceObject["default"])(function() {
            modalRoot.focus();
        }, 100);
        document.addEventListener('focusin', handleFocus);
    };
    var cleanup = function() {
        document.removeEventListener('focusin', handleFocus);
        if (lastActiveElement && _instanceof(lastActiveElement, HTMLElement)) {
            (0,debounce_namespaceObject["default"])(function() {
                lastActiveElement.focus();
            }, 100);
        }
    };
    return {
        initialize: initialize,
        cleanup: cleanup
    };
}

;// ./src/util/wait.ts
/**
 * Return a promise that resolves when certain amount of milliseconds has
 * elapsed. This is used so we can wait the same duration as our css animation.
 * Will also optionally call a callback function at the same point.
 *
 * TODO: See if we can listen to `transitionend` event in a better way.
 * http://reactcommunity.org/react-transition-group/transition#Transition-prop-addEndListener
 */ var wait = function(duration, callback) {
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
            if (callback) {
                callback();
            }
        }, duration);
    });
};

;// ./src/components/Lightbox/Lightbox.tsx
function Lightbox_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Lightbox_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Lightbox_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Lightbox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Lightbox_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Lightbox_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Lightbox_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Lightbox_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Lightbox_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








// root styles need to be imported before the transition styles for CSS specificity








var Lightbox_ANIMATION_DURATION = 300;
var ESCAPE = 27;
var rootEl = browserOnly(function() {
    return addDOMElementById(Lightbox.tfdLightbox);
});
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/lightbox | Lightbox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Lightbox_Lightbox = function(_param) {
    var background = _param.background, _param_width = _param.width, width = _param_width === void 0 ? '100%' : _param_width, _param_height = _param.height, height = _param_height === void 0 ? '100vh' : _param_height, offsetTop = _param.offsetTop, children = _param.children, isOpen = _param.isOpen, className = _param.className, close = _param.close, _param_withAnimation = _param.withAnimation, withAnimation = _param_withAnimation === void 0 ? true : _param_withAnimation, _param_disableInteractions = _param.disableInteractions, disableInteractions = _param_disableInteractions === void 0 ? false : _param_disableInteractions, props = Lightbox_object_without_properties(_param, [
        "background",
        "width",
        "height",
        "offsetTop",
        "children",
        "isOpen",
        "className",
        "close",
        "withAnimation",
        "disableInteractions"
    ]);
    var contentEl = external_react_namespaceObject.useRef(null);
    var containerEl = external_react_namespaceObject.useRef(null);
    var calculatedHeight = offsetTop ? "calc(".concat(height, " - ").concat(offsetTop, "px)") : height;
    var animationDuration = withAnimation ? Lightbox_ANIMATION_DURATION : 0;
    external_react_namespaceObject.useEffect(function() {
        if (!isOpen) {
            return noop_namespaceObject["default"];
        }
        initializeDOM();
        return function() {
            return wait(animationDuration, cleanupDOM);
        };
    }, [
        animationDuration,
        isOpen
    ]);
    external_react_namespaceObject.useEffect(function() {
        if (!isIos() || !isOpen || !containerEl.current || !contentEl.current) {
            return noop_namespaceObject["default"];
        }
        var _blockBodyScroll = blockBodyScroll(containerEl.current, contentEl.current), initialize = _blockBodyScroll.initialize, cleanup = _blockBodyScroll.cleanup;
        initialize();
        return cleanup;
    }, [
        contentEl,
        containerEl,
        isOpen
    ]);
    // trapModalFocus
    external_react_namespaceObject.useEffect(function() {
        if (!isOpen || !containerEl.current) {
            return noop_namespaceObject["default"];
        }
        var _trapFocus = trapFocus(containerEl.current), initialize = _trapFocus.initialize, cleanup = _trapFocus.cleanup;
        initialize();
        return cleanup;
    }, [
        isOpen,
        containerEl
    ]);
    // addEscKeyListener
    external_react_namespaceObject.useEffect(function() {
        if (!isOpen) {
            return noop_namespaceObject["default"];
        }
        var handleKeyUp = function(e) {
            if (e.code === 'Escape') {
                close();
            }
        };
        window.addEventListener('keyup', handleKeyUp);
        return function() {
            return window.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        isOpen,
        close,
        disableInteractions
    ]);
    if (!rootEl) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_transition_group_namespaceObject.Transition, {
        in: isOpen,
        component: null,
        timeout: animationDuration,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: true,
        children: function(state) {
            return /*#__PURE__*/ external_react_dom_namespaceObject["default"].createPortal(/*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("aside", Lightbox_object_spread_props(Lightbox_object_spread({
                className: (0,external_classnames_namespaceObject["default"])(Lightbox.container, !withAnimation && Lightbox.disableAnimation),
                style: {
                    marginTop: offsetTop
                },
                ref: containerEl
            }, (0,omit_namespaceObject["default"])(props, [
                'overflow',
                'open',
                'labelProps',
                'descriptionProps'
            ])), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", {
                        name: "background",
                        "aria-label": "close",
                        onClick: close,
                        disabled: disableInteractions,
                        className: (0,external_classnames_namespaceObject["default"])(Lightbox.background, transitions_background[state]),
                        style: {
                            background: background
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                        className: Lightbox.autoBox,
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                            ref: contentEl,
                            className: (0,external_classnames_namespaceObject["default"])(Lightbox.content, content[state], className),
                            style: {
                                width: width,
                                minHeight: calculatedHeight
                            },
                            children: children
                        })
                    })
                ]
            })), rootEl);
        }
    });
};

;// ./src/components/Lightbox/useLightboxControl.ts
function useLightboxControl_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useLightboxControl_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useLightboxControl_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useLightboxControl_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useLightboxControl_sliced_to_array(arr, i) {
    return useLightboxControl_array_with_holes(arr) || useLightboxControl_iterable_to_array_limit(arr, i) || useLightboxControl_unsupported_iterable_to_array(arr, i) || useLightboxControl_non_iterable_rest();
}
function useLightboxControl_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useLightboxControl_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useLightboxControl_array_like_to_array(o, minLen);
}



/**
 * Hook for managing lightbox dialog state
 */ var useLightboxControl = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_initialIsOpen = _ref.initialIsOpen, initialIsOpen = _ref_initialIsOpen === void 0 ? false : _ref_initialIsOpen, onClose = _ref.onClose, onOpen = _ref.onOpen, onToggle = _ref.onToggle, idProp = _ref.id;
    var _useState = useLightboxControl_sliced_to_array((0,external_react_namespaceObject.useState)(initialIsOpen), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = idProp || reactId;
    var labelId = (0,external_react_namespaceObject.useId)();
    var descriptionId = (0,external_react_namespaceObject.useId)();
    var open = (0,external_react_namespaceObject.useCallback)(function() {
        if (isOpen) {
            return;
        }
        setIsOpen(true);
        if (onToggle) {
            onToggle(true);
        }
        return wait(Lightbox_ANIMATION_DURATION, onOpen ? function() {
            return onOpen();
        } : undefined);
    }, [
        onOpen,
        onToggle,
        isOpen
    ]);
    var close = (0,external_react_namespaceObject.useCallback)(function() {
        if (!isOpen) {
            return;
        }
        setIsOpen(false);
        if (onToggle) {
            onToggle(false);
        }
        return wait(Lightbox_ANIMATION_DURATION, onClose ? function() {
            return onClose();
        } : undefined);
    }, [
        onClose,
        onToggle,
        isOpen
    ]);
    var toggle = function() {
        setIsOpen(!isOpen);
        if (onToggle) {
            onToggle(!isOpen);
        }
        if (!isOpen) {
            return wait(Lightbox_ANIMATION_DURATION, onOpen ? function() {
                return onOpen();
            } : undefined);
        }
        if (isOpen) {
            return wait(Lightbox_ANIMATION_DURATION, onClose ? function() {
                return onClose();
            } : undefined);
        }
    };
    var labelProps = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            id: labelId
        };
    }, [
        labelId
    ]);
    var descriptionProps = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            id: descriptionId
        };
    }, [
        descriptionId
    ]);
    var rootProps = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            id: id,
            isOpen: isOpen,
            role: 'dialog',
            'aria-modal': true,
            'aria-labelledby': labelId,
            'aria-describedby': descriptionId,
            tabIndex: -1,
            close: close
        };
    }, [
        id,
        isOpen,
        labelId,
        descriptionId,
        close
    ]);
    return {
        isOpen: isOpen,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        rootProps: rootProps,
        // these return promises but don't declare that in the type
        // it's a large change to fix that so we'll just ignore it
        open: open,
        close: close,
        toggle: toggle
    };
};

;// ./src/components/Lightbox/CloseButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CloseButton = ({"button":"WT4nQs qdKc3_"});
;// ./src/components/Lightbox/CloseButton.tsx
function CloseButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CloseButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CloseButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CloseButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CloseButton_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CloseButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CloseButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = CloseButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CloseButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




/**
 * Default modal close button.
 */ var CloseButton_CloseButton = function(_param) {
    var className = _param.className, props = CloseButton_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", CloseButton_object_spread_props(CloseButton_object_spread({
        type: "button",
        "aria-label": "close",
        className: (0,external_classnames_namespaceObject["default"])(CloseButton.button, className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Close, {})
    }));
};

;// ./src/components/Lightbox/index.ts




;// external "react-router-dom"
var external_react_router_dom_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_react_router_dom_y = (x) => (() => (x))
const external_react_router_dom_namespaceObject = external_react_router_dom_x({ ["Link"]: () => (__WEBPACK_EXTERNAL_MODULE_react_router_dom_a27720b7__.Link), ["NavLink"]: () => (__WEBPACK_EXTERNAL_MODULE_react_router_dom_a27720b7__.NavLink) });
;// ./src/components/Link/Link.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Link = ({"link":"wXb2Ef","as-button":"EUN6nH","asButton":"EUN6nH"});
;// ./src/components/Link/linkType.ts
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
/**
 * Determines if the props provided are for a react-router Link component
 */ function isLink(props) {
    if ((typeof props === "undefined" ? "undefined" : _type_of(props)) !== 'object' || !props) {
        return false;
    }
    var keys = Object.keys(props);
    return keys.includes('to') && Boolean(props.to);
}
/**
 * Determines if the props provided are for a react-router NavLink component
 */ function isNavLink(props) {
    if ((typeof props === "undefined" ? "undefined" : _type_of(props)) !== 'object' || !props) {
        return false;
    }
    var keys = Object.keys(props);
    return keys.includes('activeClassName') || keys.includes('activeStyle');
}
/**
 * Determines if the props provided are for an anchor element
 */ function isAnchor(props) {
    if ((typeof props === "undefined" ? "undefined" : _type_of(props)) !== 'object' || !props) {
        return false;
    }
    var keys = Object.keys(props);
    return keys.includes('href') && Boolean(props.href);
}

;// ./src/components/Link/Link.tsx
function Link_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Link_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Link_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Link_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Link_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Link_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Link_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Link_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Link_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







function isAnchorLink(item) {
    return Boolean(!item.to && item.href);
}
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/link | Link} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Link_Link = function(_param) {
    var _param_asButton = _param.asButton, asButton = _param_asButton === void 0 ? false : _param_asButton, variant = _param.variant, mode = _param.mode, highContrast = _param.highContrast, className = _param.className, children = _param.children, hover = _param.hover, active = _param.active, asPill = _param.asPill, asMini = _param.asMini, props = Link_object_without_properties(_param, [
        "asButton",
        "variant",
        "mode",
        "highContrast",
        "className",
        "children",
        "hover",
        "active",
        "asPill",
        "asMini"
    ]);
    var designClass = asButton ? getButtonDesign_getButtonDesign({
        variant: variant !== 'tertiary' ? variant : undefined,
        active: active,
        hover: hover,
        asPill: asPill,
        asMini: asMini,
        disabled: props.disabled
    }) : getLinkDesign_getLinkDesign({
        variant: variant,
        mode: mode,
        active: active,
        hover: hover,
        disabled: props.disabled,
        highContrast: highContrast
    });
    var linkProps = Link_object_spread_props(Link_object_spread({}, props), {
        className: (0,external_classnames_namespaceObject["default"])(className, Link.link, designClass, asButton && Link.asButton)
    });
    if (props.disabled) {
        linkProps['aria-disabled'] = true;
    }
    if (isAnchor(linkProps)) {
        var _omit = (0,omit_namespaceObject["default"])(linkProps, [
            'activeClassName'
        ]), className1 = _omit.className, restProps = Link_object_without_properties(_omit, [
            "className"
        ]);
        return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("a", Link_object_spread_props(Link_object_spread({}, restProps), {
            className: (0,external_classnames_namespaceObject["default"])(className1),
            children: children
        }));
    }
    if (isNavLink(linkProps)) {
        return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_router_dom_namespaceObject.NavLink, Link_object_spread_props(Link_object_spread({}, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_router_dom_namespaceObject.Link, Link_object_spread_props(Link_object_spread({}, linkProps), {
        children: children
    }));
};

;// ./src/components/Link/index.ts


;// ./src/components/Radio/Radio.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Radio = ({"container":"feeYkp"});
;// ./src/components/Radio/Radio.tsx
function Radio_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Radio_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Radio_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Radio_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Radio_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Radio_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Radio_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Radio_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Radio_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/radiobutton | RadioButton} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Radio_Radio = function(_param) {
    var label = _param.label, color = _param.color, props = Radio_object_without_properties(_param, [
        "label",
        "color"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(LabeledSelector_LabeledSelector, Radio_object_spread_props(Radio_object_spread({
        className: Radio.container
    }, props), {
        type: "radio",
        color: color,
        children: label
    }));
};

;// ./src/components/Radio/RadioView.tsx


var RadioView = function(param) {
    var state = param.state, checked = param.checked;
    var inputDesign = getRadioDesign_getRadioDesign({
        state: state,
        checked: checked
    });
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
        className: inputDesign
    });
};

;// ./src/components/Radio/index.ts



;// ./src/components/ScrollSnap/ScrollSnap.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ScrollSnap = ({"container":"ORsqNR","item":"WbrDZW"});
;// ./src/components/ScrollSnap/ScrollSnap.tsx
function ScrollSnap_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ScrollSnap_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ScrollSnap_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ScrollSnap_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ScrollSnap_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ScrollSnap_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ScrollSnap_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ScrollSnap_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ScrollSnap_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/**
 * Wraps child elements in a scroll-snap parent, ensuring one child
 * is always centered in the parent.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/scrollsnap | ScrollSnap} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ScrollSnapComponent = function(_param) {
    var _param_as = _param.as, as = _param_as === void 0 ? 'div' : _param_as, children = _param.children, className = _param.className, forwardedRef = _param.forwardedRef, props = ScrollSnap_object_without_properties(_param, [
        "as",
        "children",
        "className",
        "forwardedRef"
    ]);
    var Component = as;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Component, ScrollSnap_object_spread_props(ScrollSnap_object_spread({
        ref: forwardedRef,
        className: (0,external_classnames_namespaceObject["default"])([
            ScrollSnap.container,
            className
        ])
    }, props), {
        children: external_react_namespaceObject.Children.map(children, function(child) {
            if (!/*#__PURE__*/ external_react_namespaceObject.isValidElement(child)) {
                return child;
            }
            var className = (0,external_classnames_namespaceObject["default"])(child.props.className, ScrollSnap.item);
            return /*#__PURE__*/ external_react_namespaceObject.cloneElement(child, {
                className: className
            });
        })
    }));
};
var ScrollSnap_ScrollSnap = withRef(ScrollSnapComponent);

;// ./src/components/ScrollSnap/index.ts


;// ./src/components/Text/index.ts

// TODO: Remove these exports when website no longer uses TextV2
// This V2 export is to make the rename a none breaking change


;// ./src/components/AppBar/constants.ts
var LOGO_SIZE = 74;
var LOGO_TRANSLATE = 12;
var SHADOW_OPACITY = 0.12;

;// ./src/components/AppBar/CallToAction.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CallToAction = ({"container":"RnmUzF","padding":"n__mKT","link":"Q57MYT","fullWidth":"tIK1F0"});
;// ./src/components/AppBar/CallToAction.tsx
function CallToAction_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var CallToAction_CallToAction = function(param) {
    var href = param.href, to = param.to, title = param.title, onClick = param.onClick, _param_asPill = param.asPill, asPill = _param_asPill === void 0 ? false : _param_asPill, _param_withPadding = param.withPadding, withPadding = _param_withPadding === void 0 ? false : _param_withPadding, isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
        "data-name": "CallToAction",
        className: (0,external_classnames_namespaceObject["default"])(CallToAction.container, CallToAction_define_property({}, CallToAction.padding, withPadding)),
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, {
            className: (0,external_classnames_namespaceObject["default"])(isMobile ? CallToAction.fullWidth : undefined),
            asButton: true,
            asPill: asPill,
            to: to,
            href: href,
            variant: "primary",
            onClick: onClick,
            children: title
        })
    });
};

;// ./src/styles/colors/palette.ts
var KALE_0 = '#E5EFE7';
var KALE_1 = '#b5d3ba';
var KALE_2 = '#417C67';
var KALE_3 = '#173b33';
var BLUEBERRY_0 = '#E6ECF5';
var BLUEBERRY_1 = '#B7C6E6';
var BLUEBERRY_2 = '#385A9D';
var BLUEBERRY_3 = '#03184E';
var CARROT_0 = '#FFF4F1';
var CARROT_1 = '#FFD9CC';
var CARROT_2 = '#f2674b';
var CARROT_3 = '#D2563D';
var CHARCOAL_0 = '#c2c3c5';
var CHARCOAL_1 = '#969799';
var CHARCOAL_2 = '#717377';
var CHARCOAL_3 = '#39383C';
var CHICKPEA_0 = '#FFFAF3';
var CHICKPEA_1 = '#fff3e1';
var CHICKPEA_2 = '#f2e1c8';
var CHICKPEA_3 = '#D3BFA2';
var OYSTER_0 = '#F6F5F3';
var OYSTER_1 = '#EFEDEA';
var OYSTER_2 = '#DBD6D1';
var OYSTER_3 = '#C6BFB7';
var TFD_LOGO = '#F5694D';
var WHITE = '#ffffff';
var ERROR_RED = '#f54c5a';

;// ./src/components/Logo/assets/background.svg
function background_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function background_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            background_define_property(target, key, source[key]);
        });
    }
    return target;
}
function background_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function background_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        background_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgBackground = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", background_object_spread_props(background_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 463.097 421.318"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M462.672 182.35c-.012-.163-.032-.325-.048-.488-.5-5-.836-10.029-1.551-14.991-.612-4.2-1.258-8.326-1.308-7.665-2.914-17.292-8.7-34.369-15.9-50.368-6.136-13.631-13.662-26.749-23.42-37.983-5.853-6.737-12.451-12.735-19.03-18.714-2.952-2.682-5.905-5.365-8.953-7.927a151.248 151.248 0 00-37.873-23.308 310.565 310.565 0 00-7.751-3.167c-.864-.512-1.72-1.026-2.548-1.547-2.325-1.463-8.026-3.29-8.026-3.29s-7.842-2.768-10.844-3.368c-1.494-.3-3.722-.692-6.4-1.134q-6.142-1.671-12.28-2.958c-6.88-1.433-13.828-2.415-20.784-3.2Q269.271.367 252.526.018C242.1-.2 232.76 1.6 222.553 3.281A406.836 406.836 0 00172.6 14.758a204.233 204.233 0 00-26.066 9.6c-9.7 4.4-17.621 10.631-27.682 14.484C94 48.355 75.719 65.663 55.934 82.924c-8.788 7.667-17.7 15.469-24.546 25.106-7.141 10.052-12.328 21.92-17.364 33.251C3.142 165.765 1.1 196.228.165 223.149c-.09 2.586.068 6.762-.076 8.419.468 6.235-.286 3.067-.037 7.126-.13 1.23.188 5.536.521 9.684.4 4.623.651 7.911.323 6.568.571 5.377.91 8.745 1.007 10.025a786.428 786.428 0 001.254 10.184 57.24 57.24 0 00.919 5.981c.073-.035.878 5.113 1.751 10.475 1.183 7.683 1.217 6.487 1.259 5.051.266.238.982 3.549 1.786 7.22.592 2.076 1.193 3.93 2.06 7.459 6.195 14.582 11.137 28.565 20.576 41.545a126.592 126.592 0 0034.15 32.314c3.878 2.469 7.879 4.712 11.879 6.954a72.044 72.044 0 009.863 4.887c5.6 2.09 11.549 2.705 17.335 4.047 14.7 3.411 28.461 11.589 43.45 13.428 16.723 2.051 33.636 3.625 50.417 5.4 26.695 2.818 52.239.986 78.642-1.881 9.925-1.077 19.7-3.553 29.32-6.169 9.589-2.608 19.483-4.03 28.962-7.216 10.562-3.549 20.472-8.694 30.492-13.5 8.677-4.165 16.426-8.511 23.418-15.25a146.925 146.925 0 0013.48-15.338c4.039-5.153 8.606-9.748 12.571-14.985 2.026-2.676 4.036-5.583 6.027-8.653.038.07.07.146.11.215 4.455-7.817 9.281-14.548 13.982-22.13 4.747-7.657 6.733-16.236 9.664-24.7 3-8.675 7-17.349 10-26.023 2.916-8.427 5.336-36.186 6.535-44.906.1-.739.093-1.124-.007-1.222a204.619 204.619 0 00.874-35.808z"
        })
    }));
};
/* harmony default export */ const background = (SvgBackground);

;// ./src/components/Logo/assets/text.svg
function text_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function text_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            text_define_property(target, key, source[key]);
        });
    }
    return target;
}
function text_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function text_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        text_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgText = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("svg", text_object_spread_props(text_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 463.097 421.318"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M100.925 184.68c-.757-3.7-7.039-4.138-10.057-4.416a25.954 25.954 0 00-9.326.527c-4 1.1-7.9 2.524-11.831 3.856-2 .678-4.008 1.336-6.041 1.914-2.73.777-5.222 2.228-8.037 2.736-.834.15-1.681.221-2.521.34-1.074.152-3.517.308-4.344 1.045-.516.46-.344 1.18-.345 1.779a19.52 19.52 0 01-.254 2.584c-.577 4.163-1.352 8.31-2.064 12.452-1.18 6.986-2.584 13.954-3.607 20.962-.524 3.586-.91 7.189-1.273 10.794-.091.9-.189 1.8-.357 2.693a54.02 54.02 0 00-.839 5.968 35.275 35.275 0 01-.446 3.6c-.526 2.908-.776 5.855-1.055 8.8-.144 1.513-.29 3.027-.486 4.535-.136 1.048-.6 2.4.062 3.352.736 1.061 1.342 2.206 2.114 3.244a12.48 12.48 0 004.6 3.572c3.279 1.4 8.351 1.183 10.013-2.464a18.193 18.193 0 001.2-4.643c.592-3.614 1.087-7.4 1.663-11.076.307-1.961.64-3.918 1.034-5.864q.283-1.4.61-2.792c.313-1.318.79-4.215 2.24-4.654 1.713-.517 3.479-.061 5.3-.754 1.727-.655 3.334-1.608 5.1-2.165a23.779 23.779 0 003.743-1.236 15.68 15.68 0 003.351-2.769 2.348 2.348 0 00.421-.623 25.535 25.535 0 002.267-5.484c.222-.871 1.2-3.278.862-4.047-.348-.784-1.333-1.171-1.942-1.711-3.093-2.741-10.243-2.058-13.725-.613-1.383.574-2.918 1.764-3.607-.065-.521-1.383.083-3.195.159-4.633a52.187 52.187 0 01.518-6.306c.348-1.986.938-3.914 1.444-5.862.465-1.792.438-4.08 1.75-5.309a3.635 3.635 0 001.009.1 5.267 5.267 0 01.879-.115c9.129.236 18.38-2.837 26.469-6.98 1.64-.839 3.561-1.843 4.5-3.511a4.612 4.612 0 00.4-2.523c.012-1.383.712-2.721.474-4.112l-.025-.126zM222.247 224.05q.361-3.642.725-7.284a24.928 24.928 0 01.913-5.285 8.6 8.6 0 012.07-3.754 11.576 11.576 0 011.877-1.027c.661-.39 1.266-.814 1.948-1.164s1.055-.852 1.706-1.217c.349-.2.713-.368 1.077-.535.243-.111.474.045.538.34.01.049.02.1.032.147a13.332 13.332 0 01.237 3.9c-.066 1.2-.183 2.408-.278 3.611q-.165 2.106-.332 4.21c-.012.15-.034.3-.055.449-.247 1.743-.5 3.485-.742 5.228-.077.548-.116 1.1-.212 1.645a12.763 12.763 0 00-.173 2.405c.021 1.426.046 2.851.059 4.277a8.462 8.462 0 001.632 4.305c2.14 3.345 5.021 4.459 8.284 1.228.712-.7 2.013-.963 2.12-2.049.746-7.595 1.858-15.558 3.187-23.106a47.866 47.866 0 001.095-11 14.05 14.05 0 00-1.692-6.617 8.654 8.654 0 00-4.558-3.266c-3.653-1.449-7.543-3.146-11.553-2.612a10.616 10.616 0 00-3.656 1.018 19.971 19.971 0 00-3.542 2.951 21.056 21.056 0 00-3.466 3.493l-.788 1.1a.692.692 0 01-.8.265c-1.66-.383-3.283-.944-4.915-1.424a13.791 13.791 0 00-12.321 2.818c-.186.169-.379.33-.573.489-.078.064-.165.115-.249.171a.517.517 0 01-.565-.04 22.267 22.267 0 00-1.852-1.281c-1.051-.722-2.9-2.2-4.247-2.041a2.523 2.523 0 01-.6.069c-.353-.044-.6-.364-.916-.526a1.494 1.494 0 00-1.859.782c-.512.973-.273 2.224-.516 3.282-1.345 5.863-2.9 11.622-3.853 17.6A186.611 186.611 0 00183 234.792c-.082 1.456-.086 2.917-.121 4.376-.051 2.146 3.043 5.811 5 6.545 1.994.746 4.532-.31 6.486-.79a.953.953 0 00.572-.456 7.184 7.184 0 00.92-2.375 30.149 30.149 0 01.657-3.091 22.067 22.067 0 00.865-6.746c.064-3.383.826-6.592 1.224-9.928.262-2.2.814-4.346 1.243-6.515a1.938 1.938 0 01.8-1.232c.931-.686 1.831-1.414 2.752-2.114a9.749 9.749 0 01.881-.578c.861-.517 1.77-.968 2.581-1.553a29.674 29.674 0 013.726-2.261c.06-.031.175.027.255.063a.148.148 0 01.049.126 8.984 8.984 0 01-.2 1.037c-.6 2.03-.973 4.109-1.377 6.183a15.945 15.945 0 01-.526 2.043c-.821 2.437-1.206 4.978-1.821 7.464a40.865 40.865 0 00-.652 3.253 12.637 12.637 0 00-.277 2.693 10.167 10.167 0 002.206 6.327l2.106 2.661a4.061 4.061 0 001.064 1.048c.941.553 2.139.308 3.175.4 1.106.095 2.21.222 3.322.284a1.351 1.351 0 001.2-.514 10.471 10.471 0 00.682-.99c.208-.344.358-.723.575-1.06a2.55 2.55 0 00.389-1.121c.16-1.345.291-2.7.568-4.022.238-1.136.373-2.278.533-3.423.305-2.171.174-4.316.39-6.476zM207.63 146.131a134.627 134.627 0 00.722-17.734 31.181 31.181 0 00-2.956-8.453 14.458 14.458 0 00-7.342-7c-2.8-1.051-5.877-.9-8.857-.737-1.777.1-3.555-.027-5.141.895-.478.278-.983.509-1.479.753a1.323 1.323 0 01-.423.139.332.332 0 01-.248-.124c-.221-.29-.135-.724-.429-1a11.571 11.571 0 00.256-2.148 21.986 21.986 0 01.581-3.548c.339-1.728.445-3.465.774-5.207a17.161 17.161 0 00.44-4.186 5.776 5.776 0 00-1.559-3.819 8.564 8.564 0 00-2.245-1.422 6.486 6.486 0 00-1.853-.695c-1.123-.176-2.351-.291-3.481-.4a30.156 30.156 0 00-8.268.369 2.482 2.482 0 00-.568.2.548.548 0 00-.352.452 10.593 10.593 0 01-.584 2.8 4.175 4.175 0 00-.1 1.791 1.585 1.585 0 00.425.944 5.676 5.676 0 00.655.623c.218.18.464.3.673.488-.613 1.353-.5 3.3-.656 4.78l-.582 5.356-.895 8.248c-.263 2.425-.238 5.12-1.024 7.442a29.971 29.971 0 00-.974 4.259c-.888 4.873-1.668 9.767-2.483 14.658a82.79 82.79 0 00-1.072 10.778 2.826 2.826 0 00-.027 1.04 1.6 1.6 0 01.083 1.148c.313.478.253 1.094.676 1.561a2.878 2.878 0 00.795 1.633 2.359 2.359 0 010 .337c-.119 1.944 2 3.655 3.685 3.959a11.546 11.546 0 004.341-.284c1.694-.348 3.374-.757 5.054-1.166a4.788 4.788 0 003.958-3.913q.777-4.176 1.462-8.368.768-4.712 1.417-9.441.332-2.426.633-4.855c.089-.715-.083-3.516.779-3.766.481-.139.981-.217 1.461-.359 1.655-.487 2.738-1.835 3.794-3.109a40.387 40.387 0 014.075-3.924.54.54 0 01.57-.073.944.944 0 01.734.854c.457 9.51-2.61 18.882-2.729 28.432-.023 1.8.272 4.675 2.148 5.582 1.631.789 3.78.307 5.541.292a7.137 7.137 0 003.69-.81 8.381 8.381 0 00.807-.582 14.761 14.761 0 003.765-3.509 14.473 14.473 0 001.607-5.129q.365-2.03.726-4.052zM242.081 119.176zM255.6 121.515a1.76 1.76 0 00-.248-.712 2.549 2.549 0 00-.145-.24c-.006-.044-.011-.087-.019-.132a8.752 8.752 0 00-.419-1.591 5.539 5.539 0 00-.732-1.5.99.99 0 00-.09-.1 2.138 2.138 0 00-.485-.875c-.231-.266-.456-.546-.71-.788-.963-1.662-2.96-2.837-4.553-3.764a25.515 25.515 0 00-3.692-1.754 4.852 4.852 0 00-1.275-.643 9.008 9.008 0 00-1.308-.509 5.6 5.6 0 00-2.309-.64 54.259 54.259 0 00-3.8-.121c-2.987-.247-6.2-.143-8.774 1.126a15.8 15.8 0 00-1.8.651 31.228 31.228 0 00-2.488 2.036 19.745 19.745 0 00-1.954 1.959c-.757.9-1.452 1.857-2.124 2.824a27.219 27.219 0 00-3.674 6.9c-.4 1.216-.82 2.429-1.185 3.657a15.681 15.681 0 00-.675 5.576 16.657 16.657 0 00.462 4.321c.914 3.489 1.619 6.253 4.23 8.859l2.193 2.189c6.282 6.27 15.713 5.034 23.474 2.377 3.361-1.151 6.071-2.986 7.052-6.553a7.259 7.259 0 00.193-1.626 9.088 9.088 0 00-.688-4.155c-.072-.136-.124-.283-.2-.416a.4.4 0 01-.054-.187c-.385-.308-.758-.632-1.14-.943a1.258 1.258 0 01-.182-.183 45.242 45.242 0 01-1.971-.208 10.04 10.04 0 00-4.25.444c-1.567.479-3.1 1.069-4.654 1.593a92.483 92.483 0 01-3.511 1.129 7.133 7.133 0 01-4.095-.056 5.25 5.25 0 01-2.6-1.818.793.793 0 010-1 12.1 12.1 0 011.392-1.2 13.084 13.084 0 011.733-.994 4.024 4.024 0 012.424-.8c.181.027.386-.118.584-.171a1.433 1.433 0 01.583-.116 4.735 4.735 0 001.669-.19 22.094 22.094 0 005.929-1.548 5.118 5.118 0 01.873-.293 42.691 42.691 0 005.643-1.99 12.648 12.648 0 011.872-.681 5.573 5.573 0 001.423-.553 32.98 32.98 0 001.862-1.081c.567-.349 1.128-.71 1.671-1.095a1.226 1.226 0 00.579-1.032c-.013-1.128-.004-2.256-.037-3.383zm-12.225-.485c-1.694.37-3.327.969-5.045 1.263a19.768 19.768 0 00-3.1.95 17.959 17.959 0 01-3.767.968 10.675 10.675 0 00-3.878 1.13 3.214 3.214 0 01-1.245.345c-.046 0-.13-.025-.138-.056a.437.437 0 01-.024-.281c.014-.025.03-.047.044-.071a.463.463 0 01.006-.307c.905-2.675 3.763-3.963 6.14-5.078a15.191 15.191 0 014.545-1.58 16.4 16.4 0 014.683.359 3.1 3.1 0 001.33.624c.1.016.192.038.286.063a2.968 2.968 0 00.782.536 2.829 2.829 0 00.395.744 4.533 4.533 0 01-1.014.391zM180.353 211.62a3.486 3.486 0 00.926-4.02 10.906 10.906 0 00-.7-1.639 3.85 3.85 0 00-1.208-1.328 24.425 24.425 0 00-8.381-3.461 15.531 15.531 0 00-10.074.608 5.262 5.262 0 00-.937.485c-.79.535-1.564 1.1-2.342 1.65-.245.175-.477.369-.724.542a.883.883 0 01-.856.127 12.022 12.022 0 01-2.213-.925 11.156 11.156 0 00-2.057-.924 9.862 9.862 0 00-3.43-.355.944.944 0 00-.15.017 2.452 2.452 0 00-2.1 1.5 3.9 3.9 0 01-.632 1.022 6.55 6.55 0 00-.8 2.755 71.835 71.835 0 00-.8 3.921c-.479 2.708-.819 5.438-1.089 8.174-.775 7.85-1.046 15.349-1.133 23.232-.033 2.983 1.209 5.49 2.4 8.146a2.753 2.753 0 001.186 1.317c.218.123.411.288.622.426 2.075 1.362 4.783.741 6.8-.408 2.384-1.356 3.133-3.653 3.058-6.363a43.674 43.674 0 01.742-9.616c.348-1.772.773-3.528 1.2-5.283.689-2.852.487-5.328 2.2-7.766a55.949 55.949 0 015.72-6.576c1.786-1.847 4.857-4.053 7.637-3.987a22.762 22.762 0 003.9.2 6.676 6.676 0 002.5-.933 5.121 5.121 0 00.735-.538zM355.292 156.472v.006l.022-.041v.005c-.014.007-.023.009-.034.014l.01.019zM291.847 191.216a9.872 9.872 0 00-.533-1.353c-.572-1.268-1.057-3.268-1.986-4.3a31.389 31.389 0 00-3.008-2.726c-1.258-1.052-2.7-2.607-4.2-3.264a7.078 7.078 0 00-3.116-.355 37.315 37.315 0 00-9.133 1.055 8.029 8.029 0 01-1.164.309 5.208 5.208 0 00-2.091.805 6.062 6.062 0 01-.656.371 7.3 7.3 0 00-3.042 2.845c-.434.676-.91 1.325-1.359 1.992a21.986 21.986 0 00-1.235 1.887 37.074 37.074 0 00-2.543 5.8 12.848 12.848 0 01-1.014 2.516.988.988 0 00-.135.424 6.585 6.585 0 01-.515 1.885 42.643 42.643 0 00-1.955 9.588c-.4 3.348-.884 6.819.506 10.02a16.7 16.7 0 002.3 3.6 17.8 17.8 0 002.609 2.806 20.629 20.629 0 004.06 2.411 28.069 28.069 0 0016.531 2.141c2.188-.336 5.175-.8 6.568-2.723a6.4 6.4 0 00.973-3.223c.078-.873.587-4.329-.1-4.991a1.909 1.909 0 01-.519-.6 10.1 10.1 0 00-1.1-1.6 2.857 2.857 0 00-1.351-1.146 7.8 7.8 0 00-.983-.368c-.721-.215-1.454-.391-2.172-.617a17.4 17.4 0 00-3.239-.64c-1-.116-1.991-.254-3-.282a.164.164 0 01-.174-.2c0-.046.008-.111.037-.133.48-.361.965-.714 1.445-1.075 1.638-1.23 3.247-2.451 4.926-3.654 1.595-1.143 2.912-2.658 4.583-3.688a17.3 17.3 0 005.506-4.869 6.116 6.116 0 00.976-2.663 16 16 0 00-.345-3.565 16.113 16.113 0 00-.352-2.42zm-11.347 3.058a4.041 4.041 0 01-1.066.825c-1.138.643-2.245 1.343-3.393 1.967a36.007 36.007 0 00-6.852 4.9c-.484.435-1.027.805-1.549 1.2a.476.476 0 01-.551-.087 1.026 1.026 0 01-.349-.8 3.014 3.014 0 01.384-1.444c.439-.688.453-1.537.865-2.233a4.618 4.618 0 01.361-1.755c.139-.32.289-.636.433-.954a1.478 1.478 0 01.738-.711 22.057 22.057 0 002.659-1.71c.284-.2.594-.364.892-.545.61.042 1.14-.385 1.77-.285a3.268 3.268 0 001.049 0 8.718 8.718 0 013.577.327 1.769 1.769 0 011.091.758.987.987 0 01.077.28 1.2 1.2 0 01-.136.267z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M266 227.946l.03.028-.024-.027zM130.545 324.323l-.033.037.007.006-.007.01.028.008z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M175.233 300.475a29.57 29.57 0 00-.23-2.32 14.006 14.006 0 00-2.046-7.964 29.243 29.243 0 00-2.171-4.636 7.308 7.308 0 00-1.256-2.052 7.138 7.138 0 00-1.583-1.917 27.091 27.091 0 00-8.218-6.851 6.907 6.907 0 00-2.933-1.668l-3.43-1.294a3.715 3.715 0 00-.5-.147 35.156 35.156 0 00-5.013-1.315 8.522 8.522 0 00-1.183-.126c-2.062-.5-4.439-.056-6.493.236a69.179 69.179 0 00-7.289 1.436 27 27 0 00-4.361 1.423c-1.405.624-2.714 1.436-4.095 2.108-.421.205-3.981 1.211-4.012 1.338-.009.039-.021.074-.031.11l-.044.015a4.639 4.639 0 00-1.224.631c-.1.04-.213.1-.315.134a.294.294 0 00-.205.312 3.962 3.962 0 00-1.04 3.4c.233 1.511-.834 4.137-1.138 5.635 0 2.326-1 5.056-1.461 7.349l-.036.052a1.163 1.163 0 00-.188 1.051 133.329 133.329 0 00-2.155 14.591c-.4 4.257-1.2 8.46-1.819 12.688-.312 2.13-.579 4.269-.721 6.419a32.186 32.186 0 00-.2 6.082c.1.792.366 1.555.507 2.342a10.466 10.466 0 00.405 2 6.287 6.287 0 002.245 2.484l10.059 7.713a3.368 3.368 0 001.915.534c5.374.606 9.906-1.824 14.386-4.508q3.213-1.926 6.4-3.888a48.722 48.722 0 004.322-2.881c3.059-2.363 5.515-5.455 8.711-7.641a14.312 14.312 0 001.533-1.107c.994-.889 1.749-2.037 2.705-2.975q1.585-1.555 3.032-3.246a54.705 54.705 0 005.227-7.192 28.138 28.138 0 003.97-13.469q.056-1.443-.027-2.886zm-19.873 2.572c-3 6.878-8.02 12.571-13.663 17.414a38.487 38.487 0 01-3.775 2.961 35.781 35.781 0 00-3.729 2.8c-.9.785-1.88 1.49-2.837 2.213a.933.933 0 01-1.335-.191c-.1-.116-.183-.243-.269-.368a16.094 16.094 0 01.45-2.588c.459-2.236.417-4.713.652-7q.376-3.674.759-7.347l.59-5.681.216-2.079.643-6.2c.128-1.23.1-4.924 1.258-5.688a.34.34 0 01.5.12c0-.5.507-.834.963-1.037 2.28-1.017 4.78-.977 7.218-1.2a18.085 18.085 0 017.908.644l.048.018a9.838 9.838 0 015.782 5.312c1.037 2.693-.299 5.423-1.379 7.897z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M174.329 309.976l.043-.025-.042.022-.001.003zM226.685 357.155c-.01-.013-.021-.021-.031-.032h-.009l.021.019-.021-.019c0 .02.012.039.018.059l.025-.02z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M226.489 357.332c-.018.019 0 .1.025.121.088.076.177.047.192-.075a.494.494 0 00-.043-.2 1.6 1.6 0 00-.174.154zM218.262 308.357c1.195-2.557 1.2-5.32 1.391-8.064a20.247 20.247 0 00-.261-5.989 13.2 13.2 0 00-.771-2.347 32.892 32.892 0 00-12-13.2 11.675 11.675 0 00-4.275-1.555c-1.7-.166-3 .719-4.482 1.4a53.024 53.024 0 00-5.159 2.243 19.014 19.014 0 00-6.27 6.609c-3.752 5.9-7.377 12.382-7.151 19.37a35.1 35.1 0 00.6 4.851c.308 1.768.654 4.6 1.637 6.1a38.777 38.777 0 012.493 3.666 14.81 14.81 0 004.517 5.362c.344.281.669.6 1 .887a4.652 4.652 0 001.219.565 17.63 17.63 0 005.653 1.566 12.6 12.6 0 005.446-.589c.18-.083.334-.23.519-.293a9.31 9.31 0 001.426-.458 7.149 7.149 0 011.266-.773 3.8 3.8 0 001.018-.616 12.558 12.558 0 001.185-.924c1.491-1.288 2.522-3.414 3.636-5.029l4.005-5.808c.637-.924.915-2.42 1.467-3.453m-11.271-9.571c-.38 1.049-.9 2.045-1.373 3.056a24.8 24.8 0 01-1.128 2.209 16.594 16.594 0 01-1.371 1.929c-.153.189-.309.376-.466.561-.484.568-1.139 1.091-1.561 1.694-.127.18-.22.382-.345.563-.333.482-.859.791-1.187 1.276-.38.563-.672 1.217-1.029 1.8a4.592 4.592 0 01-.446.6.428.428 0 01-.649-.074 10.192 10.192 0 01-.927-5.914c.342-1.892.683-3.785 1.121-5.657a13.849 13.849 0 012.022-5.084c.94-1.293 2.258-2.256 3.191-3.552a7.388 7.388 0 011.315-1.744c.637-.5 1.467-.662 2.124-1.129a1.132 1.132 0 01.443-.155c1.118-.223 2.656-.616 2.585 1-.007.151-.042.3-.035.45.146 2.8-1.353 5.604-2.284 8.171zM264.377 296.193l-.028-.054h-.037l-.036.017.1.029zM175.145 304.515l-.03.038.038-.021zM175.145 304.515c.016-.021.031-.04.028-.042-.065-.066-.073-.049-.028.042zM174.426 310.029l-.067-.036-.02.061zM383.527 168.173h.027v-.373h-.026l-.001.373zM134.917 250.347a41.077 41.077 0 01-2.725-2.4c-.621-.6-1.937-1.556-2.265-2.336a8.031 8.031 0 00-.831-1.712 1.146 1.146 0 01-.1-.174c1.077-8.186.822-16.795 2.472-24.864.3-1.471.543-2.846.7-4.334a14.748 14.748 0 01.428-2.006q-.082-.269-.188-.531c-.961-2.389-3.009-3.4-5.04-4.849-.734-.523-1.5-.908-2.234-1.446a4.267 4.267 0 00-2.321-.834.456.456 0 00-.545.374c-.254.8-.49 1.6-.769 2.386-.218.614-.431.7-.991.414-1.971-1.008-3.607-2.6-5.923-2.79a9.089 9.089 0 00-2.436.208 29.189 29.189 0 00-5.921 1.755 9.285 9.285 0 00-3.46 3.129A71.975 71.975 0 0089.8 238.351a27.313 27.313 0 00-.561 3.5 23.875 23.875 0 00.235 5.01 10.561 10.561 0 00.618 2.73 10.662 10.662 0 01.5 1.849c.926 4.2 3.207 8.018 7.614 9.318 2.457.724 5.087.183 7.589-.362a19.411 19.411 0 006.035-2.042 14.391 14.391 0 003.923-4.134.65.65 0 01.207-.2.924.924 0 00.621-.75c.006-.063.137-.144.223-.164a1.366 1.366 0 011.01 0 3.054 3.054 0 001.277.307c1.437.14 2.507 1.048 3.813 1.468s2.686.558 4.018.9c1.251.318 2.386.96 3.641 1.288a6.186 6.186 0 002.177-.234.8.8 0 00.513-.265 3.484 3.484 0 01.893-.759.924.924 0 00.295-.323 15.313 15.313 0 001.147-3.309 1.249 1.249 0 00.034-.293 1.784 1.784 0 00-.705-1.539zM118.1 220.834c-.935 3.593-1.6 7.247-2.3 10.892-.645 3.377-1.9 6.968-1.768 10.427a1.479 1.479 0 01-.587 1.286 19.562 19.562 0 01-6.963 4.084c-.976.271-3.012 1.375-3.832.376a1.5 1.5 0 01-.267-.564c-.712-2.584 1.371-5.974 2.278-8.286 0-1.013 1.024-2.609 1.4-3.565l1.526-3.891c.936-2.392 1.82-4.8 2.881-7.145.766-1.69 2.121-4.538 4.319-4.662a9.793 9.793 0 012.974-.612c.146.017.267 0 .336.047.108.079.265.217.254.312a10.086 10.086 0 01-.251 1.301zM238.625 324.762l.094-.048s-.03-.026-.03-.022-.064.07-.064.07zM238.075 325.668l.02.057c.064-.054.055-.072-.02-.057z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M383.452 165.78a5.786 5.786 0 00-.363-1.661 7.335 7.335 0 00-.964-1.544c-1.593-2.135-3.327-4.149-4.916-6.283a1.6 1.6 0 00-1.115-.7c-3.429-.387-7.132 1.2-10.217 2.549a12.593 12.593 0 00-3.4 2c-1.362 1.213-2.113 2.875-3.1 4.351a48.048 48.048 0 00-3.02 5.242c-1.186 2.357-1.258 5.792-1.375 8.395-.072 1.617-.142 4.522 1.015 5.814l.049.051a6.115 6.115 0 00.373.752 4.721 4.721 0 001 1.2c1.837 3.194 4.674 5.224 7.566 7.473 1.291 1 1.056 1.39.013 2.429a9.078 9.078 0 01-3.267 1.971c-1.6.6-3.284.916-4.907 1.435a20.683 20.683 0 00-4.868 2.3c-1.6 1.024-2.861 2.362-4.684 3a2.666 2.666 0 00-.316-.082.609.609 0 00-.8.643c.137 2.305-.514 9.223 2.63 9.791 4.56.825 9.69.973 14.111-.479a24.682 24.682 0 0010.723-6.354c2.639-2.806 5.306-6.805 6.174-10.614a6.4 6.4 0 00-.2-3.8 6.55 6.55 0 00-.281-.824l-.014-.041a1.912 1.912 0 00-.216-.437q-.144-.273-.313-.53a17.583 17.583 0 00-1.8-3.241l-3.707-5.632a29.348 29.348 0 00-2.254-3.074c-1.179-1.366-1-2.152-.471-3.734a3.472 3.472 0 012.119-2.51c2.732-1.072 5.877-1.062 8.491-2.344 2.186-1.071 2.524-2.8 2.344-5.108-.015-.129-.026-.267-.04-.404zM234.573 330.053v.183a.668.668 0 00.039-.135c.002-.014-.012-.031-.039-.048zM234.574 330.347v-.111c-.011.032-.024.064-.035.1zM234.521 330.012c.014.013.034.027.052.041v-.06zM346.931 174.484a7.762 7.762 0 002.07-2.713c1.23-2.684 1.785-5.579 3.224-8.179a27.32 27.32 0 003.412-8.6 11.777 11.777 0 00-2.57-8.994c-1.328-1.792-5.789-5.347-8.009-3a11.709 11.709 0 00-1.964 3.836q-2.055 5.321-3.784 10.758c-.576 1.813-1.085 3.644-1.644 5.461-.406 1.321-1.058 3-.554 4.377.081.222.213.421.309.637a4.159 4.159 0 01.224.743l.7 2.959a5.452 5.452 0 004.267 4.018 5.373 5.373 0 004.319-1.303zM231.137 334.565s.043.007.05.01-.021-.028-.021-.028zM265.984 228.075l.013-.091c-.107.029-.115.059-.013.091z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M266 227.946l-.006.038c.013 0 .021-.007.036-.01zM333.729 178.665c-1.573-1.327-2.977-3.233-4.837-4.152a18.4 18.4 0 00-5.6-1.217 3 3 0 00-1.041.043c-.491.1-.994.157-1.482.276a15.4 15.4 0 00-2.32.647c-1.155.487-2.261 1.09-3.384 1.651-.178.089-.328.238-.51.318-.909.4-1.556.946-2.138-.053a7.572 7.572 0 00-1.012-1.838 12.983 12.983 0 00-2.657-1.834 1.893 1.893 0 00-.622-.284 1.752 1.752 0 00-.863.126 12.778 12.778 0 00-3.729 2 2.547 2.547 0 00-.732.774 2.823 2.823 0 00-.246.936c-.591 4.124-1.358 8.191-1.659 12.359-.558 7.732-1.25 15.479-1.539 23.211a35.524 35.524 0 00.047 4.366 14.858 14.858 0 001.222 4.48 11.1 11.1 0 001.038 2 2.113 2.113 0 001.322.926 3.672 3.672 0 001.643-.041 16.2 16.2 0 012.068-.338 8.637 8.637 0 003.246-1.122c.546-.337.9-.948 1.6-1.086.123-.024.236-.186.319-.308 1.924-2.822 1.464-6.466 1.294-9.7a68.584 68.584 0 01.419-11.969 4.917 4.917 0 01.32-1.428c1.04-2.3 3.413-4.375 5.4-5.844a21.945 21.945 0 013.982-2.341c1.237-.561 2.93-1.478 4.29-1.058a12.171 12.171 0 011.849.622 2.66 2.66 0 001.61.192 9.42 9.42 0 001.033-.246c.476-.117 1.823-2.065 2.169-2.542a8.771 8.771 0 001.267-3.862 2.311 2.311 0 00-.155-1.331 6.186 6.186 0 00-1.612-2.333zM134.372 292.355l.102.016-.033-.132-.069.116zM88.809 123.132c.8 1.087.659 2.537.874 3.808a10.31 10.31 0 001.51 4.091c1.729 2.578 4.8 4.593 8 4.235a18.111 18.111 0 004.049-1.1l8.516-3.052c1.624-.582 4.326-2.238 3.72.592q-.411 1.917-.812 3.838-.833 3.959-1.638 7.924c-1.332 6.91-2.44 13.886-4.759 20.528a6.359 6.359 0 00-.379 3.75c.584 2.1 2.913 3.541 4.379 5.02a5.475 5.475 0 001.279 1.052 4.613 4.613 0 001.35.411c2.517.449 5.109.04 7.632-.134a33.2 33.2 0 003.744-.909c1.538-.26 2.029-1.67 2.4-2.983a13.533 13.533 0 01.864-3.083l1-3.558c.308-1.1.7-2.2.93-3.322.213-1.023.14-2.075.357-3.107a1.842 1.842 0 00.01-.452 6.817 6.817 0 01.161-1.646c.314-1.587.318-3.269.585-4.882l.965-5.835a66.214 66.214 0 001.2-7.283c.411-2.483.666-4.827.862-7.311a9.463 9.463 0 00.222-2.892c-.173-.81-1.293-2.338-.739-3.115.292-.409 1.832-.767 2.32-.925 2.245-.726 4.482-1.273 6.793-1.786l1.82-.4c.979-.217 1.959-.435 2.934-.672a48.291 48.291 0 005.109-1.515c1.568-.572 2.987-1.463 4.707-1.372a1.2 1.2 0 001.269-1.064 2.531 2.531 0 00.085-.891 20.944 20.944 0 00-1.809-5.059 14.944 14.944 0 00-.916-1.93c-1.759-2.942-5.431-4.612-8.691-5.2-3.2-.58-6.73.263-9.866.888a316.9 316.9 0 00-36.068 9.51c-4.9 1.6-10.725 3.209-14.68 6.668a1.846 1.846 0 00-.482.568 1.507 1.507 0 00.229 1.436c.274.411.664.75.964 1.159zM238.085 325.647l-.025-.02-.03.051a.323.323 0 01.042-.009v-.013zM257.427 324.641h-.026l.017.015v-.009z"
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
                d: "M263.633 286.4a35.707 35.707 0 00-2.524-7.725c-.932-2.1-1.949-4.557-3.9-5.917a6.558 6.558 0 00-.655-.44 3.606 3.606 0 00-.275-.354 11.537 11.537 0 00-3.042-2.465 7.374 7.374 0 00-.805-.728 1.785 1.785 0 00-.459-.247c-.052-.048-.1-.1-.153-.148a35.267 35.267 0 01-3.758-1.153 3.979 3.979 0 00-.682.249 3.64 3.64 0 01-.573.064 7.355 7.355 0 00-3.306.861c-.311.165-.62.334-.93.5-1.464.781-3.594 1.577-4.983 2.487a28.993 28.993 0 00-5.869 5.172 22.491 22.491 0 00-2.416 3.084c-.629 1.031-1.168 2.106-1.735 3.167a22.62 22.62 0 00-2.724 12.063c.119 5.994.523 12.326 3.862 17.513A13.282 13.282 0 00231 315.6a8.208 8.208 0 001.639.693q.923.4 1.83.845c1 .486 2.671.973 3.669 1.459a21.6 21.6 0 002.444 1.353.439.439 0 01.179.384 6.416 6.416 0 01-.5 1.858 56.846 56.846 0 01-10.343 13.438 169.171 169.171 0 00-6.288 6.362 1.313 1.313 0 00-.216.372 11.7 11.7 0 01-1.091 1.916 1.111 1.111 0 00-.279.646c0 .13.056.255.059.385a1.148 1.148 0 01-.107.414c-.715 1.883.389 3.482.576 5.361.11 1.115.308.851.454 1.958a4.21 4.21 0 00.417 1.5 5.191 5.191 0 003.271 2.55 21.455 21.455 0 002.291.391 3.5 3.5 0 002.5-1.17 32.7 32.7 0 015.023-4.5 39.034 39.034 0 004.584-3.517c1.306-1.246 2.37-2.806 3.566-4.177l2.481-2.844 4.107-4.71a22.036 22.036 0 001.491-1.838 19.353 19.353 0 001.625-2.976 76.281 76.281 0 005.023-14.769c.311-1.325.546-2.666.843-3.994.5-2.223 1.165-4.4 1.694-6.618.517-2.166.647-4.355 1.112-6.529.277-1.3.642-2.575.855-3.885.043-.26.077-.52.105-.779a30.131 30.131 0 00-.381-8.779zM223.9 342.428c-.1.026-.157-.043-.13-.171a.129.129 0 01.115-.054c.033.01.052.07.078.108-.021.041-.034.11-.063.117zm26.312-53.084c-.328 2.231-.748 4.448-1.2 6.657-.06.293-.078.6-.116.893a69.538 69.538 0 01-.711 4.3 13.826 13.826 0 01-.855 2.879.743.743 0 01-.425.383 5.564 5.564 0 01-1.184.171c-1.1.043-2.21.055-3.315.08v.02c-.951.019-1.9.045-2.854.052-.4 0-.8-.041-1.2-.053a1.077 1.077 0 01-1.084-.869c-.082-.289-.144-.584-.215-.877-.606-2.521-1.173-4.376-.415-6.946a24.314 24.314 0 011.553-4.262c2-3.889 5.594-5.842 9.729-6.624a6.771 6.771 0 011.04-.133 1.357 1.357 0 011.5 1.481 25.88 25.88 0 01-.248 2.848zM195.438 305.782l.029-.042-.088-.048.059.09z"
            })
        ]
    }));
};
/* harmony default export */ const assets_text = (SvgText);

;// ./src/components/Logo/Logo.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Logo = ({"logo":"m78spP","path":"_6eAZll"});
;// ./src/components/Logo/Logo.tsx
function Logo_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Logo_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Logo_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Logo_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Logo_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Logo_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Logo_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Logo_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Logo_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var LogoModes = [
    'light',
    'dark',
    'product'
];
function getTextFill(mode) {
    switch(mode){
        case 'light':
        case 'product':
        default:
            return WHITE;
        case 'dark':
            return KALE_3;
    }
}
function getBackgroundFill(mode) {
    switch(mode){
        case 'light':
        default:
            return KALE_3;
        case 'product':
            return TFD_LOGO;
        case 'dark':
            return WHITE;
    }
}
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/logo | Logo} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Logo_Logo = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? 100 : _param_size, _param_mode = _param.mode, mode = _param_mode === void 0 ? 'light' : _param_mode, className = _param.className, style = _param.style, props = Logo_object_without_properties(_param, [
        "size",
        "mode",
        "className",
        "style"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", Logo_object_spread_props(Logo_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 463.097 421.318",
        className: (0,external_classnames_namespaceObject["default"])(Logo.logo, className),
        style: Logo_object_spread({
            height: size
        }, style)
    }, props), {
        "aria-label": "Logo",
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("g", {
            fillRule: "nonzero",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(background, {
                    className: Logo.path,
                    style: {
                        fill: getBackgroundFill(mode)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(assets_text, {
                    className: Logo.path,
                    style: {
                        fill: getTextFill(mode)
                    }
                })
            ]
        })
    }));
};

;// ./src/components/AppBar/Logo.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const AppBar_Logo = ({"logo":"gkGOeX","link":"s4MLkp"});
;// ./src/components/AppBar/Logo.tsx






var AppBar_Logo_Logo = function(param) {
    var _param_to = param.to, to = _param_to === void 0 ? '/' : _param_to, href = param.href, translate = param.translate, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
        className: (0,external_classnames_namespaceObject["default"])(AppBar_Logo.logo, className),
        style: {
            transform: "translateY(".concat(translate, "px)")
        },
        children: href ? /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("a", {
            href: href,
            className: AppBar_Logo.link,
            "aria-label": "The Farmer's Dog Logo",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Logo_Logo, {
                size: LOGO_SIZE,
                mode: "product"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_router_dom_namespaceObject.Link, {
            to: to,
            className: AppBar_Logo.link,
            "aria-label": "The Farmer's Dog Logo",
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Logo_Logo, {
                size: LOGO_SIZE,
                mode: "product"
            })
        })
    });
};

;// ./src/components/AppBar/MaxWidth.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MaxWidth = ({"container":"T5eSs5"});
;// ./src/components/AppBar/MaxWidth.tsx
function MaxWidth_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MaxWidth_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MaxWidth_define_property(target, key, source[key]);
        });
    }
    return target;
}
function MaxWidth_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function MaxWidth_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        MaxWidth_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function MaxWidth_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = MaxWidth_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function MaxWidth_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var MaxWidth_MaxWidth = function(_param) {
    var children = _param.children, className = _param.className, props = MaxWidth_object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", MaxWidth_object_spread_props(MaxWidth_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(MaxWidth.container, className)
    }, props), {
        children: children
    }));
};

;// ./src/components/AppBar/Large.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Large = ({"nav":"nBJQ4i g97HzC","items":"svdnAP","left":"V1EfXu","link":"U9gzXk","right":"UyIJTe","callToAction":"U1m0Tb","active":"pFIoUj","horizontalNavContainer":"BL9QUb","horizontalNavContentRow":"hlkuY8"});
;// external "lodash/isEqual"
var isEqual_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var isEqual_y = (x) => (() => (x))
const isEqual_namespaceObject = isEqual_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_lodash_isEqual_ce045a54__["default"]) });
;// ./src/hooks/useSafeOptions.ts
function useSafeOptions_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSafeOptions_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSafeOptions_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSafeOptions_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSafeOptions_sliced_to_array(arr, i) {
    return useSafeOptions_array_with_holes(arr) || useSafeOptions_iterable_to_array_limit(arr, i) || useSafeOptions_unsupported_iterable_to_array(arr, i) || useSafeOptions_non_iterable_rest();
}
function useSafeOptions_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSafeOptions_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSafeOptions_array_like_to_array(o, minLen);
}


/**
 * Return an object that updates based on a deep equality reference rather then
 * a shallow one.
 *
 * This is useful when you need to pass parameters into 3rd party objects and
 * you want to avoid needlessly destroying and creating those objects inside of
 * a useEffect hook.
 *
 * @param currentOptions - Any object that you want to update based on a deep equality comparison
 */ function useSafeOptions(currentOptions) {
    var _React_useState = useSafeOptions_sliced_to_array(external_react_namespaceObject.useState(currentOptions), 2), safeOptions = _React_useState[0], setSafeOptions = _React_useState[1];
    external_react_namespaceObject.useEffect(function() {
        setSafeOptions(function(prevOptions) {
            if (!(0,isEqual_namespaceObject["default"])(prevOptions, currentOptions)) {
                return currentOptions;
            }
            return prevOptions;
        });
    }, [
        currentOptions
    ]);
    return safeOptions;
}

;// ./src/hooks/useIntersection.ts
function useIntersection_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useIntersection_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useIntersection_array_without_holes(arr) {
    if (Array.isArray(arr)) return useIntersection_array_like_to_array(arr);
}
function useIntersection_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useIntersection_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useIntersection_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useIntersection_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIntersection_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIntersection_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIntersection_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useIntersection_sliced_to_array(arr, i) {
    return useIntersection_array_with_holes(arr) || useIntersection_iterable_to_array_limit(arr, i) || useIntersection_unsupported_iterable_to_array(arr, i) || useIntersection_non_iterable_rest();
}
function useIntersection_to_consumable_array(arr) {
    return useIntersection_array_without_holes(arr) || useIntersection_iterable_to_array(arr) || useIntersection_unsupported_iterable_to_array(arr) || useIntersection_non_iterable_spread();
}
function useIntersection_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useIntersection_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIntersection_array_like_to_array(o, minLen);
}


/**
 * Return an array of decimal points between 0 and 1
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Building_the_array_of_threshold_ratios
 */ function buildThresholdList(steps) {
    return steps > -1 ? useIntersection_to_consumable_array(new Array(steps)).map(function(_, i) {
        return i / steps;
    }) : [];
}
/**
 * Hook for creating an intersection observer.
 *
 * @param referenceEl - A target html element to observe.
 * @param root - An element used as the viewport for checking visibility.
 * @param rootMargin - A css margin around the root.
 * @param threshold - Which percentage of visibility to execute the callback.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useIntersection | useIntersection} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useIntersection(referenceEl) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState = useIntersection_sliced_to_array((0,external_react_namespaceObject.useState)(), 2), entry = _useState[0], setEntry = _useState[1];
    // Having stateful options allows us run our effect based on deep equality
    // rather then shallow object reference.
    var safeOptions = useSafeOptions(useIntersection_object_spread({
        referenceEl: referenceEl
    }, options));
    (0,external_react_namespaceObject.useEffect)(function() {
        var root = safeOptions.root, rootMargin = safeOptions.rootMargin, threshold = safeOptions.threshold, _$referenceEl = safeOptions.referenceEl;
        if (!_$referenceEl) {
            return;
        }
        var handleIntersections = function(entries) {
            setEntry(entries[0] || {});
        };
        var observer = new IntersectionObserver(handleIntersections, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold
        });
        observer.observe(_$referenceEl);
        return function() {
            return observer.disconnect();
        };
    }, [
        safeOptions
    ]);
    return entry;
}

;// ./src/components/AppBar/useCallToActionObserver.ts


var useCallToActionObserver = function(showCTA, callToAction) {
    var _showCTA_current;
    var intersection = useIntersection((_showCTA_current = showCTA === null || showCTA === void 0 ? void 0 : showCTA.current) !== null && _showCTA_current !== void 0 ? _showCTA_current : undefined, {
        rootMargin: "0px 0px -95% 0px"
    });
    return (0,external_react_namespaceObject.useMemo)(function() {
        if (!intersection || !callToAction || !(showCTA === null || showCTA === void 0 ? void 0 : showCTA.current)) {
            return false;
        }
        var bottom = intersection.boundingClientRect.bottom;
        return intersection.isIntersecting || bottom < 0;
    }, [
        callToAction,
        intersection,
        showCTA
    ]);
};

;// ./src/components/AppBar/getProgressOfRange.ts
/**
 * Given a percent, max, and min.  Determine the number that is some percent between
 * max and min.
 *
 * @example
 * getProgressOfRange(.5, 0, 10) // 5
 */ var getProgressOfRange = function(percent, min, max) {
    return percent * 100 * (max - min) / 100 + min;
};

;// external "fastdom"
var external_fastdom_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_fastdom_y = (x) => (() => (x))
const external_fastdom_namespaceObject = external_fastdom_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_fastdom__["default"]) });
;// ./src/components/AppBar/useScrollProgress.ts
function useScrollProgress_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useScrollProgress_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useScrollProgress_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useScrollProgress_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useScrollProgress_sliced_to_array(arr, i) {
    return useScrollProgress_array_with_holes(arr) || useScrollProgress_iterable_to_array_limit(arr, i) || useScrollProgress_unsupported_iterable_to_array(arr, i) || useScrollProgress_non_iterable_rest();
}
function useScrollProgress_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useScrollProgress_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useScrollProgress_array_like_to_array(o, minLen);
}





var threshold = buildThresholdList(LOGO_SIZE * 5);
function getScrollY() {
    var _browserOnly;
    return (_browserOnly = browserOnly(function(window) {
        return typeof window.scrollY === 'number' ? window.scrollY : window.pageYOffset;
    })) !== null && _browserOnly !== void 0 ? _browserOnly : 0;
}
function getScrollProgress() {
    var scrollY = getScrollY();
    var scrollProgress = scrollY / LOGO_SIZE;
    return Math.min(scrollProgress, 1);
}
function useScrollProgress(content) {
    var _useState = useScrollProgress_sliced_to_array((0,external_react_namespaceObject.useState)(getScrollProgress()), 2), scrollProgress = _useState[0], setScrollProgress = _useState[1];
    var intersection = useIntersection(content, {
        threshold: threshold
    });
    (0,external_react_namespaceObject.useEffect)(function() {
        return browserOnly(function(window) {
            if (!intersection || !content) {
                return;
            }
            var intersectionTop = intersection.intersectionRect.top;
            var boundingTop = intersection.boundingClientRect.top;
            var attachListener = false;
            if (boundingTop > 0) {
                // Content above the AppBar
                attachListener = intersectionTop > 0;
            } else {
                // Nothing above the AppBar
                attachListener = Math.abs(boundingTop) <= LOGO_SIZE;
            }
            var scrollListener = function() {
                external_fastdom_namespaceObject["default"].measure(function() {
                    setScrollProgress(getScrollProgress());
                });
            };
            if (attachListener) {
                window.addEventListener('scroll', scrollListener);
            } else if (!attachListener) {
                // Set to 1 on detach to ensure we don't get stuck in a smaller progress value
                // This also fixes scroll position restore after a refresh
                setScrollProgress(1);
                window.removeEventListener('scroll', scrollListener);
            }
            return function() {
                return window.removeEventListener('scroll', scrollListener);
            };
        });
    }, [
        content,
        intersection
    ]);
    return scrollProgress;
}

;// ./src/components/AppBar/useScrollingStyles.ts





var calculateOpacity = function(isOpen, overlay, scrollProgress) {
    return isOpen || !overlay ? 1 : scrollProgress;
};
var calculateTranslate = function(isOpen, scrollProgress, hasContentAbove) {
    if (isOpen) {
        return LOGO_TRANSLATE;
    }
    var logoDown = !hasContentAbove || scrollProgress >= 0.7;
    return logoDown ? LOGO_TRANSLATE : LOGO_TRANSLATE * -1;
};
var calculateShadowOpacity = function(isOpen, scrollProgress) {
    if (isOpen) {
        return SHADOW_OPACITY;
    }
    return getProgressOfRange(scrollProgress, 0, SHADOW_OPACITY);
};
var calculateLinkTheme = function(isOpen, scrollProgress, overlay, darkTheme) {
    var canBeDark = overlay && darkTheme;
    if (isOpen || !canBeDark) {
        return LinkModes[1];
    }
    return scrollProgress > 0.7 ? LinkModes[1] : LinkModes[0];
};
var useScrollingStyles = function(param) {
    var _param_overlay = param.overlay, overlay = _param_overlay === void 0 ? false : _param_overlay, _param_darkTheme = param.darkTheme, darkTheme = _param_darkTheme === void 0 ? false : _param_darkTheme, content = param.content, _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? false : _param_isOpen, _param_hasContentAbove = param.hasContentAbove, hasContentAbove = _param_hasContentAbove === void 0 ? false : _param_hasContentAbove;
    var scrollProgress = useScrollProgress(content);
    return (0,external_react_namespaceObject.useMemo)(function() {
        var opacity = calculateOpacity(isOpen, overlay, scrollProgress);
        var shadowOpacity = calculateShadowOpacity(isOpen, scrollProgress);
        var logoTranslate = calculateTranslate(isOpen, scrollProgress, hasContentAbove);
        var linkTheme = calculateLinkTheme(isOpen, scrollProgress, overlay, darkTheme);
        return {
            linkTheme: linkTheme,
            backgroundColor: "rgba(255, 255, 255, ".concat(opacity, ")"),
            boxShadow: "0 2px 12px 0 rgba(0, 0, 0, ".concat(shadowOpacity, ")"),
            logoTranslate: logoTranslate
        };
    }, [
        darkTheme,
        hasContentAbove,
        isOpen,
        overlay,
        scrollProgress
    ]);
};

;// external "lodash/isFunction"
var isFunction_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var isFunction_y = (x) => (() => (x))
const isFunction_namespaceObject = isFunction_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_lodash_isFunction_f90b20d6__["default"]) });
;// ./src/components/ArrowButton/ArrowButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ArrowButton = ({"horizontal-offset":"-2px","horizontalOffset":"-2px","vertical-offset":"-1px","verticalOffset":"-1px","button":"bfnQ5G","default":"DJf5qN","white-bg":"r_l5bc","whiteBg":"r_l5bc","right":"ryJxkf","left":"Z4__tI","down":"SfLqsk","up":"p8SXdm","sm":"zdDa1k","md":"aEtz0L","lg":"rlXy7f"});
;// ./src/components/ArrowButton/ArrowButton.tsx
function ArrowButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ArrowButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ArrowButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ArrowButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ArrowButton_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ArrowButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ArrowButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ArrowButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ArrowButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/** All of the available directions for this arrow to point */ var ArrowButtonDirections = (/* unused pure expression or super */ null && ([
    'up',
    'down',
    'left',
    'right'
]));
/** All available sizes for the arrow */ var ArrowButtonSize = (/* unused pure expression or super */ null && ([
    'sm',
    'md',
    'lg'
]));
/**
 * A button containing an arrow icon with a configurable direction.
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/iconbutton | IconButton} from corgi-x instead. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ArrowButton_ArrowButton = function(_param) {
    var direction = _param.direction, className = _param.className, _param_size = _param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, props = ArrowButton_object_without_properties(_param, [
        "direction",
        "className",
        "size",
        "variant"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", ArrowButton_object_spread_props(ArrowButton_object_spread({
        type: "button",
        className: (0,external_classnames_namespaceObject["default"])(styles_button.button, ArrowButton.button, className, ArrowButton[variant], ArrowButton[size])
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Arrow, {
            height: 24,
            width: 12,
            className: ArrowButton[direction],
            fill: "kale-3"
        })
    }));
};

;// ./src/components/Carousel/CarouselItem.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CarouselItem = ({"container":"geGht0","fullWidth":"bIn5_D"});
;// ./src/components/Carousel/CarouselItem.tsx
function CarouselItem_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




/**
 * List item for the carousel.  Maintains a ref to the root li
 * to be sent to the click handler.  This is so the event handler
 * always receives the li element instead of a descendant of the li.
 */ var CarouselItem_CarouselItem = function(param) {
    var children = param.children, onMouseUp = param.onMouseUp, fullWidth = param.fullWidth, className = param.className;
    var self = (0,external_react_namespaceObject.useRef)(null);
    var handleMouseUp = function() {
        if (self.current) {
            onMouseUp(self.current);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("li", {
        ref: self,
        onMouseUp: handleMouseUp,
        className: (0,external_classnames_namespaceObject["default"])(CarouselItem.container, CarouselItem_define_property({}, CarouselItem.fullWidth, fullWidth), className),
        children: children
    });
};
/* harmony default export */ const Carousel_CarouselItem = (CarouselItem_CarouselItem);

;// ./src/components/Carousel/isOverflowingLeft.ts
/**
 * Given an element and it's parent, where the parent has overflow x,
 * returns true if the element is partially or completely
 * out of view to the left.
 *
 * @param {Node} element
 * @param {Node} parentElement
 * @returns Boolean
 */ function isOverflowingLeft(element, parentElement) {
    if (!parentElement) {
        return false;
    }
    var offsetLeft = element.offsetLeft;
    var scrollLeft = parentElement.scrollLeft;
    var positionInVisibleArea = offsetLeft - scrollLeft;
    return positionInVisibleArea < 0;
}
/* harmony default export */ const Carousel_isOverflowingLeft = (isOverflowingLeft);

;// ./src/components/Carousel/isOverflowingRight.ts
/**
 * Given an element and it's parent, where the parent has overflow x,
 * returns true if the element is partially or completely
 * out of view to the right.
 *
 * @param {Node} element
 * @param {Node} parentElement
 * @returns Boolean
 */ function isOverflowingRight(element, parentElement) {
    if (!parentElement) {
        return false;
    }
    var offsetLeft = element.offsetLeft;
    var elementWidth = element.getBoundingClientRect().width;
    var scrollLeft = parentElement.scrollLeft;
    var scrollSnapWidth = parentElement.getBoundingClientRect().width;
    var positionInVisibleArea = offsetLeft + elementWidth - scrollLeft;
    return positionInVisibleArea > scrollSnapWidth;
}
/* harmony default export */ const Carousel_isOverflowingRight = (isOverflowingRight);

;// ./src/components/Carousel/Carousel.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Carousel = ({"container":"j_fnQe","horizontalSnap":"yNnRlb","next":"q9QnBN","previous":"V89huM","blank":"NWj09_"});
;// ./src/components/Carousel/Carousel.tsx
function Carousel_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Carousel_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Carousel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Carousel_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Carousel_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Carousel_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Carousel_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Carousel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Carousel_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Carousel_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Carousel_sliced_to_array(arr, i) {
    return Carousel_array_with_holes(arr) || Carousel_iterable_to_array_limit(arr, i) || Carousel_unsupported_iterable_to_array(arr, i) || Carousel_non_iterable_rest();
}
function Carousel_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Carousel_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Carousel_array_like_to_array(o, minLen);
}











/**
 * A horizontal scrolling carousel to display a collection of rich elements.
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/carousel | Carousel} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Carousel_Carousel = function(param) {
    var children = param.children, _param_withButtons = param.withButtons, withButtons = _param_withButtons === void 0 ? false : _param_withButtons, _param_centerFirstAndLast = param.centerFirstAndLast, centerFirstAndLast = _param_centerFirstAndLast === void 0 ? false : _param_centerFirstAndLast, _param_loop = param.loop, loop = _param_loop === void 0 ? false : _param_loop, _param_asSlides = param.asSlides, asSlides = _param_asSlides === void 0 ? false : _param_asSlides, className = param.className;
    var scrollSnap = (0,external_react_namespaceObject.useRef)(null);
    var _useState = Carousel_sliced_to_array((0,external_react_namespaceObject.useState)(''), 2), blankWidth = _useState[0], setBlankWidth = _useState[1];
    var id = (0,external_react_namespaceObject.useId)();
    var handlePreviousClick = function() {
        var nextChild;
        external_fastdom_namespaceObject["default"].measure(function() {
            if (!scrollSnap.current) {
                return;
            }
            if (loop && scrollSnap.current.scrollLeft === 0) {
                nextChild = centerFirstAndLast ? scrollSnap.current.children.item(scrollSnap.current.children.length - 2) : scrollSnap.current.lastChild;
            } else if (scrollSnap.current) {
                nextChild = Array.from(scrollSnap.current.children).reverse().filter(function(child) {
                    return Boolean(child);
                }).find(function(child) {
                    return Carousel_isOverflowingLeft(child, scrollSnap.current);
                });
                if (!nextChild) {
                    nextChild = centerFirstAndLast ? scrollSnap.current.children.item(1) : scrollSnap.current.firstChild;
                }
            }
        });
        external_fastdom_namespaceObject["default"].mutate(function() {
            if (nextChild) {
                nextChild.scrollIntoView({
                    inline: 'center',
                    block: 'nearest',
                    behavior: 'smooth'
                });
            }
        });
    };
    var handleNextClick = function() {
        var nextChild;
        external_fastdom_namespaceObject["default"].measure(function() {
            if (!scrollSnap.current) {
                return;
            }
            var maxScroll = scrollSnap.current.scrollWidth - scrollSnap.current.clientWidth;
            if (loop && scrollSnap.current.scrollLeft === maxScroll) {
                nextChild = centerFirstAndLast ? scrollSnap.current.children.item(1) : scrollSnap.current.firstChild;
            } else {
                nextChild = Array.from(scrollSnap.current.children).filter(function(child) {
                    return Boolean(child);
                }).find(function(child) {
                    return Carousel_isOverflowingRight(child, scrollSnap.current);
                });
                if (!nextChild) {
                    nextChild = centerFirstAndLast ? scrollSnap.current.children.item(scrollSnap.current.children.length - 2) : scrollSnap.current.lastChild;
                }
            }
        });
        external_fastdom_namespaceObject["default"].mutate(function() {
            if (nextChild) {
                nextChild.scrollIntoView({
                    inline: 'center',
                    block: 'nearest',
                    behavior: 'smooth'
                });
            }
        });
    };
    var handleChildMouseUp = function(element) {
        var isOverflow;
        external_fastdom_namespaceObject["default"].measure(function() {
            isOverflow = Carousel_isOverflowingRight(element, scrollSnap.current) || Carousel_isOverflowingLeft(element, scrollSnap.current);
        });
        external_fastdom_namespaceObject["default"].mutate(function() {
            if (isOverflow) {
                element.scrollIntoView({
                    inline: 'center',
                    block: 'nearest',
                    behavior: 'smooth'
                });
            }
        });
    };
    (0,external_react_namespaceObject.useEffect)(function() {
        if (!scrollSnap.current) {
            return;
        }
        var firstRealChild = scrollSnap.current.children.item(1);
        if (!firstRealChild) {
            return;
        }
        var childWidth = firstRealChild.getBoundingClientRect().width;
        setBlankWidth("calc(50% - ".concat(childWidth / 2, "px)"));
    }, []);
    var childProps = {
        onMouseUp: handleChildMouseUp,
        fullWidth: asSlides
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0,external_classnames_namespaceObject["default"])(Carousel.container, className),
        children: [
            withButtons && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ArrowButton_ArrowButton, {
                onClick: handlePreviousClick,
                direction: "left",
                "aria-label": "previous",
                "aria-controls": id,
                className: Carousel.previous
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(ScrollSnap_ScrollSnap, {
                as: "ul",
                id: id,
                ref: scrollSnap,
                className: Carousel.horizontalSnap,
                children: [
                    centerFirstAndLast && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("li", {
                        className: (0,external_classnames_namespaceObject["default"])(Carousel.blank, Carousel.left),
                        style: {
                            marginRight: blankWidth
                        }
                    }),
                    (0,isFunction_namespaceObject["default"])(children) ? children(childProps) : external_react_namespaceObject.Children.map(children, function(child) {
                        return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Carousel_CarouselItem, Carousel_object_spread_props(Carousel_object_spread({}, childProps), {
                            children: child
                        }));
                    }),
                    centerFirstAndLast && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("li", {
                        className: (0,external_classnames_namespaceObject["default"])(Carousel.blank, Carousel.right),
                        style: {
                            marginLeft: blankWidth
                        }
                    })
                ]
            }),
            withButtons && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ArrowButton_ArrowButton, {
                onClick: handleNextClick,
                direction: "right",
                "aria-label": "next",
                "aria-controls": id,
                className: Carousel.next
            })
        ]
    });
};

;// ./src/components/HorizontalNavigation/HorizontalNavigation.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HorizontalNavigation = ({"carousel":"s8yHlP"});
;// ./src/components/HorizontalNavigation/HorizontalNavigation.tsx




/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/navbar | NavBar} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var HorizontalNavigation_HorizontalNavigation = function(param) {
    var withButtons = param.withButtons, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Carousel_Carousel, {
        withButtons: withButtons,
        className: (0,external_classnames_namespaceObject["default"])(HorizontalNavigation.carousel, className),
        children: children
    });
};

;// ./src/components/HorizontalNavigationItem/HorizontalNavigationItem.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HorizontalNavigationItem = ({"nav-item":"yOqosL","navItem":"yOqosL","active":"BW2XKF"});
;// ./src/components/HorizontalNavigationItem/HorizontalNavigationItem.tsx
function HorizontalNavigationItem_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/navbar | NavBar} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var HorizontalNavigationItem_HorizontalNavigationItem = function(param) {
    var to = param.to, href = param.href, disabled = param.disabled, active = param.active, children = param.children, onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, {
        variant: "secondary",
        mode: "dark",
        to: to,
        href: href,
        disabled: disabled,
        onClick: onClick,
        activeClassName: HorizontalNavigationItem.active,
        className: (0,external_classnames_namespaceObject["default"])(HorizontalNavigationItem.navItem, className, HorizontalNavigationItem_define_property({}, HorizontalNavigationItem.active, active)),
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
            bold: true,
            variant: "heading-16",
            children: children
        })
    });
};

;// ./src/components/AppBar/SmallLabel.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SmallLabel = ({"container":"DQoG9Z","padding":"JXRsRN","small":"rJrKsr","active":"fUsZOM"});
;// ./src/components/AppBar/SmallLabel.tsx




var SmallLabel_SmallLabel = function(param) {
    var title = param.title, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
            color: "kale-3",
            variant: "heading-21",
            className: (0,external_classnames_namespaceObject["default"])(SmallLabel.container, SmallLabel.padding),
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("label", {
                className: (0,external_classnames_namespaceObject["default"])(className, SmallLabel.small, SmallLabel.active),
                children: title
            })
        })
    });
};

;// ./src/components/AppBar/Large.tsx
function Large_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Large_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Large_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Large_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Large_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Large_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var Large_Large = function(param) {
    var overlay = param.overlay, content = param.content, leftItems = param.leftItems, rightItems = param.rightItems, smallRightLabel = param.smallRightLabel, persistentItem = param.persistentItem, subNavItems = param.subNavItems, callToAction = param.callToAction, showCTA = param.showCTA, onCallToActionClick = param.onCallToActionClick, darkTheme = param.darkTheme, logoTo = param.logoTo, logoHref = param.logoHref, hasContentAbove = param.hasContentAbove;
    var nav = (0,external_react_namespaceObject.useRef)(null);
    var _useScrollingStyles = useScrollingStyles({
        overlay: overlay,
        darkTheme: darkTheme,
        content: content,
        hasContentAbove: hasContentAbove
    }), backgroundColor = _useScrollingStyles.backgroundColor, boxShadow = _useScrollingStyles.boxShadow, logoTranslate = _useScrollingStyles.logoTranslate, linkTheme = _useScrollingStyles.linkTheme;
    var showCallToAction = useCallToActionObserver(showCTA, callToAction);
    var alwaysShowCallToAction = !showCTA && callToAction;
    var logoLinkProps = logoTo ? {
        to: logoTo
    } : {
        href: logoHref
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor,
            boxShadow: boxShadow
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("nav", {
                role: "navigation",
                className: Large.nav,
                style: {
                    backgroundColor: backgroundColor
                },
                ref: nav,
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(MaxWidth_MaxWidth, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(AppBar_Logo_Logo, Large_object_spread_props(Large_object_spread({}, logoLinkProps), {
                            translate: logoTranslate
                        })),
                        /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                            variant: "heading-16",
                            bold: true,
                            className: (0,external_classnames_namespaceObject["default"])(Large.items, Large.left),
                            as: "ul",
                            children: leftItems.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Large_object_spread_props(Large_object_spread({}, item), {
                                        activeClassName: Large.active,
                                        className: (0,external_classnames_namespaceObject["default"])(Large.link, item.className),
                                        variant: "secondary",
                                        mode: linkTheme,
                                        children: item.title
                                    }))
                                }, item.title);
                            })
                        }),
                        smallRightLabel && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(SmallLabel_SmallLabel, {
                            title: smallRightLabel
                        }),
                        rightItems && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                            variant: "heading-16",
                            bold: true,
                            className: (0,external_classnames_namespaceObject["default"])(Large.items, Large.right),
                            as: "ul",
                            children: rightItems.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Large_object_spread_props(Large_object_spread({}, item), {
                                        activeClassName: Large.active,
                                        className: (0,external_classnames_namespaceObject["default"])(Large.link, item.className),
                                        variant: "secondary",
                                        mode: linkTheme,
                                        children: item.title
                                    }))
                                }, item.title);
                            })
                        }),
                        callToAction && (showCallToAction || alwaysShowCallToAction) && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                            className: (0,external_classnames_namespaceObject["default"])(Large.items, Large.callToAction),
                            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(CallToAction_CallToAction, Large_object_spread_props(Large_object_spread({}, callToAction), {
                                onClick: onCallToActionClick,
                                asPill: true
                            }))
                        }),
                        persistentItem && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Large_object_spread_props(Large_object_spread({}, persistentItem), {
                            className: (0,external_classnames_namespaceObject["default"])(Large.link, persistentItem.className),
                            variant: rightItems ? 'primary' : 'secondary',
                            mode: linkTheme,
                            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                                variant: "heading-16",
                                bold: true,
                                children: persistentItem.title
                            })
                        }))
                    ]
                })
            }),
            subNavItems && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: Large.horizontalNavContainer,
                "aria-label": "subnavigation",
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(MaxWidth_MaxWidth, {
                    className: Large.horizontalNavContentRow,
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HorizontalNavigation_HorizontalNavigation, {
                        withButtons: false,
                        children: subNavItems.map(function(item) {
                            var linkProps = isAnchorLink(item) ? {
                                href: item.href
                            } : {
                                to: item.to
                            };
                            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HorizontalNavigationItem_HorizontalNavigationItem, Large_object_spread_props(Large_object_spread({
                                className: Large.horizontalNavLink
                            }, linkProps), {
                                children: item.title
                            }), item.title);
                        })
                    })
                })
            })
        ]
    });
};

;// ./src/components/Divider/Divider.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Divider = ({"container":"Rbd79x","horizontal":"JdnPzo","vertical":"dXatUl","kale-3":"soDGQG","kale3":"soDGQG","white":"mn2P4r","charcoal-3":"lOMfWj","charcoal3":"lOMfWj","charcoal-1":"byPGJU","charcoal1":"byPGJU","charcoal-0":"S9llx6","charcoal0":"S9llx6","oyster-0":"Mvsi3y","oyster0":"Mvsi3y","kale-1":"GrZZAD","kale1":"GrZZAD","carrot-1":"XzI7er","carrot1":"XzI7er","chickpea-2":"YWj5Dj","chickpea2":"YWj5Dj","carrot-2":"FWAqcn","carrot2":"FWAqcn","carrot-3":"sTKEdh","carrot3":"sTKEdh"});
;// ./src/components/Divider/Divider.tsx
function Divider_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Divider_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Divider_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Divider_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Divider_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Divider_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var horizontal = Divider.horizontal, vertical = Divider.vertical, container = Divider.container;
var DividerOrientations = [
    'horizontal',
    'vertical'
];
var DividerColors = [
    'kale-3',
    'white',
    'charcoal-3',
    'charcoal-1',
    'oyster-0',
    'charcoal-0',
    'kale-1',
    'carrot-1',
    'chickpea-2',
    'carrot-2',
    'carrot-3'
];
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/divider | Divider} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Divider_Divider = function(_param) {
    var orientation = _param.orientation, _param_style = _param.style, style = _param_style === void 0 ? 'solid' : _param_style, _param_margin = _param.margin, margin = _param_margin === void 0 ? 13 : _param_margin, color = _param.color, _param_width = _param.width, width = _param_width === void 0 ? 2 : _param_width, className = _param.className, props = Divider_object_without_properties(_param, [
        "orientation",
        "style",
        "margin",
        "color",
        "width",
        "className"
    ]);
    var isHorizontal = orientation === 'horizontal';
    var margins = isHorizontal ? {
        marginTop: margin,
        marginBottom: margin
    } : {
        marginLeft: margin,
        marginRight: margin
    };
    var colorClass = color ? Divider[color] : undefined;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", Divider_object_spread({
        role: "separator",
        "aria-orientation": orientation,
        className: (0,external_classnames_namespaceObject["default"])(container, (_obj = {}, Divider_define_property(_obj, horizontal, isHorizontal), Divider_define_property(_obj, vertical, !isHorizontal), _obj), colorClass, className),
        style: Divider_object_spread({
            borderColor: !colorClass ? color : undefined,
            borderStyle: style,
            borderTopWidth: isHorizontal ? width : 0,
            borderLeftWidth: isHorizontal ? 0 : width
        }, margins)
    }, props));
};

;// ./src/components/AppBar/HamburgerButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HamburgerButton = ({"container":"BxqR5q","bar":"lSet74","darkTheme":"dJHERF","x":"XnsV8r"});
;// ./src/components/AppBar/HamburgerButton.tsx
function HamburgerButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var HamburgerButton_HamburgerButton = function(param) {
    var onClick = param.onClick, isOpen = param.isOpen, mode = param.mode;
    var barClassName = (0,external_classnames_namespaceObject["default"])(HamburgerButton.bar, HamburgerButton_define_property({}, HamburgerButton.darkTheme, mode === LinkModes[0]));
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("button", {
        type: "button",
        role: "button",
        "aria-label": "".concat(isOpen ? 'close' : 'open', " menu"),
        "aria-expanded": isOpen,
        className: (0,external_classnames_namespaceObject["default"])(HamburgerButton.container, HamburgerButton_define_property({}, HamburgerButton.x, isOpen)),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: barClassName
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: barClassName
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: barClassName
            })
        ]
    });
};

;// ./src/components/AppBar/Mobile.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Mobile = ({"nav":"MN7Daw g97HzC","navItem":"IgmX5G","callToAction":"llSfzN","menu":"aW5oZr","items":"Z5_pmL","logo":"iWVkyj","link":"xzhMbu","inNav":"Mr3wuh","active":"yiUZDT","persistentLink":"S8AKlI","shortDivider":"dPnqLn","ctaContainer":"cmHK7_","lastDivider":"mAp0mM","horizontalNavContainer":"KJMVV0","horizontalNavContentRow":"Yc2yTy"});
;// ./src/components/AppBar/Mobile.tsx
function Mobile_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Mobile_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Mobile_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Mobile_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Mobile_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Mobile_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var Mobile_Mobile = function(param) {
    var overlay = param.overlay, darkTheme = param.darkTheme, content = param.content, leftItems = param.leftItems, rightItems = param.rightItems, persistentItem = param.persistentItem, callToAction = param.callToAction, subNavItems = param.subNavItems, showCTA = param.showCTA, onCallToActionClick = param.onCallToActionClick, onToggle = param.onToggle, logoTo = param.logoTo, logoHref = param.logoHref, hasContentAbove = param.hasContentAbove;
    var _useLightboxControl = useLightboxControl({
        initialIsOpen: false,
        id: 'appbar-lightbox',
        onToggle: onToggle
    }), rootProps = _useLightboxControl.rootProps, toggle = _useLightboxControl.toggle, isOpen = _useLightboxControl.isOpen;
    var nav = (0,external_react_namespaceObject.useRef)(null);
    var _useScrollingStyles = useScrollingStyles({
        overlay: overlay,
        darkTheme: darkTheme,
        content: content,
        hasContentAbove: hasContentAbove,
        isOpen: isOpen
    }), backgroundColor = _useScrollingStyles.backgroundColor, boxShadow = _useScrollingStyles.boxShadow, logoTranslate = _useScrollingStyles.logoTranslate, linkTheme = _useScrollingStyles.linkTheme;
    var showCallToAction = useCallToActionObserver(showCTA, callToAction);
    var logoLinkProps = logoTo ? {
        to: logoTo
    } : {
        href: logoHref
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor,
            boxShadow: boxShadow
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("nav", {
                role: "navigation",
                className: Mobile.nav,
                ref: nav,
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(MaxWidth_MaxWidth, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                            className: Mobile.navItem,
                            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HamburgerButton_HamburgerButton, {
                                onClick: toggle,
                                isOpen: isOpen,
                                mode: linkTheme
                            })
                        }),
                        (!showCallToAction || isOpen) && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(AppBar_Logo_Logo, Mobile_object_spread_props(Mobile_object_spread({}, logoLinkProps), {
                                    translate: logoTranslate,
                                    className: (0,external_classnames_namespaceObject["default"])(Mobile.logo, Mobile.navItem)
                                })),
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                                    className: (0,external_classnames_namespaceObject["default"])(Mobile.persistentLink, Mobile.navItem),
                                    children: persistentItem && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, persistentItem), {
                                        className: (0,external_classnames_namespaceObject["default"])(Mobile.link, Mobile.inNav, persistentItem.className),
                                        style: {
                                            opacity: isOpen ? 0 : 1
                                        },
                                        variant: "secondary",
                                        mode: linkTheme,
                                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                                            variant: "heading-16",
                                            bold: true,
                                            children: persistentItem.title
                                        })
                                    }))
                                })
                            ]
                        }),
                        showCallToAction && callToAction && !isOpen && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                                    className: (0,external_classnames_namespaceObject["default"])(Mobile.navItem, Mobile.callToAction),
                                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(CallToAction_CallToAction, Mobile_object_spread_props(Mobile_object_spread({}, callToAction), {
                                        onClick: onCallToActionClick,
                                        asPill: true
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                                    className: Mobile.navItem
                                })
                            ]
                        })
                    ]
                })
            }),
            subNavItems && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: Mobile.horizontalNavContainer,
                "aria-label": "subnavigation",
                style: {
                    display: isOpen ? 'none' : 'block'
                },
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(MaxWidth_MaxWidth, {
                    className: Mobile.horizontalNavContentRow,
                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HorizontalNavigation_HorizontalNavigation, {
                        withButtons: false,
                        children: subNavItems.map(function(item) {
                            var linkProps = isAnchorLink(item) ? {
                                href: item.href
                            } : {
                                to: item.to
                            };
                            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HorizontalNavigationItem_HorizontalNavigationItem, Mobile_object_spread_props(Mobile_object_spread({
                                className: Mobile.horizontalNavLink
                            }, linkProps), {
                                children: item.title
                            }), item.title);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(Lightbox_Lightbox, Mobile_object_spread_props(Mobile_object_spread({
                offsetTop: LOGO_SIZE,
                background: "white",
                className: Mobile.menu
            }, rootProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Divider_Divider, {
                        orientation: "horizontal",
                        margin: 0,
                        color: OYSTER_0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("ul", {
                        className: Mobile.items,
                        children: [
                            rightItems && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(MaxWidth_MaxWidth, {
                                children: rightItems.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, item), {
                                                activeClassName: Mobile.active,
                                                className: (0,external_classnames_namespaceObject["default"])(Mobile.link, item.className),
                                                onClick: interceptEvent(toggle, item.onClick),
                                                variant: "secondary",
                                                mode: "dark",
                                                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                                                    variant: "heading-21",
                                                    bold: true,
                                                    children: item.title
                                                })
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Divider_Divider, {
                                                orientation: "horizontal",
                                                margin: 0,
                                                color: OYSTER_0,
                                                className: Mobile.shortDivider
                                            })
                                        ]
                                    }, item.title);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(MaxWidth_MaxWidth, {
                                children: leftItems.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, item), {
                                                className: (0,external_classnames_namespaceObject["default"])(Mobile.link, item.className),
                                                activeClassName: Mobile.active,
                                                onClick: interceptEvent(toggle, item.onClick),
                                                variant: "secondary",
                                                mode: "dark",
                                                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                                                    variant: "heading-21",
                                                    bold: true,
                                                    children: item.title
                                                })
                                            })),
                                            (leftItems.length !== index + 1 || persistentItem) && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Divider_Divider, {
                                                orientation: "horizontal",
                                                margin: 0,
                                                color: OYSTER_0,
                                                className: Mobile.shortDivider
                                            })
                                        ]
                                    }, item.title);
                                })
                            }),
                            persistentItem && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(MaxWidth_MaxWidth, {
                                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, persistentItem), {
                                    className: (0,external_classnames_namespaceObject["default"])(Mobile.link, persistentItem.className),
                                    onClick: interceptEvent(toggle, persistentItem.onClick),
                                    variant: "secondary",
                                    mode: "dark",
                                    children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                                        variant: "heading-21",
                                        bold: true,
                                        children: persistentItem.title
                                    })
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                        className: Mobile.ctaContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(MaxWidth_MaxWidth, {
                            children: isOpen && callToAction && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(CallToAction_CallToAction, Mobile_object_spread_props(Mobile_object_spread({
                                isMobile: true
                            }, callToAction), {
                                withPadding: false,
                                onClick: interceptEvent(toggle, callToAction.onClick)
                            }))
                        })
                    })
                ]
            }))
        ]
    });
};

;// ./src/components/AppBar/AppBar.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const AppBar = ({"container":"PYLduF","static":"io9mmp","isOpen":"d59Nwm","nav":"g97HzC","logo":"G9Paht"});
;// ./src/hooks/useIsomorphicLayoutEffect.ts

// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
/** @deprecated Don't use this hook. Create one in your code. */ var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? external_react_namespaceObject.useLayoutEffect : external_react_namespaceObject.useEffect;

;// ./src/components/AppBar/AppBar.tsx
function AppBar_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AppBar_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function AppBar_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AppBar_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AppBar_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AppBar_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AppBar_define_property(target, key, source[key]);
        });
    }
    return target;
}
function AppBar_sliced_to_array(arr, i) {
    return AppBar_array_with_holes(arr) || AppBar_iterable_to_array_limit(arr, i) || AppBar_unsupported_iterable_to_array(arr, i) || AppBar_non_iterable_rest();
}
function AppBar_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AppBar_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AppBar_array_like_to_array(o, minLen);
}








/**
 * The App Bar displays information and actions relating to the current screen.
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/layout | Layout} from corgi-x to build layouts with an app bar. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var AppBar_AppBar = function(props) {
    var appBarRef = (0,external_react_namespaceObject.useRef)(null);
    var _useState = AppBar_sliced_to_array((0,external_react_namespaceObject.useState)(null), 2), content = _useState[0], setContent = _useState[1];
    var _useState1 = AppBar_sliced_to_array((0,external_react_namespaceObject.useState)(false), 2), isOpen = _useState1[0], setIsOpen = _useState1[1];
    useIsomorphicLayoutEffect(function() {
        if (appBarRef.current) {
            var nextElementSibling = appBarRef.current.nextElementSibling;
            setContent(nextElementSibling);
            if (nextElementSibling && props.overlay) {
                var currentMarginTop = nextElementSibling.style.marginTop || '0px';
                nextElementSibling.style.marginTop = "calc(".concat(currentMarginTop, " - ").concat(LOGO_SIZE, "px)");
            }
        }
    }, []);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        ref: appBarRef,
        "data-name": "AppBar",
        className: (0,external_classnames_namespaceObject["default"])(AppBar.container, (_obj = {}, AppBar_define_property(_obj, AppBar.isOpen, isOpen), AppBar_define_property(_obj, AppBar.static, props.static), _obj)),
        children: [
            props.large && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Large_Large, AppBar_object_spread({
                content: content
            }, props)),
            !props.large && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Mobile_Mobile, AppBar_object_spread({
                onToggle: setIsOpen,
                content: content
            }, props))
        ]
    });
};

;// ./src/components/AppBar/index.ts


;// ./src/components/Carousel/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity



;// ./src/components/Divider/index.ts


;// ./src/hooks/useHtmlElement.ts
function useHtmlElement_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useHtmlElement_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useHtmlElement_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useHtmlElement_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useHtmlElement_sliced_to_array(arr, i) {
    return useHtmlElement_array_with_holes(arr) || useHtmlElement_iterable_to_array_limit(arr, i) || useHtmlElement_unsupported_iterable_to_array(arr, i) || useHtmlElement_non_iterable_rest();
}
function useHtmlElement_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useHtmlElement_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useHtmlElement_array_like_to_array(o, minLen);
}

/**
 * Obtain a reference to an underlying HTML element in a stateful manner. This
 * can be preferred to useRef for instances where an html node may not be
 * available on initial render but you would like to receive updates when it is
 * available.
 *
 * @example
 *
 * const [divElement, divRef] = useHtmlElement();
 * return <div ref={divRef} />
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useHtmlElement | useHtmlElement} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useHtmlElement() {
    var _React_useState = useHtmlElement_sliced_to_array(external_react_namespaceObject.useState(null), 2), currentHtmlElement = _React_useState[0], setCurrentHtmlElement = _React_useState[1];
    var setRef = external_react_namespaceObject.useCallback(function(node) {
        if (node !== null) {
            setCurrentHtmlElement(node);
        }
    }, []);
    return [
        currentHtmlElement,
        setRef
    ];
}

;// ./src/hooks/useSlideShow.ts
function useSlideShow_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSlideShow_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSlideShow_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSlideShow_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSlideShow_sliced_to_array(arr, i) {
    return useSlideShow_array_with_holes(arr) || useSlideShow_iterable_to_array_limit(arr, i) || useSlideShow_unsupported_iterable_to_array(arr, i) || useSlideShow_non_iterable_rest();
}
function useSlideShow_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSlideShow_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSlideShow_array_like_to_array(o, minLen);
}


/**
 * The time since the last user interaction used for determining if scrolling
 * has ceased.
 */ var SCROLL_INTERVAL = 1000 / 15; // 15 FPS
/**
 * Add programmatic control for managing slide show state to a scrollable
 * content area.
 *
 * !Requires `polyfillSmoothScroll()` on the client for full browser support.
 *
 * @deprecated Just use the {@link https://corgi-x.tfd.engineering/components/slideshow | Slideshow component} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useSlideShow(param) {
    var scrollableEl = param.scrollableEl, getIsActiveSlide = param.getIsActiveSlide, onSlideChange = param.onSlideChange, activeIndexProp = param.activeIndex, scrollBehavior = param.scrollBehavior;
    var _React_useState = useSlideShow_sliced_to_array(external_react_namespaceObject.useState(Date.now()), 2), lastScroll = _React_useState[0], setLastScroll = _React_useState[1];
    var _React_useState1 = useSlideShow_sliced_to_array(external_react_namespaceObject.useState(activeIndexProp !== null && activeIndexProp !== void 0 ? activeIndexProp : 0), 2), activeIndex = _React_useState1[0], setCurrentSlide = _React_useState1[1];
    var getIsScrolling = external_react_namespaceObject.useCallback(function() {
        var now = Date.now();
        return Boolean(lastScroll) && now < lastScroll + SCROLL_INTERVAL;
    }, [
        lastScroll
    ]);
    var handleSlideChange = external_react_namespaceObject.useCallback(function(nextIndex) {
        setCurrentSlide(nextIndex);
        if (onSlideChange) {
            onSlideChange(nextIndex);
        }
    }, [
        onSlideChange
    ]);
    var goToSlide = external_react_namespaceObject.useCallback(function(nextIndex) {
        if (!scrollableEl) {
            return;
        }
        var slides = Array.from(scrollableEl.children);
        var nextSlideEl = slides[nextIndex];
        var activeSlideEl = slides[activeIndex];
        if (nextSlideEl && activeSlideEl && scrollableEl) {
            var scrollTop = 0;
            var scrollLeft = 0;
            external_fastdom_namespaceObject["default"].measure(function() {
                var nextSlideRects = nextSlideEl.getBoundingClientRect();
                var activeSlideRects = activeSlideEl.getBoundingClientRect();
                scrollTop = nextSlideRects.top - activeSlideRects.top;
                scrollLeft = nextSlideRects.left - activeSlideRects.left;
            });
            external_fastdom_namespaceObject["default"].mutate(function() {
                scrollableEl.scrollBy({
                    top: scrollTop,
                    left: scrollLeft,
                    behavior: scrollBehavior
                });
            });
        }
    }, [
        activeIndex,
        scrollableEl,
        scrollBehavior
    ]);
    external_react_namespaceObject.useEffect(function() {
        if (typeof activeIndexProp === 'undefined') {
            return;
        }
        if (activeIndexProp === activeIndex) {
            return;
        }
        if (!getIsScrolling()) {
            goToSlide(activeIndexProp);
        }
    }, [
        activeIndexProp,
        activeIndex,
        goToSlide,
        getIsScrolling
    ]);
    external_react_namespaceObject.useEffect(function() {
        if (!scrollableEl) {
            return;
        }
        var handleScroll = function() {
            external_fastdom_namespaceObject["default"].measure(function() {
                setLastScroll(Date.now());
                var scrollableRect = scrollableEl.getBoundingClientRect();
                var slides = Array.from(scrollableEl.children);
                var nextIndex = slides.findIndex(function(slideEl) {
                    return getIsActiveSlide(slideEl.getBoundingClientRect(), scrollableRect);
                });
                if (activeIndex !== nextIndex) {
                    handleSlideChange(nextIndex);
                }
            });
        };
        scrollableEl.addEventListener('scroll', handleScroll);
        return function() {
            return scrollableEl.removeEventListener('scroll', handleScroll);
        };
    }, [
        scrollableEl,
        handleSlideChange,
        getIsActiveSlide,
        activeIndex
    ]);
    return {
        activeIndex: activeIndex,
        goToSlide: goToSlide
    };
}

;// ./src/components/IndexButton/IndexButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const IndexButton = ({"button-size":"12px","buttonSize":"12px","button-size-green":"10px","buttonSizeGreen":"10px","button-margin-green":"5px","buttonMarginGreen":"5px","button":"BnH_C8","dark":"jGXHes","active":"JLpdmv","light":"_rMQY5","green":"oAO_rU"});
;// ./src/components/IndexButton/IndexButton.tsx
function IndexButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IndexButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IndexButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function IndexButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = IndexButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function IndexButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Modes = [
    'light',
    'dark',
    'green'
];
/**
 * Render a small button that can be used to indicate the active index of a list
 * of items.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/indexbutton | IndexButton} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var IndexButton_IndexButton = function(_param) {
    var active = _param.active, _param_mode = _param.mode, mode = _param_mode === void 0 ? 'dark' : _param_mode, className = _param.className, props = IndexButton_object_without_properties(_param, [
        "active",
        "mode",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", IndexButton_object_spread({
        type: "button",
        className: (0,external_classnames_namespaceObject["default"])(styles_button.button, IndexButton.button, className, IndexButton[mode], IndexButton_define_property({}, IndexButton.active, active))
    }, props));
};

;// external "lodash/round"
var round_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var round_y = (x) => (() => (x))
const round_namespaceObject = round_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_lodash_round_5c2fdcd3__["default"]) });
;// external "bezier-easing"
var external_bezier_easing_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_bezier_easing_y = (x) => (() => (x))
const external_bezier_easing_namespaceObject = external_bezier_easing_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_bezier_easing_32289db5__["default"]) });
;// ./src/components/Gallery/animations.ts

var notWide = {
    curve: (0,external_bezier_easing_namespaceObject["default"])(0.25, 0.75, 1, 1),
    minScale: 0.83,
    maxScale: 1
};
var wide = {
    curve: (0,external_bezier_easing_namespaceObject["default"])(0, 0, 1, 0.25),
    minScale: 0.83,
    maxScale: 1
};

;// ./src/components/Gallery/getScale.ts
/**
 * Return a number between min and max based on progress. Progress should be a
 * decimal between 0 and 1 that represents how much of the task (usually
 * animation) has been completed.
 *
 * @example
 *
 * const startingScale = 15;
 * const endingScale = 115;
 * const progress = 0.6 // compute this linearly or along a bezier curve
 *
 * const currentX = getScale(progress, startingScale, endingScale)
 */ function getScale(progress, minScale, maxScale) {
    var scaleDistance = maxScale - minScale;
    var scale = minScale + scaleDistance * progress;
    return scale;
}

;// ./src/components/Gallery/Slide.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Slide = ({"slide":"jRUJgP","button":"zeeKAJ","animation-reference":"BfXnax","animationReference":"BfXnax","animation-debug":"BMsCd1","animationDebug":"BMsCd1","is-not-wide":"eFQtVw","isNotWide":"eFQtVw","is-wide":"V9IFrG","isWide":"V9IFrG","active":"DoC6SB","inactive":"Yj8muw"});
;// ./src/components/Gallery/Slide.tsx
function Slide_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Slide_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Slide_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Slide_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Slide_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Slide_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Slide_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Slide_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Slide_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var Slide_Slide = function(_param) {
    var children = _param.children, className = _param.className, _param_isWide = _param.isWide, isWide = _param_isWide === void 0 ? false : _param_isWide, index = _param.index, intersectionRatio = _param.intersectionRatio, _param_isDebug = _param.isDebug, isDebug = _param_isDebug === void 0 ? false : _param_isDebug, active = _param.active, props = Slide_object_without_properties(_param, [
        "children",
        "className",
        "isWide",
        "index",
        "intersectionRatio",
        "isDebug",
        "active"
    ]);
    var responsiveAnimation = !isWide ? notWide : wide;
    var style = external_react_namespaceObject.useMemo(function() {
        var minScale = responsiveAnimation.minScale, maxScale = responsiveAnimation.maxScale, curve = responsiveAnimation.curve;
        var progress = curve(intersectionRatio);
        var scale = getScale(progress, minScale, maxScale);
        return {
            transform: "scale(".concat(scale, ")")
        };
    }, [
        intersectionRatio,
        responsiveAnimation
    ]);
    var showDebug = index === 2 && isDebug;
    var activeStyle = active ? Slide.active : Slide.inactive;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("li", {
        className: (0,external_classnames_namespaceObject["default"])(Slide.slide, className, (_obj = {}, Slide_define_property(_obj, Slide.isWide, isWide), Slide_define_property(_obj, Slide.isNotWide, !isWide), _obj)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: (0,external_classnames_namespaceObject["default"])(Slide.animationReference, showDebug && Slide.animationDebug),
                children: showDebug && "Animation reference intersection ".concat((0,round_namespaceObject["default"])(intersectionRatio, 2))
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", Slide_object_spread_props(Slide_object_spread({
                className: (0,external_classnames_namespaceObject["default"])(Slide.button, styles_button.button, activeStyle),
                style: style
            }, props), {
                children: children
            }))
        ]
    });
};

;// ./src/components/Gallery/getIsActiveSlide.ts
/**
 * Return a boolean indicating if the slide should be marked as the currently
 * active slide.
 */ function getIsActiveSlide(slideRect, scrollableRect) {
    var scrollableCenter = scrollableRect.left + scrollableRect.width / 2;
    return scrollableCenter > slideRect.left && scrollableCenter < slideRect.right;
}

;// ./src/components/Gallery/Gallery.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Gallery = ({"container":"JhQOJM","horizontalSnap":"PRwCB0","message":"egSv6N","dots":"MjehCr","arrow-button":"PTgj4C","arrowButton":"PTgj4C","button-icon-back":"ksmoQA","buttonIconBack":"ksmoQA","forward-button":"k_PWpW","forwardButton":"k_PWpW","is-not-wide":"DRUHtE","isNotWide":"DRUHtE","is-wide":"ktvQlB","isWide":"ktvQlB"});
;// ./src/components/Gallery/Gallery.tsx
function Gallery_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Gallery_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Gallery_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Gallery_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Gallery_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Gallery_sliced_to_array(arr, i) {
    return Gallery_array_with_holes(arr) || Gallery_iterable_to_array_limit(arr, i) || Gallery_unsupported_iterable_to_array(arr, i) || Gallery_non_iterable_rest();
}
function Gallery_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Gallery_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gallery_array_like_to_array(o, minLen);
}













/** Which contrast mode to use */ var GalleryModes = [
    'light',
    'dark'
];
var initialRatios = [];
/**
 * Render a gallery component. This component accepts any number of children
 * that will each be rendered as a slide for the gallery.
 *
 * !Requires `polyfillSmoothScroll()` on the client for full browser support.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/gallery | Gallery} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Gallery_Gallery = function(param) {
    var _param_mode = param.mode, mode = _param_mode === void 0 ? 'dark' : _param_mode, children = param.children, label = param.label, onSlideChange = param.onSlideChange, _param_withDots = param.withDots, withDots = _param_withDots === void 0 ? false : _param_withDots, onActiveSlideClick = param.onActiveSlideClick, footnote = param.footnote, activeIndexProp = param.activeIndex, _param_isWide = param.isWide, isWide = _param_isWide === void 0 ? false : _param_isWide, className = param.className, _param_isDebug = param.isDebug, isDebug = _param_isDebug === void 0 ? false : _param_isDebug;
    var id = (0,external_react_namespaceObject.useId)();
    var messageId = (0,external_react_namespaceObject.useId)();
    var numberOfSlides = external_react_namespaceObject["default"].Children.count(children);
    var _useHtmlElement = Gallery_sliced_to_array(useHtmlElement(), 2), scrollableEl = _useHtmlElement[0], scrollableRef = _useHtmlElement[1];
    var _React_useState = Gallery_sliced_to_array(external_react_namespaceObject["default"].useState(initialRatios), 2), intersectionRatios = _React_useState[0], setIntersectionRatios = _React_useState[1];
    var _useSlideShow = useSlideShow({
        scrollableEl: scrollableEl,
        scrollBehavior: 'smooth',
        getIsActiveSlide: getIsActiveSlide,
        onSlideChange: onSlideChange,
        activeIndex: activeIndexProp
    }), activeIndex = _useSlideShow.activeIndex, goToSlide = _useSlideShow.goToSlide;
    var handleScroll = external_react_namespaceObject["default"].useCallback(function() {
        var nextIntersectionRatios;
        external_fastdom_namespaceObject["default"].measure(function() {
            if (!scrollableEl) {
                return;
            }
            var scrollableRect = scrollableEl.getBoundingClientRect();
            var scrollableLeft = scrollableRect.left;
            var scrollableRight = scrollableRect.right;
            var scrollableWidth = scrollableRect.width;
            var slides = Array.from(scrollableEl.children);
            nextIntersectionRatios = slides.map(function(slide) {
                var slideRect = slide.getBoundingClientRect();
                var slideCenter = slideRect.width / 2 + slideRect.left;
                var animationReferenceRight = slideCenter + scrollableRect.width / 2;
                var animationReferenceLeft = slideCenter - scrollableRect.width / 2;
                var isIntersectingLeft = animationReferenceLeft <= scrollableLeft && animationReferenceRight > scrollableLeft;
                var isIntersectingRight = animationReferenceRight >= scrollableRight && animationReferenceLeft < scrollableRight;
                if (isIntersectingRight) {
                    return (scrollableWidth - (animationReferenceRight - scrollableRight)) / scrollableWidth;
                }
                if (isIntersectingLeft) {
                    return (animationReferenceRight - scrollableLeft) / scrollableWidth;
                }
                return 0;
            });
            external_fastdom_namespaceObject["default"].mutate(function() {
                setIntersectionRatios(nextIntersectionRatios);
            });
        });
    }, [
        scrollableEl
    ]);
    // Set up initial positions when element is rendered
    external_react_namespaceObject["default"].useEffect(function() {
        handleScroll();
    }, [
        handleScroll
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("section", {
        "aria-label": label,
        className: (0,external_classnames_namespaceObject["default"])(className, (_obj = {}, Gallery_define_property(_obj, Gallery.isWide, isWide), Gallery_define_property(_obj, Gallery.isNotWide, !isWide), _obj)),
        "data-active-slide": activeIndex,
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
                className: Gallery.container,
                children: [
                    isWide && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", {
                                onClick: function() {
                                    return goToSlide(activeIndex - 1);
                                },
                                className: (0,external_classnames_namespaceObject["default"])(Gallery.arrowButton),
                                disabled: activeIndex === 0,
                                "aria-label": "Previous Slide",
                                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Chevron, {
                                    fill: mode === 'light' ? 'white' : 'kale-3',
                                    size: 72,
                                    className: (0,external_classnames_namespaceObject["default"])(Gallery.buttonIcon, Gallery.buttonIconBack)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("button", {
                                onClick: function() {
                                    return goToSlide(activeIndex + 1);
                                },
                                className: (0,external_classnames_namespaceObject["default"])(Gallery.arrowButton, Gallery.forwardButton),
                                disabled: activeIndex === numberOfSlides - 1,
                                "aria-label": "Next Slide",
                                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Chevron, {
                                    fill: mode === 'light' ? 'white' : 'kale-3',
                                    size: 72,
                                    className: Gallery.buttonIcon
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ScrollSnap_ScrollSnap, {
                        as: "ul",
                        id: id,
                        ref: scrollableRef,
                        className: Gallery.horizontalSnap,
                        onScroll: handleScroll,
                        children: external_react_namespaceObject["default"].Children.map(children, function(child, index) {
                            var handleClick = index === activeIndex ? onActiveSlideClick : function() {
                                return goToSlide(index);
                            };
                            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Slide_Slide, {
                                "aria-label": "".concat(index + 1, " of ").concat(numberOfSlides),
                                "aria-describedby": messageId,
                                onClick: handleClick,
                                isDebug: isDebug,
                                isWide: isWide,
                                index: index,
                                intersectionRatio: intersectionRatios[index],
                                active: index === activeIndex,
                                children: child
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(LiveMessage_LiveMessage, {
                "aria-live": "polite",
                id: messageId,
                className: Gallery.message,
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                    variant: "heading-16",
                    color: mode === 'dark' ? 'kale-3' : 'white',
                    children: footnote
                })
            }),
            withDots && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: Gallery.dots,
                children: external_react_namespaceObject["default"].Children.map(children, function(_, childIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(IndexButton_IndexButton, {
                        mode: mode,
                        "aria-label": "Go to slide ".concat(childIndex),
                        "aria-controls": id,
                        active: childIndex === activeIndex,
                        onClick: function() {
                            return goToSlide(childIndex);
                        }
                    });
                })
            })
        ]
    });
};

;// ./src/components/Gallery/index.ts


;// ./src/components/GridContainer/GridContainer.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const GridContainer = ({"container":"ytmIjG","skip-xs":"kdATNw","skipXs":"kdATNw","skip-sm":"TXpJbF","skipSm":"TXpJbF","skip-md":"wAk4PR","skipMd":"wAk4PR","skip-lg":"Iedy6N","skipLg":"Iedy6N","skip-xl":"kCMBqc","skipXl":"kCMBqc","disabled":"Dy05Jw"});
;// ./src/components/GridContainer/GridContainer.tsx
function GridContainer_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GridContainer_array_without_holes(arr) {
    if (Array.isArray(arr)) return GridContainer_array_like_to_array(arr);
}
function GridContainer_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GridContainer_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function GridContainer_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GridContainer_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GridContainer_define_property(target, key, source[key]);
        });
    }
    return target;
}
function GridContainer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function GridContainer_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        GridContainer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function GridContainer_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = GridContainer_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function GridContainer_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function GridContainer_to_consumable_array(arr) {
    return GridContainer_array_without_holes(arr) || GridContainer_iterable_to_array(arr) || GridContainer_unsupported_iterable_to_array(arr) || GridContainer_non_iterable_spread();
}
function GridContainer_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GridContainer_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GridContainer_array_like_to_array(o, minLen);
}



var GridContainerBreakpoints = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
var GridContainerHTMLElements = [
    'div',
    'ul'
];
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/grid | Grid} from corgi-x to create grid layouts. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ function GridContainer_GridContainer(_param) {
    var children = _param.children, _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, _param_skip = _param.skip, skip = _param_skip === void 0 ? [] : _param_skip, className = _param.className, tmp = _param.as, HTMLElement = tmp === void 0 ? 'div' : tmp, props = GridContainer_object_without_properties(_param, [
        "children",
        "enabled",
        "skip",
        "className",
        "as"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(HTMLElement, GridContainer_object_spread_props(GridContainer_object_spread({
        className: external_classnames_namespaceObject["default"].apply(void 0, [
            GridContainer.container,
            GridContainer_define_property({}, GridContainer.disabled, !enabled)
        ].concat(GridContainer_to_consumable_array(skip.map(function(s) {
            return GridContainer["skip-".concat(s)];
        })), [
            className
        ]))
    }, props), {
        children: children
    }));
}

;// ./src/components/GridContainer/index.ts


;// ./src/components/PageWidth/PageWidth.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const PageWidth = ({"container":"A8BffM","skip-xs":"o5ypPe","skipXs":"o5ypPe","skip-sm":"dHa93m","skipSm":"dHa93m","skip-md":"Al6uLK","skipMd":"Al6uLK","skip-lg":"t26bP6","skipLg":"t26bP6","skip-xl":"pe7rwu","skipXl":"pe7rwu","disabled":"aR9YQs"});
;// ./src/components/PageWidth/PageWidth.tsx
function PageWidth_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PageWidth_array_without_holes(arr) {
    if (Array.isArray(arr)) return PageWidth_array_like_to_array(arr);
}
function PageWidth_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PageWidth_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function PageWidth_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PageWidth_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PageWidth_define_property(target, key, source[key]);
        });
    }
    return target;
}
function PageWidth_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PageWidth_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PageWidth_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PageWidth_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = PageWidth_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PageWidth_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function PageWidth_to_consumable_array(arr) {
    return PageWidth_array_without_holes(arr) || PageWidth_iterable_to_array(arr) || PageWidth_unsupported_iterable_to_array(arr) || PageWidth_non_iterable_spread();
}
function PageWidth_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PageWidth_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PageWidth_array_like_to_array(o, minLen);
}



var PageWidthBreakpoints = (/* unused pure expression or super */ null && ([
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]));
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/pagewidth | PageWidth} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var PageWidth_PageWidth = function(_param) {
    var children = _param.children, _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, _param_skip = _param.skip, skip = _param_skip === void 0 ? [] : _param_skip, className = _param.className, props = PageWidth_object_without_properties(_param, [
        "children",
        "enabled",
        "skip",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", PageWidth_object_spread_props(PageWidth_object_spread({
        className: external_classnames_namespaceObject["default"].apply(void 0, [
            PageWidth.container,
            PageWidth_define_property({}, PageWidth.disabled, !enabled)
        ].concat(PageWidth_to_consumable_array(skip.map(function(s) {
            return PageWidth["skip-".concat(s)];
        })), [
            className
        ]))
    }, props), {
        children: children
    }));
};

;// ./src/components/Hero/Hero.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Hero = ({"section":"axJH4n","background":"Sjqyhz","content":"nCD4ER","title":"ur3i2i","subtitle":"bCK22E","cta":"acOmCn"});
;// ./src/components/Hero/Hero.tsx
function Hero_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Hero_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Hero_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Hero_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Hero_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Hero_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Hero_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Hero_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Hero_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/hero | Hero} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Hero_Hero = function(_param) {
    var title = _param.title, titleProps = _param.titleProps, subtitle = _param.subtitle, subtitleProps = _param.subtitleProps, ctaLabel = _param.ctaLabel, ctaProps = _param.ctaProps, _param_withCta = _param.withCta, withCta = _param_withCta === void 0 ? true : _param_withCta, background = _param.background, className = _param.className, props = Hero_object_without_properties(_param, [
        "title",
        "titleProps",
        "subtitle",
        "subtitleProps",
        "ctaLabel",
        "ctaProps",
        "withCta",
        "background",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("section", Hero_object_spread_props(Hero_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(Hero.section, className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: Hero.background,
                children: background
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(PageWidth_PageWidth, {
                className: Hero.content,
                style: {
                    marginTop: LOGO_SIZE
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, Hero_object_spread_props(Hero_object_spread({
                        as: "h1",
                        color: "white",
                        bold: true,
                        className: Hero.title
                    }, titleProps), {
                        children: title
                    })),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, Hero_object_spread_props(Hero_object_spread({
                        as: "h2",
                        color: "white",
                        bold: true,
                        className: Hero.subtitle
                    }, subtitleProps), {
                        children: subtitle
                    })),
                    withCta && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Link_Link, Hero_object_spread_props(Hero_object_spread({
                        asButton: true,
                        variant: "primary",
                        className: Hero.cta
                    }, ctaProps), {
                        children: ctaLabel
                    }))
                ]
            })
        ]
    }));
};

;// ./src/components/Hero/index.ts


;// ./src/components/HorizontalNavigation/index.ts


;// ./src/components/HorizontalNavigationItem/index.ts


;// ./src/components/IndexButton/index.ts


;// ./src/components/ListSelect/ListSelectOption.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ListSelectOption = ({"label":"I_hH8B","normal":"MMBmQo","badge":"NGJ_br","recommended":"yO2yo0","checkbox":"FTEkdK","disabled":"vJwd8W","focus":"uvskVj","checked":"pqBxQ4","badge-text":"q6XEv1","badgeText":"q6XEv1","input":"WDXbOj"});
;// ./src/components/ListSelect/ListSelectOption.tsx
function ListSelectOption_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListSelectOption_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListSelectOption_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListSelectOption_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ListSelectOption_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListSelectOption_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListSelectOption_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ListSelectOption_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ListSelectOption_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ListSelectOption_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ListSelectOption_sliced_to_array(arr, i) {
    return ListSelectOption_array_with_holes(arr) || ListSelectOption_iterable_to_array_limit(arr, i) || ListSelectOption_unsupported_iterable_to_array(arr, i) || ListSelectOption_non_iterable_rest();
}
function ListSelectOption_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListSelectOption_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListSelectOption_array_like_to_array(o, minLen);
}









var ListSelectOptionComponent = function(_param) {
    var label = _param.label, invalid = _param.invalid, forwardedRef = _param.forwardedRef, onBlur = _param.onBlur, onFocus = _param.onFocus, withCheckbox = _param.withCheckbox, withRadio = _param.withRadio, badge = _param.badge, className = _param.className, labelRef = _param.labelRef, style = _param.style, children = _param.children, props = ListSelectOption_object_without_properties(_param, [
        "label",
        "invalid",
        "forwardedRef",
        "onBlur",
        "onFocus",
        "withCheckbox",
        "withRadio",
        "badge",
        "className",
        "labelRef",
        "style",
        "children"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = ListSelectOption_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("label", {
        ref: labelRef,
        className: (0,external_classnames_namespaceObject["default"])(ListSelectOption.label, ListSelectOption[state], className, ListSelectOption_define_property({}, ListSelectOption.checked, props.checked)),
        style: style,
        children: [
            badge && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: (0,external_classnames_namespaceObject["default"])(ListSelectOption.badge, (_obj = {}, ListSelectOption_define_property(_obj, ListSelectOption.checked, props.checked), ListSelectOption_define_property(_obj, ListSelectOption.recommended, props.recommended), ListSelectOption_define_property(_obj, ListSelectOption.disabled, state === 'disabled'), _obj)),
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                    role: "status",
                    variant: "heading-12",
                    className: ListSelectOption.badgeText,
                    children: badge
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                        as: "div",
                        variant: "heading-22",
                        color: state === 'disabled' ? 'charcoal-1' : 'kale-3',
                        bold: true,
                        children: label || props.name || ''
                    }),
                    props.description && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                        as: "div",
                        variant: "heading-16",
                        color: state === 'disabled' ? 'charcoal-1' : 'charcoal-3',
                        children: props.description
                    }),
                    children
                ]
            }),
            withCheckbox && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                className: ListSelectOption.checkbox,
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(CheckboxView, {
                    checked: props.checked,
                    state: state
                })
            }),
            withRadio && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(RadioView, {
                checked: props.checked,
                state: state
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("input", ListSelectOption_object_spread({
                ref: forwardedRef,
                className: (0,external_classnames_namespaceObject["default"])(accessibility.hidden, ListSelectOption.input),
                onBlur: interceptEvent(handlers.onBlur, onBlur),
                onFocus: interceptEvent(handlers.onFocus, onFocus),
                "data-checked": props.checked
            }, props))
        ]
    });
};
var ListSelectOption_ListSelectOption = withRef(ListSelectOptionComponent);

;// ./src/components/ListSelect/getInitialValue.ts
/**
 * Get the initial state value according to the input props. Initial state
 * depends on whether or not multiple selections are available as well as
 * whether or not a `value` prop is passed in.
 */ function getInitialValue_getInitialValue(value, multi) {
    var isControlled = typeof value !== 'undefined';
    if (isControlled) {
        return value;
    }
    if (multi) {
        return [];
    }
    return undefined;
}
/* harmony default export */ const ListSelect_getInitialValue = (getInitialValue_getInitialValue);

;// ./src/components/ListSelect/includesCastValue.ts
/**
 * Returns a boolean indicating whether or not the array contains an item that
 * matches the stringified argument.
 */ function includesCastValue_includesCastValue(value, child) {
    if (!Array.isArray(value)) {
        return false;
    }
    return typeof value.find(function(value) {
        return String(value) === String(child);
    }) !== 'undefined';
}
/* harmony default export */ const ListSelect_includesCastValue = (includesCastValue_includesCastValue);

;// ./src/util/accessibility/constants.ts
var PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

;// ./src/util/accessibility/getPreferredScrollBehavior.ts


var Behavior = /*#__PURE__*/ function(Behavior) {
    Behavior["auto"] = "auto";
    Behavior["smooth"] = "smooth";
    return Behavior;
}({});
function getPreferredScrollBehavior() {
    return browserOnly(function(window) {
        var mediaQuery = window.matchMedia(PREFERS_REDUCED_MOTION_QUERY);
        var behavior = mediaQuery.matches ? "auto" : "smooth";
        return behavior;
    });
}

;// ./src/components/ListSelect/ListSelect.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ListSelect = ({"fieldset":"EPJSoo","badge":"bHm_gU","two-column":"arO8ZL","twoColumn":"arO8ZL","horizontal":"NR_GtH"});
;// ./src/components/ListSelect/ListSelect.tsx
function ListSelect_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListSelect_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListSelect_array_without_holes(arr) {
    if (Array.isArray(arr)) return ListSelect_array_like_to_array(arr);
}
function ListSelect_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListSelect_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ListSelect_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ListSelect_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListSelect_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListSelect_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ListSelect_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ListSelect_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ListSelect_sliced_to_array(arr, i) {
    return ListSelect_array_with_holes(arr) || ListSelect_iterable_to_array_limit(arr, i) || ListSelect_unsupported_iterable_to_array(arr, i) || ListSelect_non_iterable_rest();
}
function ListSelect_to_consumable_array(arr) {
    return ListSelect_array_without_holes(arr) || ListSelect_iterable_to_array(arr) || ListSelect_unsupported_iterable_to_array(arr) || ListSelect_non_iterable_spread();
}
function ListSelect_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListSelect_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListSelect_array_like_to_array(o, minLen);
}








/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/togglebox | ToggleBox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var ListSelect_ListSelect = function(_param) {
    var _param_multi = _param.multi, multi = _param_multi === void 0 ? false : _param_multi, children = _param.children, label = _param.label, name = _param.name, onChange = _param.onChange, withTwoColumn = _param.withTwoColumn, className = _param.className, _param_direction = _param.direction, direction = _param_direction === void 0 ? 'vertical' : _param_direction, props = ListSelect_object_without_properties(_param, [
        "multi",
        "children",
        "label",
        "name",
        "onChange",
        "withTwoColumn",
        "className",
        "direction"
    ]);
    var horizontalDirection = direction === 'horizontal';
    var _useState = ListSelect_sliced_to_array((0,external_react_namespaceObject.useState)(ListSelect_getInitialValue(props.value, multi)), 2), internalValue = _useState[0], setInternalValue = _useState[1];
    var value = typeof props.value !== 'undefined' ? props.value : internalValue;
    var handleChange = function(e) {
        var eventValue = e.target.value;
        if (!(multi && Array.isArray(value))) {
            setInternalValue(eventValue);
            return;
        }
        var nextValue = ListSelect_includesCastValue(value, eventValue) ? value.filter(function(lastValue) {
            return String(lastValue) !== eventValue;
        }) : ListSelect_to_consumable_array(value).concat([
            eventValue
        ]);
        setInternalValue(nextValue);
    };
    var getChecked = function(childValue) {
        if (multi && Array.isArray(value)) {
            return ListSelect_includesCastValue(value, childValue);
        }
        return String(value) === String(childValue);
    };
    var fieldsetRef = (0,external_react_namespaceObject.useRef)(null);
    var selectedOptionRef = (0,external_react_namespaceObject.useRef)(null);
    (0,external_react_namespaceObject.useEffect)(function() {
        var _fieldsetRef_current;
        // Check that scrollTo exists as jsdom doesn't include it
        if (((_fieldsetRef_current = fieldsetRef.current) === null || _fieldsetRef_current === void 0 ? void 0 : _fieldsetRef_current.scrollTo) && selectedOptionRef.current) {
            var fieldsetBoundingRect = fieldsetRef.current.getBoundingClientRect();
            var selectedOptionBoundingRect = selectedOptionRef.current.getBoundingClientRect();
            if (horizontalDirection) {
                var scrollOffset = fieldsetBoundingRect.left;
                var centerOffset = fieldsetBoundingRect.width / 2 - selectedOptionBoundingRect.width / 2;
                var left = selectedOptionBoundingRect.left - scrollOffset - centerOffset;
                fieldsetRef.current.scrollTo({
                    left: left,
                    behavior: getPreferredScrollBehavior()
                });
            } else {
                var scrollOffset1 = fieldsetBoundingRect.top;
                var centerOffset1 = fieldsetBoundingRect.height / 2 - selectedOptionBoundingRect.height / 2;
                var top = selectedOptionBoundingRect.top - scrollOffset1 - centerOffset1;
                fieldsetRef.current.scrollTo({
                    top: top,
                    behavior: getPreferredScrollBehavior()
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("fieldset", {
        ref: fieldsetRef,
        className: (0,external_classnames_namespaceObject["default"])(ListSelect.fieldset, className, (_obj = {}, ListSelect_define_property(_obj, ListSelect.twoColumn, Boolean(withTwoColumn)), ListSelect_define_property(_obj, ListSelect.horizontal, horizontalDirection), _obj)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("legend", {
                className: accessibility.hidden,
                children: label || name
            }),
            external_react_namespaceObject.Children.map(children, function(listSelectOption) {
                if (!(listSelectOption && listSelectOption.props)) {
                    return listSelectOption;
                }
                var optionProps = listSelectOption.props;
                var checked = getChecked(listSelectOption.props.value);
                return /*#__PURE__*/ (0,external_react_namespaceObject.cloneElement)(listSelectOption, {
                    name: name,
                    onChange: interceptEvent(listSelectOption.props.onChange, handleChange, onChange),
                    labelRef: checked ? selectedOptionRef : undefined,
                    checked: checked,
                    type: multi ? 'checkbox' : 'radio',
                    className: (0,external_classnames_namespaceObject["default"])(optionProps.className, ListSelect_define_property({}, ListSelect.badge, Boolean(optionProps.badge)))
                });
            })
        ]
    });
};

;// ./src/components/ListSelect/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity



;// ./src/components/Logo/index.ts


;// ./src/components/Wave/assets/wave.svg
function wave_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function wave_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            wave_define_property(target, key, source[key]);
        });
    }
    return target;
}
function wave_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function wave_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        wave_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var SvgWave = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("svg", wave_object_spread_props(wave_object_spread({
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("path", {
            d: "M100 100 H0 V100 H0 V50 C 33.3333 100, 66.6666 0, 100 50"
        })
    }));
};
/* harmony default export */ const wave = (SvgWave);

;// ./src/components/Wave/Wave.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Wave = ({"container":"vKLL2B","background":"wPNgT2","top-wave":"XEPYRl","topWave":"XEPYRl","bottom-wave":"pMnrMO","bottomWave":"pMnrMO","margin-xxs":"PPGzZx","marginXxs":"PPGzZx","margin-xs":"Zbpawv","marginXs":"Zbpawv","margin-sm":"WSKxW8","marginSm":"WSKxW8","margin-md":"eKaeX8","marginMd":"eKaeX8","margin-lg":"v7A7Fa","marginLg":"v7A7Fa","margin-xl":"PnXKmR","marginXl":"PnXKmR","margin-xxl":"ePH_DW","marginXxl":"ePH_DW","margin-3xl":"oEqkgy","margin3Xl":"oEqkgy","margin-4xl":"BDxqyx","margin4Xl":"BDxqyx","kale-3":"QydUhu","kale3":"QydUhu","white":"r2bc9u","charcoal-3":"YIYzKo","charcoal3":"YIYzKo","charcoal-1":"h1es5V","charcoal1":"h1es5V","charcoal-0":"V5KiIy","charcoal0":"V5KiIy","oyster-0":"JVJmc1","oyster0":"JVJmc1","kale-1":"QfqhRA","kale1":"QfqhRA","carrot-1":"ngkBbp","carrot1":"ngkBbp","chickpea-2":"HdJymN","chickpea2":"HdJymN","chickpea-1":"MITxVT","chickpea1":"MITxVT"});
;// ./src/components/Wave/Wave.tsx
function Wave_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Wave_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Wave_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Wave_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Wave_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Wave_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Wave_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Wave_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Wave_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var WaveFills = (/* unused pure expression or super */ null && ([
    'kale-3',
    'white',
    'charcoal-1',
    'charcoal-3',
    'oyster-0',
    'charcoal-0',
    'kale-1',
    'carrot-1',
    'chickpea-2',
    'chickpea-1'
]));
var WaveMargins = (/* unused pure expression or super */ null && ([
    'margin-xxs',
    'margin-xs',
    'margin-sm',
    'margin-md',
    'margin-lg',
    'margin-xl',
    'margin-xxl',
    'margin-3xl',
    'margin-4xl'
]));
/**
 * Render an interface
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/wave | Wave} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Wave_Wave = function(_param) {
    var className = _param.className, children = _param.children, withTop = _param.withTop, withBottom = _param.withBottom, topClassName = _param.topClassName, bottomClassName = _param.bottomClassName, _param_fill = _param.fill, fill = _param_fill === void 0 ? 'chickpea-1' : _param_fill, padding = _param.padding, _param_waveHeight = _param.waveHeight, waveHeight = _param_waveHeight === void 0 ? 24 : _param_waveHeight, _param_topTransform = _param.topTransform, topTransform = _param_topTransform === void 0 ? 'scaleX(-1)' : _param_topTransform, _param_bottomTransform = _param.bottomTransform, bottomTransform = _param_bottomTransform === void 0 ? 'scaleX(-1) rotate(180deg)' : _param_bottomTransform, props = Wave_object_without_properties(_param, [
        "className",
        "children",
        "withTop",
        "withBottom",
        "topClassName",
        "bottomClassName",
        "fill",
        "padding",
        "waveHeight",
        "topTransform",
        "bottomTransform"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0,external_classnames_namespaceObject["default"])(Wave.container, className, Wave[fill]),
        children: [
            withTop && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(wave, {
                className: (0,external_classnames_namespaceObject["default"])(Wave.topWave, topClassName),
                style: {
                    height: waveHeight,
                    transform: topTransform
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", Wave_object_spread_props(Wave_object_spread({
                className: (0,external_classnames_namespaceObject["default"])(Wave.background, padding ? Wave[padding] : null)
            }, props), {
                children: children
            })),
            withBottom && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(wave, {
                className: (0,external_classnames_namespaceObject["default"])(Wave.bottomWave, bottomClassName),
                style: {
                    height: waveHeight,
                    transform: bottomTransform
                }
            })
        ]
    });
};

;// ./src/styles/margins/margins.ts
var MARGIN_XXS = '2px';
var MARGIN_XS = '6px';
var MARGIN_SM = '12px';
var MARGIN_MD = '24px';
var MARGIN_LG = '36px';
var MARGIN_XL = '48px';
var MARGIN_XXL = '72px';
var MARGIN_3XL = '96px';
var MARGIN_4XL = '120px';

;// ./src/components/Modal/Modal.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Modal = ({"close-button":"reAfyb","closeButton":"reAfyb"});
;// ./src/components/Modal/Modal.tsx
function Modal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Modal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Modal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Modal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Modal_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Modal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Modal_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Modal_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Modal_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var UNSET_WIDTH = '';
var MIN_HEIGHT = 0;
var Modal_Modal = function(_param) {
    var children = _param.children, rootProps = _param.rootProps, _param_disableInteractions = _param.disableInteractions, disableInteractions = _param_disableInteractions === void 0 ? false : _param_disableInteractions, waveSectionContent = _param.waveSectionContent, className = _param.className, props = Modal_object_without_properties(_param, [
        "children",
        "rootProps",
        "disableInteractions",
        "waveSectionContent",
        "className"
    ]);
    var isWaveDesign = Boolean(waveSectionContent);
    var modalDesign = getModalDesign_getModalDesign();
    var nonWaveDesign = getNonWaveDesign();
    var _getWaveDesign = getWaveDesign(), waveSectionDesign = _getWaveDesign.waveSectionDesign, belowWaveSectionDesign = _getWaveDesign.belowWaveSectionDesign;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(Lightbox_Lightbox, Modal_object_spread_props(Modal_object_spread({
        width: UNSET_WIDTH,
        height: MIN_HEIGHT,
        className: (0,external_classnames_namespaceObject["default"])(modalDesign, className, Modal_define_property({}, nonWaveDesign, !isWaveDesign)),
        disableInteractions: disableInteractions
    }, rootProps, props), {
        children: [
            !disableInteractions && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(CloseButton_CloseButton, {
                onClick: props.close,
                className: Modal.closeButton
            }),
            isWaveDesign && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Wave_Wave, {
                        fill: "chickpea-1",
                        waveHeight: MARGIN_XL,
                        withBottom: true,
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                            className: waveSectionDesign,
                            children: waveSectionContent
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                        className: belowWaveSectionDesign,
                        children: children
                    })
                ]
            }),
            !isWaveDesign && children
        ]
    }));
};

;// ./src/components/Modal/index.ts


;// ./src/components/ResponsiveText/ResponsiveText.tsx
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ function ResponsiveText_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ResponsiveText_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ResponsiveText_array_without_holes(arr) {
    if (Array.isArray(arr)) return ResponsiveText_array_like_to_array(arr);
}
function ResponsiveText_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ResponsiveText_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ResponsiveText_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ResponsiveText_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ResponsiveText_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ResponsiveText_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ResponsiveText_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ResponsiveText_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ResponsiveText_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ResponsiveText_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ResponsiveText_sliced_to_array(arr, i) {
    return ResponsiveText_array_with_holes(arr) || ResponsiveText_iterable_to_array_limit(arr, i) || ResponsiveText_unsupported_iterable_to_array(arr, i) || ResponsiveText_non_iterable_rest();
}
function ResponsiveText_to_consumable_array(arr) {
    return ResponsiveText_array_without_holes(arr) || ResponsiveText_iterable_to_array(arr) || ResponsiveText_unsupported_iterable_to_array(arr) || ResponsiveText_non_iterable_spread();
}
function ResponsiveText_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ResponsiveText_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ResponsiveText_array_like_to_array(o, minLen);
}



/** The available variants of article.
 * Article has a different font family than heading and body.
 * article-3 should only be used for labels
 */ var ArticleTextVariants = [
    'article-1',
    'article-2',
    'article-3'
];
/** The available variants of body.
 * body-3 should only be used for labels
 */ var BodyTextVariants = [
    'body-1',
    'body-2',
    'body-3'
];
/** The available variants of heading.
 * Heading always has a bold font styles
 */ var HeadingTextVariants = [
    'heading-1',
    'heading-2',
    'heading-3',
    'heading-4',
    'heading-5'
];
var ResponsiveTextVariants = ResponsiveText_to_consumable_array(ArticleTextVariants).concat(ResponsiveText_to_consumable_array(BodyTextVariants), ResponsiveText_to_consumable_array(HeadingTextVariants));
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/text | Text} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ function ResponsiveText(_param) {
    var tmp = _param.as, TypographyHTMLElementTag = tmp === void 0 ? 'span' : tmp, variant = _param.variant, _param_fontWeight = _param.fontWeight, fontWeight = _param_fontWeight === void 0 ? 'roman' : _param_fontWeight, fontStyle = _param.fontStyle, color = _param.color, className = _param.className, props = ResponsiveText_object_without_properties(_param, [
        "as",
        "variant",
        "fontWeight",
        "fontStyle",
        "color",
        "className"
    ]);
    var _variant_split = ResponsiveText_sliced_to_array(variant.split('-'), 2), type = _variant_split[0], size = _variant_split[1];
    var weight = fontWeight;
    if ([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ].includes(TypographyHTMLElementTag)) {
        weight = 'black';
    }
    // @ts-expect-error not sure why this works at runtime, but typescript isn't happy
    var typographyStyles = typography_namespaceObject[type].create({
        size: size,
        weight: weight,
        fontStyle: fontStyle,
        color: color
    });
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(TypographyHTMLElementTag, ResponsiveText_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(className, typographyStyles.className)
    }, props));
}

;// ./src/components/ResponsiveText/index.ts


;// ./src/components/RichSelector/RichSelector.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const RichSelector = ({"container":"h1bNcO","label":"hxOFKx","icon":"iY_6cN","input":"TZRotH","largeInput":"p9PyUM"});
;// ./src/components/RichSelector/RichSelector.tsx
function RichSelector_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RichSelector_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RichSelector_define_property(target, key, source[key]);
        });
    }
    return target;
}
function RichSelector_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RichSelector_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RichSelector_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RichSelector_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = RichSelector_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RichSelector_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









/**
 * Selector component to display very detailed options.  Can display an image
 * and extended description.  Also set up to connect sibling options together
 * via the `lineThroughDesign`
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/richselector | RichSelector} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var RichSelector_RichSelector = function(_param) {
    var label = _param.label, isFirst = _param.isFirst, isLast = _param.isLast, icon = _param.icon, description = _param.description, type = _param.type, stateProp = _param.state, props = RichSelector_object_without_properties(_param, [
        "label",
        "isFirst",
        "isLast",
        "icon",
        "description",
        "type",
        "state"
    ]);
    var isCheckbox = type === 'checkbox';
    var getInputDesign = isCheckbox ? getCheckboxDesign_getCheckboxDesign : getRadioDesign_getRadioDesign;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Selector_Selector, RichSelector_object_spread_props(RichSelector_object_spread({
        type: type
    }, props), {
        children: function(state) {
            var inputDesign = getInputDesign({
                state: stateProp !== null && stateProp !== void 0 ? stateProp : state,
                checked: props.checked
            });
            var lineThroughDesign = getLineThroughDesign_getLineThroughDesign({
                first: isFirst,
                last: isLast
            });
            return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
                className: (0,external_classnames_namespaceObject["default"])(RichSelector.container, RichSelector[state]),
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
                        className: RichSelector.icon,
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                        className: lineThroughDesign,
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                            className: (0,external_classnames_namespaceObject["default"])(inputDesign, RichSelector.input, RichSelector_define_property({}, RichSelector.largeInput, !icon)),
                            children: isCheckbox && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Check, {
                                fill: "white",
                                size: 12
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                        as: "span",
                        variant: "heading-16",
                        color: "kale-3",
                        className: RichSelector.label,
                        children: label
                    }),
                    description
                ]
            });
        }
    }));
};

;// ./src/components/RichSelector/index.ts


;// ./src/components/RichSelectorGroup/Description.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Description = ({"container":"hYaDQ1","position":"UXnXuR"});
;// ./src/components/RichSelectorGroup/Description.tsx
function Description_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Description_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Description_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Description_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Description_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Description_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Description_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Description_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Description_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Description_Description = function(_param) {
    var children = _param.children, className = _param.className, props = Description_object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(LiveMessage_LiveMessage, Description_object_spread_props(Description_object_spread({
        "aria-live": "polite",
        hidden: !props.in,
        className: Description.position
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
            as: "div",
            variant: "article-12",
            color: "carrot-2",
            fontStyle: "italic",
            className: (0,external_classnames_namespaceObject["default"])(Description.container, className),
            children: children
        })
    }));
};

;// ./src/components/RichSelectorGroup/RichSelectorGroup.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const RichSelectorGroup = ({"container":"ayubQy","inputs":"krj8Uy","descriptionPadding":"dVCSVA"});
;// ./src/components/RichSelectorGroup/RichSelectorGroup.tsx
function RichSelectorGroup_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function RichSelectorGroup_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function RichSelectorGroup_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RichSelectorGroup_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function RichSelectorGroup_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RichSelectorGroup_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RichSelectorGroup_define_property(target, key, source[key]);
        });
    }
    return target;
}
function RichSelectorGroup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RichSelectorGroup_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RichSelectorGroup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RichSelectorGroup_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = RichSelectorGroup_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RichSelectorGroup_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function RichSelectorGroup_sliced_to_array(arr, i) {
    return RichSelectorGroup_array_with_holes(arr) || RichSelectorGroup_iterable_to_array_limit(arr, i) || RichSelectorGroup_unsupported_iterable_to_array(arr, i) || RichSelectorGroup_non_iterable_rest();
}
function RichSelectorGroup_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return RichSelectorGroup_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RichSelectorGroup_array_like_to_array(o, minLen);
}






/**
 * SelectorGroup component meant to be used with the RichSelector component.
 *
 * Will manage RichSelector `isFirst`, `isLast`, and `description` props.
 *
 * Handles showing the description given the fullWidthDescription and the hover
 * or checked state of the RichSelectors
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/richselector | RichSelector} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var RichSelectorGroup_RichSelectorGroup = function(_param) {
    var value = _param.value, fullWidthDescription = _param.fullWidthDescription, defaultFullWidthDescription = _param.defaultFullWidthDescription, children = _param.children, props = RichSelectorGroup_object_without_properties(_param, [
        "value",
        "fullWidthDescription",
        "defaultFullWidthDescription",
        "children"
    ]);
    var id = (0,external_react_namespaceObject.useId)();
    var options = external_react_namespaceObject["default"].Children.map(children, function(child) {
        return child;
    });
    var selectedOption = options.find(function(option) {
        return option.props.value === value;
    });
    var hasDescriptions = options.some(function(option) {
        return Boolean(option.props.description);
    });
    var _React_useState = RichSelectorGroup_sliced_to_array(external_react_namespaceObject["default"].useState(selectedOption), 2), activeOption = _React_useState[0], setActiveOption = _React_useState[1];
    var handleOptionEnter = function(value) {
        var hoveredOption = options.find(function(option) {
            return option.props.value === value;
        });
        setActiveOption(hoveredOption);
    };
    var handleOptionLeave = function() {
        setActiveOption(selectedOption);
    };
    var activeOptionId = id && activeOption ? "".concat(id, "-").concat(String(activeOption.props.value)) : undefined;
    var activeOptionHasDescription = Boolean(activeOption === null || activeOption === void 0 ? void 0 : activeOption.props.description);
    var hasDefaultFullWithDescription = Boolean(defaultFullWidthDescription);
    var showFullWidthDescription = fullWidthDescription && (activeOptionHasDescription || hasDefaultFullWithDescription);
    var _activeOption_props_description;
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0,external_classnames_namespaceObject["default"])(RichSelectorGroup.container, RichSelectorGroup_define_property({}, RichSelectorGroup.descriptionPadding, hasDescriptions && fullWidthDescription)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(SelectorGroup_SelectorGroup, RichSelectorGroup_object_spread_props(RichSelectorGroup_object_spread({
                inputsClassName: RichSelectorGroup.inputs,
                value: value
            }, props), {
                children: options.map(function(option, index) {
                    var isActive = (activeOption === null || activeOption === void 0 ? void 0 : activeOption.props.value) === option.props.value;
                    var hasDescription = Boolean(option.props.description);
                    var descriptionId = id ? "".concat(id, "-").concat(String(option.props.value)) : undefined;
                    return /*#__PURE__*/ external_react_namespaceObject["default"].cloneElement(option, {
                        isFirst: index === 0,
                        isLast: index === options.length - 1,
                        labelProps: RichSelectorGroup_object_spread_props(RichSelectorGroup_object_spread({}, option.props.labelProps), {
                            onMouseEnter: function() {
                                return handleOptionEnter(option.props.value);
                            },
                            onMouseLeave: handleOptionLeave,
                            onFocus: function() {
                                return handleOptionEnter(option.props.value);
                            },
                            onBlur: handleOptionLeave
                        }),
                        className: (0,external_classnames_namespaceObject["default"])(option.props.className, RichSelectorGroup_define_property({}, RichSelectorGroup.descriptionPadding, hasDescriptions && !fullWidthDescription)),
                        'aria-describedby': descriptionId,
                        description: fullWidthDescription ? undefined : /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Description_Description, {
                            id: descriptionId,
                            in: isActive && hasDescription,
                            className: RichSelectorGroup.description,
                            children: option.props.description
                        })
                    });
                })
            })),
            showFullWidthDescription && /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Description_Description, {
                id: activeOptionId,
                in: activeOptionHasDescription || hasDefaultFullWithDescription,
                className: RichSelectorGroup.description,
                children: (_activeOption_props_description = activeOption === null || activeOption === void 0 ? void 0 : activeOption.props.description) !== null && _activeOption_props_description !== void 0 ? _activeOption_props_description : defaultFullWidthDescription
            })
        ]
    });
};

;// ./src/components/RichSelectorGroup/index.ts


;// ./src/components/Select/Arrow.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Select_Arrow = ({"container":"Lhs0CE","caret":"UyYQl2","left":"U6j1Bg","right":"DG6Dbv","chevron":"WAzhUJ"});
;// ./src/components/Select/hasValueSelected.ts


/**
 * Used to determine if an option is selected and it isn't an empty option
 */ var hasValueSelected = function(children) {
    if (!children) {
        return false;
    }
    var childArray = external_react_namespaceObject.Children.toArray(children);
    var firstChild = childArray[0];
    if (!(0,external_react_namespaceObject.isValidElement)(firstChild)) {
        return false;
    }
    var firstChildValue = firstChild.props.value;
    if (getHasValue(firstChildValue)) {
        return true;
    }
    return childArray.some(function(option) {
        if (!(0,external_react_namespaceObject.isValidElement)(option)) {
            return false;
        }
        var _option_props = option.props, selected = _option_props.selected, value = _option_props.value;
        return selected && getHasValue(value);
    });
};

;// ./src/components/Select/Select.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Select = ({"select":"bwIw36","regular":"Y8NqRF","bold":"sYP6Ks"});
;// ./src/components/Select/Select.tsx
function Select_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Select_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Select_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Select_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Select_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Select_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Select_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Select_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Select_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Select_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Select_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Select_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Select_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Select_sliced_to_array(arr, i) {
    return Select_array_with_holes(arr) || Select_iterable_to_array_limit(arr, i) || Select_unsupported_iterable_to_array(arr, i) || Select_non_iterable_rest();
}
function Select_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Select_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Select_array_like_to_array(o, minLen);
}










/** These are native props that we do not want to use and should protect ourselves */ var nativeOverrides = {
    autoFocus: false,
    multiple: false,
    defaultValue: undefined
};
var headingTypography = heading.create({
    size: 16
});
var bodyTypography = body.create({
    size: 16,
    weight: 'bold'
});
/**
 * Custom select component using native select element.
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/select | Select} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var SelectComponent = function(_param) {
    var label = _param.label, children = _param.children, className = _param.className, onChange = _param.onChange, onFocus = _param.onFocus, onBlur = _param.onBlur, forwardedRef = _param.forwardedRef, invalid = _param.invalid, highlighted = _param.highlighted, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, _param_icon = _param.icon, icon = _param_icon === void 0 ? 'caret' : _param_icon, _param_bold = _param.bold, bold = _param_bold === void 0 ? false : _param_bold, props = Select_object_without_properties(_param, [
        "label",
        "children",
        "className",
        "onChange",
        "onFocus",
        "onBlur",
        "forwardedRef",
        "invalid",
        "highlighted",
        "hideLabel",
        "icon",
        "bold"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = Select_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid,
        highlighted: highlighted
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _useState = Select_sliced_to_array((0,external_react_namespaceObject.useState)(getHasValue(props.value) || hasValueSelected(children)), 2), hasValue = _useState[0], setHasValue = _useState[1];
    (0,external_react_namespaceObject.useEffect)(function() {
        setHasValue(getHasValue(props.value) || hasValueSelected(children));
    }, [
        props.value,
        children
    ]);
    var handleChange = function(event) {
        var eventTarget = event.target;
        setHasValue(getHasValue(eventTarget.value));
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(BorderLabel_BorderLabel, {
        in: hasValue,
        state: state,
        text: label || props.name || '',
        className: className,
        hideLabel: hideLabel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("select", Select_object_spread_props(Select_object_spread({
                ref: forwardedRef,
                className: (0,external_classnames_namespaceObject["default"])(Select.select, bold ? bodyTypography.className : headingTypography.className, bold ? Select.bold : Select.regular),
                onChange: interceptEvent(handleChange, onChange),
                onBlur: interceptEvent(handlers.onBlur, onBlur),
                onFocus: interceptEvent(handlers.onFocus, onFocus),
                "aria-invalid": invalid
            }, props, nativeOverrides), {
                children: children
            })),
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                className: (0,external_classnames_namespaceObject["default"])(Select_Arrow.container, Select_Arrow[icon], Select_Arrow[state]),
                children: icon === 'chevron' ? /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Chevron, {
                    fill: "kale-3",
                    className: Select_Arrow.buttonIcon,
                    size: 36
                }) : /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Caret, {
                    fill: "kale-3",
                    className: Select_Arrow.buttonIcon,
                    size: 36
                })
            })
        ]
    });
};
var Select_Select = withRef(SelectComponent);

;// ./src/components/Select/index.ts


;// ./src/components/TextArea/TextArea.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const TextArea = ({"textarea":"JNP_3_","label":"y6FJ6c"});
;// ./src/components/TextArea/TextArea.tsx
function TextArea_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TextArea_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function TextArea_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TextArea_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TextArea_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TextArea_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TextArea_define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextArea_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function TextArea_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        TextArea_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function TextArea_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = TextArea_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function TextArea_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TextArea_sliced_to_array(arr, i) {
    return TextArea_array_with_holes(arr) || TextArea_iterable_to_array_limit(arr, i) || TextArea_unsupported_iterable_to_array(arr, i) || TextArea_non_iterable_rest();
}
function TextArea_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TextArea_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TextArea_array_like_to_array(o, minLen);
}







var TextArea_typography = heading.create({
    size: 16
});
var TextAreaComponent = function(_param) {
    var label = _param.label, className = _param.className, invalid = _param.invalid, onBlur = _param.onBlur, onChange = _param.onChange, onFocus = _param.onFocus, forwardedRef = _param.forwardedRef, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = TextArea_object_without_properties(_param, [
        "label",
        "className",
        "invalid",
        "onBlur",
        "onChange",
        "onFocus",
        "forwardedRef",
        "hideLabel"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = TextArea_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _React_useState = TextArea_sliced_to_array(external_react_namespaceObject.useState(typeof props.value !== 'undefined' ? props.value : ''), 2), value = _React_useState[0], setValue = _React_useState[1];
    external_react_namespaceObject.useEffect(function() {
        if (typeof props.value !== 'undefined') {
            setValue(props.value);
        }
    }, [
        props.value
    ]);
    var handleChange = function(event) {
        setValue(event.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(BorderLabel_BorderLabel, {
        className: (0,external_classnames_namespaceObject["default"])(TextArea.label, className),
        in: state === 'focus' || state === 'invalid' || getHasValue(value),
        text: label || props.name || '',
        state: state,
        hideLabel: hideLabel,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("textarea", TextArea_object_spread_props(TextArea_object_spread({
            ref: forwardedRef,
            className: (0,external_classnames_namespaceObject["default"])(TextArea.textarea, TextArea_typography.className),
            onChange: interceptEvent(handleChange, onChange),
            onFocus: interceptEvent(handlers.onFocus, onFocus),
            onBlur: interceptEvent(handlers.onBlur, onBlur),
            "aria-invalid": invalid
        }, props), {
            value: value,
            placeholder: undefined
        }))
    });
};
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/textarea | TextArea} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var TextArea_TextArea = withRef(TextAreaComponent);

;// ./src/components/TextArea/index.ts


;// ./src/components/Toast/constants.ts
var constants_ANIMATION_DURATION = 600;

;// ./src/components/Toast/Toast.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Toast = ({"toast":"uoJHJ4","neutral":"I_mRGr","negative":"tIXZ0J","positive":"hNPKvJ"});
;// ./src/components/Toast/Toast.transitions.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Toast_transitions = ({"appear":"BB6Inj","appearDone":"s9MChP","enter":"RiHmCW","enterDone":"qGWcPX","exit":"P3VF4u","exitDone":"e0DiqZ","appearActive":"B_7Ukf","spring-in":"Kqg2Pn","springIn":"Kqg2Pn","enterActive":"W1mX2G","exitActive":"vv7s6b","spring-out":"KRn7A9","springOut":"KRn7A9"});
;// ./src/components/Toast/Toast.tsx
function Toast_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Toast_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Toast_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Toast_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Toast_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Toast_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Toast_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Toast_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Toast_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var VARIANTS = (/* unused pure expression or super */ null && ([
    'negative',
    'neutral',
    'positive'
]));
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/toast | Toast} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Toast_Toast = function(_param) {
    var variant = _param.variant, children = _param.children, transitionProps = Toast_object_without_properties(_param, [
        "variant",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_transition_group_namespaceObject.CSSTransition, Toast_object_spread_props(Toast_object_spread({}, transitionProps), {
        timeout: constants_ANIMATION_DURATION,
        classNames: Toast_transitions,
        unmountOnExit: true,
        appear: true,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
            role: "alert",
            className: (0,external_classnames_namespaceObject["default"])(Toast.toast, Toast[variant]),
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                variant: "heading-16",
                color: "kale-3",
                children: children
            })
        })
    }));
};

;// ./src/components/Toast/ToastContext.ts


var ToastContext = (0,external_react_namespaceObject.createContext)({
    dispatchToast: noop_namespaceObject["default"],
    dispatchToastDialog: noop_namespaceObject["default"],
    closeToastDialog: noop_namespaceObject["default"]
});

;// ./src/components/Toast/ToastDialog.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ToastDialog = ({"document":"z6iqjW","message":"dZAqkd"});
;// ./src/components/Toast/ToastDialog.tsx
function ToastDialog_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToastDialog_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToastDialog_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToastDialog_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ToastDialog_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ToastDialog_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ToastDialog_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ToastDialog_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ToastDialog_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var ToastDialog_VARIANTS = (/* unused pure expression or super */ null && ([
    'negative',
    'neutral',
    'positive'
]));
/**
 * A toast that includes a single interaction.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/toast | Toast} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ToastDialog_ToastDialog = function(_param) {
    var /** Style of the toast */ variant = _param.variant, /** Toast content */ message = _param.message, /** Text in the button */ buttonLabel = _param.buttonLabel, /** Button click handler */ onButtonClick = _param.onButtonClick, transitionProps = ToastDialog_object_without_properties(_param, [
        "variant",
        "message",
        "buttonLabel",
        "onButtonClick"
    ]);
    var closeToastDialog = external_react_namespaceObject["default"].useContext(ToastContext).closeToastDialog;
    var labelId = (0,external_react_namespaceObject.useId)();
    var handleClick = function(e) {
        closeToastDialog === null || closeToastDialog === void 0 ? void 0 : closeToastDialog();
        onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(external_react_transition_group_namespaceObject.CSSTransition, ToastDialog_object_spread_props(ToastDialog_object_spread({}, transitionProps), {
        timeout: constants_ANIMATION_DURATION,
        classNames: Toast_transitions,
        unmountOnExit: true,
        appear: true,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
            role: "alertdialog",
            className: (0,external_classnames_namespaceObject["default"])(Toast.toast, Toast[variant]),
            "aria-label": labelId,
            children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("div", {
                role: "document",
                className: ToastDialog.document,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                        variant: "heading-16",
                        color: "kale-3",
                        id: labelId,
                        className: ToastDialog.message,
                        children: message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Button_Button, {
                        asLink: true,
                        variant: "primary",
                        onClick: handleClick,
                        className: ToastDialog.button,
                        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                            variant: "heading-16",
                            bold: true,
                            children: buttonLabel
                        })
                    })
                ]
            })
        })
    }));
};

;// ./src/components/Toast/ToastRenderer.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ToastRenderer = ({"tfd-toast":"kFGAW2","tfdToast":"kFGAW2","container":"je2jkL"});
;// ./src/components/Toast/ToastRenderer.tsx
function ToastRenderer_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToastRenderer_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToastRenderer_define_property(target, key, source[key]);
        });
    }
    return target;
}









var ToastRenderer_ToastRenderer = function() {
    var root = (0,external_react_namespaceObject.useRef)();
    var _useContext = (0,external_react_namespaceObject.useContext)(ToastContext), activeToasts = _useContext.activeToasts, activeToastDialogs = _useContext.activeToastDialogs;
    (0,external_react_namespaceObject.useEffect)(function() {
        root.current = addDOMElementById(ToastRenderer.tfdToast);
    }, []);
    if (!root.current || !activeToastDialogs || !activeToasts) {
        return null;
    }
    return /*#__PURE__*/ external_react_dom_namespaceObject["default"].createPortal(/*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
        className: ToastRenderer.container,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)(external_react_transition_group_namespaceObject.TransitionGroup, {
            component: null,
            children: [
                activeToastDialogs.map(function(toastDialogProps) {
                    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ToastDialog_ToastDialog, ToastRenderer_object_spread({}, toastDialogProps), toastDialogProps.id);
                }),
                activeToasts.map(function(toastProps) {
                    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Toast_Toast, ToastRenderer_object_spread({}, toastProps), toastProps.id);
                })
            ]
        })
    }), root.current);
};

;// external "nanoid/non-secure"
var non_secure_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var non_secure_y = (x) => (() => (x))
const non_secure_namespaceObject = non_secure_x({ ["nanoid"]: () => (__WEBPACK_EXTERNAL_MODULE_nanoid_non_secure_38f76ec4__.nanoid) });
;// ./src/components/Toast/ToastProvider.tsx
function ToastProvider_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ToastProvider_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ToastProvider_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToastProvider_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ToastProvider_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ToastProvider_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToastProvider_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToastProvider_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ToastProvider_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ToastProvider_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ToastProvider_sliced_to_array(arr, i) {
    return ToastProvider_array_with_holes(arr) || ToastProvider_iterable_to_array_limit(arr, i) || ToastProvider_unsupported_iterable_to_array(arr, i) || ToastProvider_non_iterable_rest();
}
function ToastProvider_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ToastProvider_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ToastProvider_array_like_to_array(o, minLen);
}





var TOAST_DURATION = 1000 * 5;
var TIMEOUT = TOAST_DURATION + constants_ANIMATION_DURATION;
function useToastDispatch(toastTimeout) {
    var _useState = ToastProvider_sliced_to_array((0,external_react_namespaceObject.useState)(), 2), active = _useState[0], setActive = _useState[1];
    var _useState1 = ToastProvider_sliced_to_array((0,external_react_namespaceObject.useState)(), 2), queued = _useState1[0], setQueued = _useState1[1];
    var close = function() {
        return setActive(undefined);
    };
    var dispatchToast = (0,external_react_namespaceObject.useCallback)(function(toastProps) {
        var id = (0,non_secure_namespaceObject.nanoid)();
        var newToast = ToastProvider_object_spread_props(ToastProvider_object_spread({}, toastProps), {
            id: id
        });
        if (active || queued) {
            setQueued(newToast);
        } else {
            setActive(newToast);
        }
    }, [
        active,
        queued
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (!active) {
            return;
        }
        var removeToast = function() {
            setActive(undefined);
        };
        var timeout = toastTimeout ? setTimeout(removeToast, toastTimeout) : undefined;
        return function() {
            if (timeout) {
                clearTimeout(timeout);
            }
            removeToast();
        };
    }, [
        active,
        toastTimeout
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (!queued) {
            return;
        }
        setActive(undefined);
        var timeout = setTimeout(function() {
            setQueued(function(currentQueued) {
                setActive(currentQueued);
                return undefined;
            });
        }, constants_ANIMATION_DURATION);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        queued
    ]);
    return [
        dispatchToast,
        active ? [
            active
        ] : [],
        close
    ];
}
var ToastProvider = function(param) {
    var children = param.children;
    var _useToastDispatch = ToastProvider_sliced_to_array(useToastDispatch(TIMEOUT), 2), dispatchToast = _useToastDispatch[0], activeToasts = _useToastDispatch[1];
    var _useToastDispatch1 = ToastProvider_sliced_to_array(useToastDispatch(), 3), dispatchToastDialog = _useToastDispatch1[0], activeToastDialogs = _useToastDispatch1[1], closeToastDialog = _useToastDispatch1[2];
    var toastContextValue = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            dispatchToast: dispatchToast,
            activeToasts: activeToasts,
            dispatchToastDialog: dispatchToastDialog,
            activeToastDialogs: activeToastDialogs,
            closeToastDialog: closeToastDialog
        };
    }, [
        dispatchToast,
        activeToasts,
        dispatchToastDialog,
        activeToastDialogs,
        closeToastDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(ToastContext.Provider, {
        value: toastContextValue,
        children: children
    });
};

;// ./src/components/Toast/useToast.ts


function useToast() {
    var dispatchToast = (0,external_react_namespaceObject.useContext)(ToastContext).dispatchToast;
    return dispatchToast;
}

;// ./src/components/Toast/useToastDialog.ts


function useToastDialog() {
    var dispatchToastDialog = (0,external_react_namespaceObject.useContext)(ToastContext).dispatchToastDialog;
    return dispatchToastDialog;
}

;// ./src/components/Toast/index.ts





;// ./src/components/withTFDProps/getDisplayName.ts
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

;// ./src/components/withTFDProps/withTFDProps.tsx
function withTFDProps_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withTFDProps_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withTFDProps_define_property(target, key, source[key]);
        });
    }
    return target;
}
function withTFDProps_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function withTFDProps_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        withTFDProps_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var withTFDProps = function(WrappedComponent) {
    return function(props) {
        var _props_dataname;
        var dataName = (_props_dataname = props === null || props === void 0 ? void 0 : props['data-name']) !== null && _props_dataname !== void 0 ? _props_dataname : getDisplayName(WrappedComponent);
        return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(WrappedComponent, withTFDProps_object_spread_props(withTFDProps_object_spread({}, props), {
            "data-name": dataName
        }));
    };
};

;// ./src/components/Tooltip/Tooltip.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Tooltip = ({"overlay-wrapper":"EzFG5n","overlayWrapper":"EzFG5n","tooltip-wrapper":"IUpyoD","tooltipWrapper":"IUpyoD","tooltip":"ZOLQRn","light":"QBtlsG","dark":"QPqGtj","tooltip-top":"FTK0Zq","tooltipTop":"FTK0Zq","tooltip-top-left":"N5iEmD","tooltipTopLeft":"N5iEmD","tooltip-top-right":"tif_cs","tooltipTopRight":"tif_cs","tooltip-bottom":"PgfWlq","tooltipBottom":"PgfWlq","tooltip-bottom-left":"hU9Nmc","tooltipBottomLeft":"hU9Nmc","tooltip-bottom-right":"gg73G_","tooltipBottomRight":"gg73G_","tooltip-left":"TK1EaO","tooltipLeft":"TK1EaO","tooltip-left-top":"LQOkuB","tooltipLeftTop":"LQOkuB","tooltip-left-bottom":"FTAb_z","tooltipLeftBottom":"FTAb_z","tooltip-right":"FDGdsz","tooltipRight":"FDGdsz","tooltip-right-top":"obO_p2","tooltipRightTop":"obO_p2","tooltip-right-bottom":"Pg5ZTo","tooltipRightBottom":"Pg5ZTo"});
;// ./src/components/Tooltip/Tooltip.tsx
function Tooltip_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Tooltip_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Tooltip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tooltip_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Tooltip_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Tooltip_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tooltip_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Tooltip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Tooltip_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Tooltip_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Tooltip_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Tooltip_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Tooltip_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Tooltip_sliced_to_array(arr, i) {
    return Tooltip_array_with_holes(arr) || Tooltip_iterable_to_array_limit(arr, i) || Tooltip_unsupported_iterable_to_array(arr, i) || Tooltip_non_iterable_rest();
}
function Tooltip_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Tooltip_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tooltip_array_like_to_array(o, minLen);
}






var TooltipPositions = [
    'top',
    'top-left',
    'top-right',
    'right',
    'right-top',
    'right-bottom',
    'bottom',
    'bottom-left',
    'bottom-right',
    'left',
    'left-top',
    'left-bottom'
];
var TooltipModes = [
    'light',
    'dark'
];
function TooltipComponent(_param) {
    var children = _param.children, position = _param.position, content = _param.content, _param_mode = _param.mode, mode = _param_mode === void 0 ? 'light' : _param_mode, className = _param.className, props = Tooltip_object_without_properties(_param, [
        "children",
        "position",
        "content",
        "mode",
        "className"
    ]);
    var el = external_react_namespaceObject["default"].useRef(null);
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var _React_useState = Tooltip_sliced_to_array(external_react_namespaceObject["default"].useState(true), 2), isHidden = _React_useState[0], setIsHidden = _React_useState[1];
    var hide = function() {
        setIsHidden(true);
    };
    var show = function() {
        setIsHidden(false);
    };
    // Special case - prevent mouseleave hiding tooltip if element in focus using
    // document.contains because child element could have multiple focusable
    // children
    var handleMouseLeave = function() {
        if (el.current && !el.current.contains(document.activeElement)) {
            setIsHidden(true);
        }
    };
    var handleBlur = function() {
        browserOnly(function(window) {
            /** This pushes the hide to the end of the event loop ensuring that on touch
       * devices they can interact with the tooltip content before it hides */ window.setTimeout(hide, 0);
        });
    };
    external_react_namespaceObject["default"].useEffect(function() {
        return browserOnly(function(_, document1) {
            var handleKeyDown = function(e) {
                if (e.key === 'Escape') {
                    setIsHidden(true);
                }
            };
            document1.addEventListener('keydown', handleKeyDown);
            return function() {
                return document1.removeEventListener('keydown', handleKeyDown);
            };
        });
    }, []);
    if (!/*#__PURE__*/ external_react_namespaceObject["default"].isValidElement(children)) {
        throw new Error('Tooltip only accepts a single child as a valid trigger element');
    }
    var triggerElement = /*#__PURE__*/ external_react_namespaceObject["default"].cloneElement(children, {
        'aria-describedby': id,
        onMouseEnter: interceptEvent(children.props.onMouseEnter, show),
        onMouseLeave: interceptEvent(children.props.onMouseLeave, handleMouseLeave),
        onFocus: interceptEvent(children.props.onFocus, show),
        onBlur: interceptEvent(children.props.onBlur, handleBlur),
        // We need to attach onClick to support iOS Safari
        onClick: interceptEvent(children.props.onClick, show)
    });
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsxs)("span", Tooltip_object_spread_props(Tooltip_object_spread({
        className: (0,external_classnames_namespaceObject["default"])(Tooltip.overlayWrapper, className),
        "aria-label": "Toggle tooltip",
        ref: el
    }, props), {
        children: [
            triggerElement,
            /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                className: (0,external_classnames_namespaceObject["default"])(Tooltip.tooltipWrapper, Tooltip["tooltip-".concat(position)]),
                onMouseEnter: show,
                onMouseLeave: hide,
                "aria-hidden": content ? isHidden : true,
                children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("span", {
                    className: (0,external_classnames_namespaceObject["default"])(Tooltip.tooltip, Tooltip[mode]),
                    role: "tooltip",
                    id: id,
                    children: content
                })
            })
        ]
    }));
}
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/tooltip | Tooltip} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Tooltip_Tooltip = withTFDProps(TooltipComponent);

;// ./src/components/Tooltip/index.ts


;// ./src/components/VerticalNavigation/VerticalNavigation.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const VerticalNavigation = ({"container":"ztq9Z1","items":"Bylntm","link":"gW6MfN","active":"b0wct3"});
;// ./src/components/VerticalNavigation/VerticalNavigation.tsx
function VerticalNavigation_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VerticalNavigation_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VerticalNavigation_define_property(target, key, source[key]);
        });
    }
    return target;
}
function VerticalNavigation_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function VerticalNavigation_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        VerticalNavigation_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/**
 *
 * The VerticalNavigation displays information and actions relating to the navigation in a vertical orientation.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/verticalnavigation | VerticalNavigation} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var VerticalNavigation_VerticalNavigation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("nav", {
        role: "navigation",
        className: VerticalNavigation.container,
        children: /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)("div", {
            className: VerticalNavigation.items,
            children: props.items.map(function(item) {
                return /*#__PURE__*/ (0,external_react_namespaceObject.createElement)(Link_Link, VerticalNavigation_object_spread_props(VerticalNavigation_object_spread({}, item), {
                    key: item.title,
                    className: VerticalNavigation.link,
                    activeClassName: VerticalNavigation.active,
                    variant: "secondary",
                    mode: "dark"
                }), /*#__PURE__*/ (0,jsx_runtime_namespaceObject.jsx)(Text_Text, {
                    variant: "heading-16",
                    bold: true,
                    children: item.title
                }));
            })
        })
    });
};

;// ./src/components/VerticalNavigation/index.ts


;// ./src/components/withTFDProps/index.ts


;// ./src/components/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity





































;// ./src/hooks/index.ts






;// external "smoothscroll-polyfill"
var external_smoothscroll_polyfill_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var external_smoothscroll_polyfill_y = (x) => (() => (x))
const external_smoothscroll_polyfill_namespaceObject = external_smoothscroll_polyfill_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_smoothscroll_polyfill_5a6263eb__["default"]) });
;// ./src/util/polyfills.ts

/**
 * Enable native smooth scrolling on browser not supporting it (e.g. IE, Safari)
 * with the [smoothscroll-polyfill](https://github.com/iamdustan/smoothscroll).
 *
 * Polyfills must be enabled on the browser, for example in the app client's
 * entry file or within an effect.
 */ function polyfillSmoothScroll() {
    external_smoothscroll_polyfill_namespaceObject["default"].polyfill();
}

;// ./src/util/accessibility/index.ts



;// ./src/index.ts

// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity










export { Lightbox_ANIMATION_DURATION as ANIMATION_DURATION, AppBar_AppBar as AppBar, AriaLiveAttributes, Arrow, ArticleColors, ArticleFontWeights, ArticleSizeVariants, ArticleSizes, ArticleStyles, ArticleTextVariants, ArticleWeights, Back, Behavior, Blob, BodyColors, BodyFontWeights, BodySizeVariants, BodySizes, BodyStyles, BodyTextVariants, BodyWeights, Bolt, BorderLabel_BorderLabel as BorderLabel, BowlSteaming, Button_Button as Button, ButtonVariants, Calendar, Caret, Carousel_Carousel as Carousel, CarouselItem_CarouselItem as CarouselItem, Carrot, Check, CheckCircle, Checkbox_Checkbox as Checkbox, CheckboxView, Chevron, Circle, CircleAlert, CircleCross, CircleFill, CircleMinus, CirclePlus, Clipboard, Clock, Close, CloseButton_CloseButton as CloseButton, ContentReveal, ContentRevealAnimations, Divider_Divider as Divider, DividerColors, DividerOrientations, Doctor, DogFood, ESCAPE, ElementStates, Facebook, ForkSpoon, FormControl_FormControl as FormControl, Gallery_Gallery as Gallery, GalleryModes, GridContainer_GridContainer as GridContainer, GridContainerBreakpoints, GridContainerHTMLElements, HeadingColors, HeadingFontWeights, HeadingSizeVariants, HeadingSizes, HeadingStyles, HeadingTextVariants, HeadingWeights, Heart, HeartOutline, Hero_Hero as Hero, HoImport, HorizontalNavigation_HorizontalNavigation as HorizontalNavigation, HorizontalNavigationItem_HorizontalNavigationItem as HorizontalNavigationItem, IconPropTypes, IndexButton_IndexButton as IndexButton, Information, Input_Input as Input, InputComponent, LabeledSelector_LabeledSelector as LabeledSelector, Leaf, Lightbox_Lightbox as Lightbox, Link_Link as Link, LinkModes, LinkVariants, ListSelect_ListSelect as ListSelect, ListSelectOption_ListSelectOption as ListSelectOption, ListSelectOptionComponent, LiveMessage_LiveMessage as LiveMessage, Lock, Logo_Logo as Logo, LogoModes, Mail, Minus, Modal_Modal as Modal, Modes, Navigation, PREFERS_REDUCED_MOTION_QUERY, Parcel, Play, Plus, Radio_Radio as Radio, RadioView, Refund, ResponsiveText, ResponsiveTextVariants, RichSelector_RichSelector as RichSelector, RichSelectorGroup_RichSelectorGroup as RichSelectorGroup, Scale, ScrollSnap_ScrollSnap as ScrollSnap, ScrollSnapComponent, Select_Select as Select, Selector_Selector as Selector, SelectorGroup_SelectorGroup as SelectorGroup, Square, SquareFill, StandOnScale, Star, Text_Text as Text, TextArea_TextArea as TextArea, TextAreaComponent, Text_Text as TextV2, TextVariants as TextV2Variants, TextVariants, ToastProvider, ToastRenderer_ToastRenderer as ToastRenderer, Tooltip_Tooltip as Tooltip, TooltipModes, TooltipPositions, Truck, Twitter, Types, Vegetable, VerticalNavigation_VerticalNavigation as VerticalNavigation, article, articleStyles, body, bodyStyles, browserOnly, getButtonDesign_getButtonDesign as getButtonDesign, getCheckboxDesign_getCheckboxDesign as getCheckboxDesign, getLineThroughDesign_getLineThroughDesign as getLineThroughDesign, getLinkDesign_getLinkDesign as getLinkDesign, getModalDesign_getModalDesign as getModalDesign, getNonWaveDesign, getPreferredScrollBehavior, getRadioDesign_getRadioDesign as getRadioDesign, getWaveDesign, heading, headingStyles, isAnchorLink, polyfillSmoothScroll, useElementState, useHtmlElement, useIntersection, useIsomorphicLayoutEffect, useLightboxControl, useSafeOptions, useSlideShow, useToast, useToastDialog, withRef, withTFDProps };

//# sourceMappingURL=index.js.map